import {
    AfterViewInit,
    Component,
    ComponentFactoryResolver,
    ElementRef,
    Inject, Injector,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
    ApplicationRef, Output, EventEmitter, SimpleChanges, OnChanges
} from '@angular/core';
import {ConfService} from '../conf.service';
import {interval, Observable} from 'rxjs';
import {ICategory} from '../crudapi/crudapi.component';
import {FormControl} from '@angular/forms';
import {NgxXml2jsonService} from 'ngx-xml2json';
import {environment} from '../../environments/environment';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {KongService} from '../kong.service';
import {ActivatedRoute} from '@angular/router';
import {HeadersComponent} from '../devex/headers/headers.component';
import {AppComponent} from '../app.component';
import {AuthorizationComponent} from '../authorization/authorization.component';
import {EntityVersionChangeConfirmationComponent} from '../edit-entity/edit-entity.component';
import {ConnecttocrudService} from '../connecttocrud.service';
import {DialogComponent} from '../shared/dialog/dialog.component';
import {Router} from '@angular/router';
import {PartnerOnboardComponent} from '../partner-onboard/partner-onboard.component';
import {ListenerService} from '../listener.service';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {BusinesslogicListenerService} from '../businesslogic-listener.service';
import {Location} from '@angular/common';
import {WebsocketService} from '../websocket.service';
import {ApiCreatorsService} from '../api-creators.service';
import {EmailtemplateService} from '../emailtemplate.service';
import {Subject} from 'rxjs/Subject';
import {AuditListenerService} from '../audit-listener.service';
import {ScrollService} from '../scroll.service';
import {isNamedVariableDeclaration} from '@angular/compiler-cli/src/ngtsc/reflection';
import {TestReportComponent} from '../testsuite/test-report/test-report.component';
import {OpenCodeEditorOnBlock, BlocklyFieldTextbutton, CodeDisplayField, BlocklyFieldImagebutton} from './blockly-code-editor-helper';
import {BlockCodeEditorComponent} from './block-code-editor/block-code-editor.component';
import {saveAs} from 'file-saver';
import {ImportVariablesComponent} from '../accelerators/import-variables/import-variables.component';
import {generatorBlockForAcceleratorVariable} from './accelerator_variable_block_generator';
import {ManageAcceleratorComponent, ManageAcceleratorsComponent} from '../accelerators/manage-accelerator/manage-accelerator.component';
import {BlocklyHeaderButtonsService} from './blockly-header-buttons.service';
import {BusinessLogicDataService} from './business-logic-data.service';
import * as stringSimilarity from 'string-similarity';
import {AccountInfoService} from '../user/account-info.service';
import {AuditLogService} from '../audit-log.service';

const incr = 5;
declare let Blockly;
declare let $;
const JSON5 = require('json5');

interface BlockData {
    block: {};
    functions: any[];
}

@Component({
    selector: 'new-blockly',
    templateUrl: './new-blockly.component.html',
    styleUrls: ['./new-blockly.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class NewBlocklyComponent implements AfterViewInit, OnInit, OnChanges {

    @ViewChild(HeadersComponent) devexHeader: HeadersComponent;

    private _searchbarTimeout;
    private _filterbarTimeout;

    save: boolean;
    workspace: any;
    application: any;
    @Input() executors: any;
    @Input() tempAPIEntities: any;

    attributes: any;
    addTo: any;
    apiConnectors: any;
    attributeList = [];
    properties = {};
    sortedAttributeList = [];
    acceleratorVariablesList = [['Select a variable', 'null']];
    acceleratorConnectorVariablesList = [['Select a connector', 'null']];
    firstOfBody = [];
    addToList = [];
    apiConnectorList = [];
    executorList = [];
    entityName = [];
    blocklyXMLToolbox: any;
    simplifiedJsonForb2b = [];
    executorVersions = [
        {name: 'v1'},
        {name: 'v2'},
        {name: 'v3'},
        {name: 'v4'},
        {name: 'v5'},
        {name: 'v6'},
        {name: 'v7'},
        {name: 'v8'},
        {name: 'v9'},
        {name: 'v10'}
    ];
    authModel = {
        'authType': '',
        'authAttributes': {}
    };
    @ViewChild(AuthorizationComponent) authModel1: AuthorizationComponent;

    blockRefreshLoading = false;

    showDialogOnNonWebsocketConnection: any;

    blocklyLoading = false;

    headers = [];
    queryParams = [];
    requestBody = {};
    prerequisites: any;
    responseAttributes = [];
    @Input() mockResponses = [];
    executorMethods = [
        {name: 'GET'},
        {name: 'POST'},
        {name: 'PUT'},
        {name: 'DELETE'},
        {name: 'PATCH'}
    ];
    blocklyDivSize = 'col-md-12 col-lg-12';
    debugErrorFlag = false;
    debugResult: any;
    debugVariables = [];
    inputSet: any;
    searchText: any;
    results: any;
    debugResults: any;
    isError = false;
    errorClass: string;
    errorMessage: string;
    logText: string;
    errorStackTrace: [];
    executorBlocks: any;
    executorTypes = [
        // {'displayName': 'Simple API', 'value': 'API'},
        {'displayName': 'Business Logic API', 'value': 'BUSINESSLOGIC'},
        // {'displayName': 'Data Access API', 'value': 'DATAACCESS'},
        // {'displayName': 'Third Party API', 'value': 'THIRDPARTY'}
    ];

    scope = [{'displayName': 'Public', 'value': 'public'},
        {'displayName': 'Private', 'value': 'private'}];
    scopeSelected = 'public';
    description: string;
    executorCategory: string;
    @Input() executor_name: string;
    executor_type: string;
    selectedVersion: string;
    selectedExecutor: string;
    currentEntityName: string;
    selectedExecutorType = 'BUSINESSLOGIC';
    executor_display_name: string;
    searchAPI: any;

    customPathParams = [];
    isCustomPath = false;
    isBodyParamEnabled = false;
    bodyParamDescription = [];

    acceleratorVariableName = '';
    acceleratorConnectorName = '';
    gateways = [
        {
            gateway_name: 'default',
            gateway_type: 'kong'
        },
        {
            gateway_name: 'aws gateway',
            gateway_type: 'AWS'
        }
    ];
    selectGateway = 'default';

    databases: any;
    sqlDatabases = [['Select a SQL Database', '']];
    mongodbDatabases = [['Select a MongoDB Database', '']];
    mongodbExecuteQueryName = 'mongodb_query';
    mongoExecuteQueryAttributes = [
        // 'response',
        'response.statusCode',
        'response.body',
        'response._isList',
        // 'response.collection',
        // 'response.match',
        // 'response.sort',
        // 'response.isSuccess',
    ];
    apiResponse: any;
    sqlOperations: any;
    parallel: any;
    filteredOptions: Observable<ICategory[]>;
    myControl = new FormControl();
    destroy: any;
    Blocks = [];
    BlockList = {
        '1': 0,
        '2': 25,
        '3': 50,
        '4': 75,
        '5': 100
    };
    progress = 0;
    progressMessage: string;
    showNextPanel = false;
    @Input() entity: string;
    @Input() version: string;
    @Input() workSpaceId = 'blocklyDiv';
    @Input() partner = localStorage.getItem('partner');

    @Input() apiExecutor: any;
    @Input() isEditComponent = false;
    @Input() isAPIalreadyExists = false;
    @Input() isApiDiscovery = false;

    @Output() blocklyRenderedEdit: EventEmitter<any> = new EventEmitter<any>();
    @Output() saveBlocks: EventEmitter<any> = new EventEmitter<any>();

    partnerKey = localStorage.getItem('partnerKey');
    @Input() account_id = localStorage.getItem('account');
    @Input() retrieveExecutorFromRouteParams = true;
    apiKey = localStorage.getItem('apikey');
    url = environment.konghost;
    servicedata: any;
    routehostdata: any;
    routepathdata: any;
    ratelimitingOrig: any;
    keyauthOrig: any;

    executor: any;
    editFlag = false;
    @Input() showButtons = true;
    debugFlag = false;
    gatewayUrl: any; // = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
    gatewayFullUrl: string; // = 'https://' + this.gatewayUrl;
    blockExecutors: any;

    orig_executor_name: string;
    orig_executor_version: string;

    orig_executor_method_type: string;
    orig_executor_parameters: any;
    orig_executor: any;
    orig_executor_request_body: any;
    orig_executor_authModel: any;

    backupExecutor: any;
    dependencyApis: any;

    loading = false;
    loading1 = false;

    samplesInPartner = false;
    cloneable = false;
    registeredConnectors: any;
    @ViewChild('toolbox') toolbox: ElementRef;
    eventNameForAudit = '';
    eventLabelForAuditLog = '';
    eventNameForAuditLog = '';
    xml_content: any;
    isFromHistory = false;
    historyData: any;
    previousSavedData: any;
    partnerEntities: any;
    partnerExecutors: any;
    isAPIAlreadyPresent: boolean;
    isAPIAlreadyPresentCheckCompleted = false;
    previouslyCheckedName: any;
    previouslyCheckedVersion: any;
    entityNameVersionAfterDeploy = false;
    isToggleExpanded = false;
    executeFlagLocally: boolean;
    historyTimestamp: any;
    businessLogicEdit: boolean;
    logVisible = false;
    refreshLogCount = 0;
    logTimeStamp: any;
    pubSubTopic: any;
    operations = [];
    currentMessage: any;
    apiType = 'BUSINESSLOGIC';
    action: any;
    searchBlocklyText: any;
    blocklyRendered = false;

    blocksBeforeExecution = [];
    blocklyRightPanelButtons = [
        {
            name: 'Test',
            value: 'test-component',
            matIcon: 'assignment_turned_in',
            title: 'Test Your Logic',
            visible: true,
        },
        // {
        //     name: 'Code',
        //     value: 'code-component',
        //     matIcon: 'code',
        //     title: 'Code Preview',
        //     visible: true,
        // },
        {
            name: 'Docs',
            value: 'docs-component',
            matIcon: 'article',
            title: 'Blocks Documentation',
            visible: true,
        },
        {
            name: 'Accelerators',
            value: 'accelerators-component',
            matIcon: 'send_time_extension',
            title: 'Accelerators',
            visible: false,
        },
        {
            name: 'SAIL',
            value: 'sail-component',
            matIcon: 'api',
            title: 'Structured API Integration Language',
            visible: true,
        }

    ];
    visibleDocumentationType = 'block';
    selectedRightPanelComponent = {
        name: '',
        value: '',
        matIcon: '',
        title: ''
    };
    enableDeepDebugLogs = false;
    enableVisualDebugger = true;
    debugging = false;
    selectedBlock: any;

    filteredBlocklyXMLToolbox: any;
    blocklyDocumentation: any;

    blockDescriptions = [];
    apiBlockDescription = [];

    acceleratorsList = [];
    blocksContainsLogColour = false;
    javascriptCode: any;
    pythonCode: any;
    sailCode: any;

    editorOptions = {theme: 'vs-dark', language: 'javascript'};

    testLoading = false;
    testSuiteResponse: any;

    apiGateways: any;

    gatewayControl = new FormControl([]);

    gatewayInputs = [];

    constructor(
        private router: Router,
        private websocketService: WebsocketService,
        private route: ActivatedRoute,
        private cfgSrv: ConfService, private kongService: KongService, private _service: ConnecttocrudService,
        public snackBar: MatSnackBar,
        private appComp: AppComponent,
        public dialog: MatDialog,
        public settingComp: PartnerOnboardComponent,
        private leftPanelDataListener: ListenerService,
        public platform: LeftpanelComponent,
        public accountInfoService: AccountInfoService,
        private auditLog: AuditLogService,
        private businessLogicListenerInstance: BusinesslogicListenerService,
        private auditListenerService: AuditListenerService,
        private location: Location,
        private ngxXml2jsonService: NgxXml2jsonService,
        private apiCreator: ApiCreatorsService,
        private scrollService: ScrollService,
        private resolver: ComponentFactoryResolver,
        private injector: Injector,
        private app: ApplicationRef,
        public blComponentDataService: BusinessLogicDataService,
        public blocklyHeaderButtonService: BlocklyHeaderButtonsService) {


        this.apiCreator.eventCallback$.subscribe(value => {

            if (value.apiName === this.executor_name && value.apiVersion === this.selectedVersion) {
                this.loading1 = false;
                this.closeNonWSDialogBox();
                if (!this.websocketService.isOpen()) {
                    // if (value.result === 'failure') {
                    //     this.displaySnackBarWithWS('Error', 5000, value.message);
                    // } else if (value.result === 'success') {
                    //     this.Blocks = [1, 2, 4, 5];
                    //     const blockLength = this.Blocks.length;
                    //     const blockStart = this.BlockList[this.Blocks[0]];
                    //     const blockEnd = this.BlockList[this.Blocks[blockLength - 1]];
                    //     this.progress = blockStart;
                    //     // this.leftPanelDataListener.changeInLeftPanelDataV2.emit('sql');
                    //
                    //     this.setInterval(blockEnd, true);
                    // }
                    this.logVisible = true;
                    this.refreshLogCount++;
                }
                if (value.result === 'failure') {
                    const errorCode = value.auditPayload ? value.auditPayload.statusCode ? value.auditPayload.statusCode : 400 : 400;
                    const errorMessage = value.auditPayload ? value.auditPayload.message ? value.auditPayload.message : '' : '';
                    Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', errorCode, '', '', errorMessage)).then(response => {
                        this.auditListenerService.auditListener.emit({
                            type: 'auditLog',
                            category: 'isAuditForBusinessLogic',
                            payload: response
                        });
                    });
                } else if (value.result === 'success') {
                    const statusCode = value.auditPayload ? value.auditPayload.statusCode ? value.auditPayload.statusCode : 201 : 201;
                    const message = value.auditPayload ? value.auditPayload.message ? value.auditPayload.message : 'API created' : 'API created';
                    Promise.resolve(this.appComp.generatePayloadForAudit('INFO', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'SUCCESS', '', statusCode, '', '', message)).then(response => {
                        this.auditListenerService.auditListener.emit({
                            type: 'auditLog',
                            category: 'isAuditForBusinessLogic',
                            payload: response
                        });
                    });
                }
            }
        });

    }

    // onGatewayRemoved(topping: string) {
    //     const toppings = this.gatewayControl.value as string[];
    //     this.removeFirst(toppings, topping);
    //     this.gatewayControl.setValue(toppings); // To trigger change detection
    // }
    //
    // private removeFirst<T>(array: T[], toRemove: T): void {
    //     const index = array.indexOf(toRemove);
    //     if (index !== -1) {
    //         array.splice(index, 1);
    //     }
    // }

    afterPermissionsLoaded() {
        this.blocklyRightPanelButtons[this.blocklyRightPanelButtons.findIndex(value => value['value'] === 'test-component')].visible = this.hasTestPermissions();
        this.blocklyRightPanelButtons[this.blocklyRightPanelButtons.findIndex(value => value['value'] === 'accelerators-component')].visible = this.hasAcceleratorPermission('view');
    }

    addAccelerator(accelerators_integration) {
        const dialogRef = this.dialog.open(ManageAcceleratorsComponent, {
            height: 'auto',
            width: '30%',
            data: {
                integrationsData: JSON.parse(JSON.stringify(accelerators_integration)),
                type: 'integration_selector',
                isEdit: true
            }
        });

        dialogRef.afterClosed().subscribe(integration => {
            if (integration) {
                const dialogRef2 = this.dialog.open(ManageAcceleratorComponent, {
                    height: 'auto',
                    width: '80%',
                    data: {
                        accelerator: JSON.parse(JSON.stringify({
                            'title': '',
                            'category': '',
                            'display_name': '',
                            'short_description': '',
                            'description': [],
                            'accelerator_source': {
                                'type': '',
                                'source': Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                                'block_attributes': this.attributeList,
                                'accelerator_variables': []
                            },
                            'executor_name': '',
                            'executor_version': ''
                        })),
                        integration: JSON.parse(JSON.stringify(integration)),
                        currentWorkspace: {
                            source: Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                            attributeList: this.attributeList
                        },
                        isEdit: false
                    }
                });
            }
        });
    }

    addOwnAccelerator() {
        const dialogRef = this.dialog.open(ManageAcceleratorComponent, {
            height: 'auto',
            width: '80%',
            data: {
                accelerator: JSON.parse(JSON.stringify({
                    'title': '',
                    'category': '',
                    'display_name': '',
                    'short_description': '',
                    'description': [],
                    'accelerator_source': {
                        'type': '',
                        'source': Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                        'block_attributes': this.attributeList,
                        'accelerator_variables': []
                    },
                    'executor_name': '',
                    'executor_version': ''
                })),
                isIndividualAccelerator: true,
                currentWorkspace: {
                    source: Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                    attributeList: this.attributeList
                },
                isEdit: false
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.setAcceleratorsData(true);
            }
        });
    }
    editOwnAccelerator(accelerator) {
        const dialogRef = this.dialog.open(ManageAcceleratorComponent, {
            height: 'auto',
            width: '80%',
            data: {
                accelerator: JSON.parse(JSON.stringify(accelerator)),
                isIndividualAccelerator: true,
                currentWorkspace: {
                    source: Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                    attributeList: this.attributeList
                },
                isEdit: true
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.setAcceleratorsData(true);
            }
        });
    }

    editAccelerator(accelerator, integration) {
        const dialogRef = this.dialog.open(ManageAcceleratorComponent, {
            height: 'auto',
            width: '80%',
            data: {
                accelerator: JSON.parse(JSON.stringify(accelerator)),
                integration: JSON.parse(JSON.stringify(integration)),
                currentWorkspace: {
                    source: Blockly.Xml.domToText(Blockly.Xml.workspaceToDom(this.workspace)),
                    attributeList: this.attributeList
                },
                isEdit: true
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.setAcceleratorsData(true);
            }
        });
    }


    removeDuplicates(arr: any) {
        return arr.filter((item,
                           index) => arr.indexOf(item) === index);
    }

    updateAndGetVariables(blockText, origLocalVariables, origConnectorVariables) {
        const xmlDom = Blockly.utils.xml.textToDom(blockText);
        const blockNodes = xmlDom.getElementsByTagName('block');
        const localVariables = [];
        const connectorVariables = [];
        for (const node of blockNodes) {
            if (node.getAttribute('type') === 'accelerator_variables') {
                const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
                const index = origLocalVariables.findIndex(value => value['name'] === fieldValue);
                if (index === -1) {
                    localVariables.push({
                        name: fieldValue,
                        result_block_type: '',
                        description: '',
                        masked: false,
                        required: false,
                        value: ''
                    });
                    // const secondIndex = this.initialLocalVariables.findIndex(value => value['name'] === fieldValue);
                    // if (secondIndex === -1) {
                    //     localVariables.push({
                    //         name: fieldValue,
                    //         result_block_type: '',
                    //         description: '',
                    //         masked: false,
                    //         required: false,
                    //         value: ''
                    //     });
                    // } else {
                    //     // localVariables.push(this.initialLocalVariables[secondIndex]);
                    // }

                } else {
                    localVariables.push(origLocalVariables[index]);
                }
            }

            if (node.getAttribute('type') === 'accelerator_connector_variables') {
                const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
                const index = origConnectorVariables.findIndex(value => value['name'] === fieldValue);

                if (index === -1) {
                    connectorVariables.push({
                        name: fieldValue,
                        result_block_type: '',
                        description: '',
                        masked: false,
                        required: false,
                        value: ''
                    });
                } else {
                    connectorVariables.push(origConnectorVariables[index]);
                }
            }
        }
        return {
            local_variables: this.removeDuplicates(localVariables),
            connector_variables: this.removeDuplicates(connectorVariables)
        };
    }

    importAcceleratorIntoWorkspace(type, blockText, blockAttributes, accelerator_variables, connector_variables, title, dependencies) {
        const updatedVariables = this.updateAndGetVariables(blockText, accelerator_variables, connector_variables);
        accelerator_variables = updatedVariables.local_variables;
        connector_variables = updatedVariables.connector_variables;

        const dialogRef = this.dialog.open(ImportVariablesComponent, {
            height: 'auto',
            width: '70%',
            data: {
                accelerator_variables: accelerator_variables,
                connector_variables: connector_variables,
                integration_title : title,
                serviceProviderDepndencies: (dependencies && dependencies.service_providers) ? dependencies.service_providers : [],
                checkServiceProviders: true
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.subscriptionUpdated) {
                    const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                        maxWidth: '95vw',
                        maxHeight: '60vh',
                    });
                    Promise.resolve(this.renderBlockly('update',
                        {myExecutors: false, b2bExecutors: true, alerts: false, connectors: false, triggers: false})).then(response => {
                        this.appendToDomWithChange(type, blockText, blockAttributes, result.accelerator_variables, result.connector_variables);
                        loaderDialog.close();
                    });
                } else {
                    this.appendToDomWithChange(type, blockText, blockAttributes, result.accelerator_variables, result.connector_variables);
                }

            }
        });
    }

    async appendToDomWithChange(type, blockText, blockAttributes, accelerator_variables, connector_variables) {

        const xmlDom = Blockly.utils.xml.textToDom(blockText);
        const blockNodes = xmlDom.getElementsByTagName('block');

        for (const variable of accelerator_variables) {
            if (variable.isParameter) {
                if (this.queryParams.filter(element => element.key === variable.name).length === 0) {
                    this.queryParams.push({
                        key: variable.name,
                        value: variable.value,
                        description: variable.description
                    });
                }
                variable['result_block_type'] = 'attributes.parameters'
            } else if (variable.isHeader) {
                if (this.headers.filter(element => element.key === variable.name).length === 0) {
                    this.headers.push({
                        key: variable.name,
                        value: variable.value,
                        description: variable.description
                    });
                }
                variable['result_block_type'] = 'attributes.headers'
            } else if (variable.isPayload) {
                variable['result_block_type'] = 'get_a_key_from_payload'
            }
        }
        this.updateAttributes();

        for (const node of blockNodes) {
            if (node.getAttribute('type') === 'accelerator_variables') {
                const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
                const blockData = (accelerator_variables.filter(function (item) {
                    return item.name === fieldValue;
                }).map(function (item) {return item; }))[0];

                await Promise.resolve(generatorBlockForAcceleratorVariable(blockData.result_block_type, blockData.value, blockData.name)).then(response => {
                    const replaceXml = response;
                    node.parentElement.replaceChild(replaceXml, node);
                });
            }

            if (node.getAttribute('type') === 'accelerator_connector_variables') {
                const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
                const blockData = (connector_variables.filter(function (item) {
                    return item.name === fieldValue;
                }).map(function (item) {return item; }))[0];

                await Promise.resolve(generatorBlockForAcceleratorVariable(blockData.result_block_type, blockData.value, blockData.name)).then(response => {
                    const replaceXml = response;
                    node.parentElement.replaceChild(replaceXml, node);
                });
            }
        }

        const xml = Blockly.Xml.domToText(xmlDom);

        this.appendToDom(type, xml, blockAttributes);

    }

    appendToDom(type, blockText, blockAttributes) {
        // let blockText = '<xml xmlns="https://developers.google.com/blockly/xml"><block type="controls_if" id="M*mdV5%.;pmXyT1)D;#H" x="31" y="12"><value name="IF0"><block type="logic_compare" id="N_#aWC70dPRDt)c5%}i`"><field name="OP">EQ</field><value name="A"><block type="math_number" id="3PMLbj9LNl.RqbH$CfWK"><field name="NUM">0</field></block></value><value name="B"><block type="math_number" id="DUx_$y:5-E{i#,6$9@bD"><field name="NUM">0</field></block></value></block></value><statement name="DO0"><block type="text_print" id="UEhJ-mb^MYKDTN=vJW#h"><value name="TEXT"><shadow type="text" id="+n^58n(Tfbg@kKs9J~c0"><field name="TEXT">abc</field></shadow><block type="text" id="a`-,t/|r(eBI)]O%#m2x"><field name="TEXT">Hello</field></block></value></block></statement></block></xml>';

        const that = this;
        const parser = new DOMParser();
        const xml1 = parser.parseFromString(blockText, 'text/xml');
        var xmlNode = xml1.getElementsByTagName('xml');
        if (xmlNode && xmlNode.length > 0) {
            for (var i = 0; i < xmlNode.length; i++) {
                for (var j = 0; j < xmlNode[i].childNodes.length; j++) {
                    var el = xmlNode[i].childNodes[j];
                    if (el.childNodes.length !== 1) {
                        blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + Blockly.Xml.domToText(el) + '</xml>';
                    }
                }
            }
        } else {
            blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + blockText + '</xml>';

        }

        if (blockAttributes && blockAttributes.length > 0) {
            blockAttributes.forEach((attr, index) => {
                if (attr && attr.length === 2) {
                    const row = that.attributeList.findIndex(row => row.includes(attr[0]));
                    if (row === -1) {
                        that.attributeList.push(attr);
                    }
                }
            });
        }

        var xml2 = Blockly.utils.xml.textToDom(blockText);
        Blockly.Xml.appendDomToWorkspace(xml2, this.workspace);
    }

    hasViewPagePermissions() {
        if (this.editFlag === true) {
            if (this.isFromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'EDIT_BUSINESS_LOGIC_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]));
            } else {
                return this.platform.hasPermissions(['EDIT_BUSINESS_LOGIC_API', 'edit:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
            }
        } else {
            if (this.isFromHistory === true) {
                return (this.platform.hasPermissions(['EDIT_HISTORY', 'CREATE_BUSINESS_LOGIC_API']));
            } else {
                return this.platform.hasPlatformPermission('CREATE_BUSINESS_LOGIC_API');
            }
        }
    }

    hasAcceleratorPermission(type) {
        switch (type) {
            case 'view':
                return this.platform.hasPlatformPermission('VIEW_ACCELERATORS');
            case 'edit':
                return this.platform.hasPlatformPermission('EDIT_ACCELERATORS');
            default:
                return false;
        }
    }

    hasTestPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['TEST_BUSINESS_LOGIC_API', 'test:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('TEST_BUSINESS_LOGIC_API');
        }
    }

    hasSavePermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['SAVE_BUSINESS_LOGIC_API', 'save:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('SAVE_BUSINESS_LOGIC_API');
        }
    }

    hasCopyPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['COPY_BUSINESS_LOGIC_API', 'copy:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('COPY_BUSINESS_LOGIC_API');
        }
    }

    hasUpdateParamsPermissions() {
        if (this.editFlag === true) {
            return this.platform.hasPermissions(['UPDATE_PARAMS_BUSINESS_LOGIC_API', 'update_params:' + this.partner + '=>' + this.account_id + '=>' + this.orig_executor_name + '=>' + this.orig_executor_version]);
        } else {
            return this.platform.hasPlatformPermission('UPDATE_PARAMS_BUSINESS_LOGIC_API');
        }
    }

    sleep(ms: number = 0) {
        return new Promise(r => setTimeout(r, ms));
    }

    getAPIExecutor() {
        return new Promise((resolve, reject) => {
            this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                if (data != null) {
                    this.orig_executor = data;
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    getHistory(partner, account, timestamp) {
        return new Promise((resolve, reject) => {
            this.cfgSrv.getData('services', 'services', 'v1', 'apiHistory', 'partner=' + partner + '&account=' + account + '&at=' + timestamp).subscribe(response => {
                if (response && response !== null && response !== undefined && response[0] && response[0]['executor']) {
                    this.entity = response[0]['executor_name'];
                    this.version = response[0]['executor_version'];
                    this.orig_executor_name = response[0]['executor_name'];
                    this.orig_executor_version = response[0]['executor_version'];
                    if (response[0]['action'] === 'CREATE') {
                        this.editFlag = false;
                    } else {
                        this.editFlag = true;
                    }
                    this.isFromHistory = true;
                    this.historyData = response[0]['executor'];
                    this.orig_executor = response[0]['executor'];
                    if (this.loading) {
                        Blockly.mainWorkspace.clear();
                        this.loadExecutor();
                    }
                    resolve('success');
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
            });
        });
    }

    manageProgress(target, showPanel) {
        if (this.progress <= target) {
            // this.showNextPanel = showPanel;
            // this.cfgSrv.getPartner(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(data => {
            //     let item = data;
            // this.kongService.getKeyAuthForConsumerInApiGatewayByNameOrId(item['primary_email']).subscribe(keys => {
            this.save = false;
            let apiKey = localStorage.getItem('apikey');
            const dialogRef = this.dialog.open(DialogComponent, {
                maxWidth: '95vw',
                data: {
                    type: 'bl',
                    save: true,
                    gatewayFullUrl: this.gatewayFullUrl,
                    Blocks: this.Blocks,
                    selectedVersion: this.selectedVersion,
                    showNextPanel: false,
                    partner: this.partner,
                    account: this.account_id,
                    selectedExecutor: this.selectedExecutor,
                    executor_name: this.executor_name,
                    apiKey: apiKey,
                    partnerKey: this.partnerKey
                }
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result === 'create') {
                    await this.router.navigateByUrl('/businesslogic');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (result === 'edit') {
                    this.router.navigateByUrl('/businesslogic/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                } else if (result === 'execute') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion);
                } else if (result === 'devex') {
                    this.router.navigateByUrl('/devex?partner=' + this.partner + '&account=' + this.account_id + '&executor_name=' + this.executor_name + '&executor_version=' + this.selectedVersion + '&showDoc=true');
                }
            });
            // });
            // });
            this.ngOnDestroy();
        } else {
            this.progress = this.progress + incr;
        }
        if (this.progress <= 35) {
            this.progressMessage = 'Setting Up Business Logic API';
        } else if (this.progress > 35 && this.progress <= 70) {
            this.progressMessage = 'Setting Up Database';
        } else if (this.progress > 70) {
            this.progressMessage = 'Deploying into Cloud';
        }
    }

    runTests() {

        this.testLoading = true;
        this.cfgSrv.testAPITestsuiteWithUsages(this.partner, this.account_id, this.partnerKey, {
            executor_name: this.orig_executor.executor_name,
            executor_version: this.orig_executor.executor_version
        }).subscribe(res => {
            this.testLoading = false;
            if (res) {
                this.testSuiteResponse = res;

                if (this.testSuiteResponse['testCaseResults'] !== undefined) {
                    const dialogRef = this.dialog.open(TestReportComponent, {
                        height: '80%',
                        width: '80%',
                        data: {
                            testSuitePayload: {name: this.testSuiteResponse.name},
                            testSuiteResponse: this.testSuiteResponse
                        }
                    });
                } else {
                    this.platform.openSnackBar('Error while testing the API. Please try again after sometime.', 'Error', {
                        duration: 7000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }

        }, error => {
            this.testLoading = false;
            this.platform.handleErrorGracefully(error, 'Error while testing the API. Please try again after sometime.');

        });
    }

    async copyTo() {
        if (this.orig_executor && this.orig_executor !== null && this.orig_executor !== undefined) {
            const metaSchema = JSON.parse(JSON.stringify(this.orig_executor));
            this.platform.copyToPartner(this.orig_executor['executor_name'], this.orig_executor['executor_version'], 'BUSINESSLOGIC', metaSchema);
        }
    }

    async ngAfterViewInit(): Promise<void> {
        this.renderBlockly('new');
    }

    async renderBlockly(action, forceUpdate = {myExecutors: false,
        b2bExecutors: false, alerts: false, connectors: false, triggers: false}) {

        return new Promise((resolve, reject) => {
            if (!this.blocklyLoading) {
                this.blocklyLoading = true;
                const that = this;

                this.blockRefreshLoading = true;

                const promises = [];

                promises.push(this.blComponentDataService.setSubscriptionsBlocksData(action === 'update' && forceUpdate.b2bExecutors));
                promises.push(this.blComponentDataService.setMyAPIsBlocksData(action === 'update' && forceUpdate.myExecutors));
                promises.push(this.blComponentDataService.setAlertsBlocksData(action === 'update' && forceUpdate.alerts));
                promises.push(this.blComponentDataService.setTriggersBlocksData(action === 'update' && forceUpdate.triggers));
                promises.push(this.blComponentDataService.setProvidersConnectosData(action === 'update' && forceUpdate.connectors));
                promises.push(this.blComponentDataService.setDevToolsBlocksData());
                promises.push(this.blComponentDataService.setJSScriptsData());


                // this.blComponentDataService.providerConnectorsData.push(['Select API Connector ', 'null']);

                Promise.all(promises)
                    .then(async (results) => {

                        this.blocklyXMLToolbox =
                            '<category name="Core Logic Builder" expanded="false" colour="210">\n' +
                            '        <category name="Logic" >\n' +
                            '            <block type="controls_if"></block>\n' +
                            '            <block type="logic_compare"></block>\n' +
                            '            <block type="logic_operation"></block>\n' +
                            '            <block type="logic_negate"></block>\n' +
                            '            <block type="logic_boolean"></block>\n' +
                            '            <block type="logic_null"></block>\n' +
                            '            <block type="logic_ternary"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Lists">\n' +
                            '            <block type="lists_create_empty"></block>\n' +
                            '            <block type="lists_create_with"></block>\n' +
                            '            <block type="lists_repeat">\n' +
                            '                <value name="NUM">\n' +
                            '                    <block type="math_number">\n' +
                            '                        <field name="NUM">5</field>\n' +
                            '                    </block>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="lists_length"></block>\n' +
                            '            <block type="lists_isEmpty"></block>\n' +
                            '            <block type="lists_indexOf"></block>\n' +
                            '            <block type="lists_getIndex"></block>\n' +
                            '            <block type="lists_setIndex"></block>\n' +
                            '            <block type="lists_append"></block>\n' +
                            '            <block type="lists_splice"></block>\n' +
                            '            <block type="lists_contains"></block>\n' +
                            '        </category>\n' +
                            '        <category name="JSON">\n' +
                            '            <block type="json_object"></block>\n' +
                            '            <block type="key_value_pair"></block>\n' +
                            '            <block type="get_keys_from_json_object"></block>\n' +
                            '            <block type="get_a_key_from_json_object"></block>\n' +
                            '            <block type="replace_key_in_json"></block>\n' +
                            '            <block type="insert_key_value_pair_in_json"></block>\n' +
                            '            <block type="remove_key_from_json"></block>\n' +
                            '            <block type="parse_json"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Text" >\n' +
                            '            <block type="text"></block>\n' +
                            '            <block type="text_print">\n' +
                            '                <value name="TEXT">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT">abc</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_join"></block>\n' +
                            '            <block type="text_substring_count"></block>\n' +
                            '            <block type="text_get_ascii_code"></block>\n' +
                            '            <block type="text_append">\n' +
                            '                <value name="TEXT">\n' +
                            '                    <shadow type="text"></shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_length">\n' +
                            '                <value name="VALUE">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT">abc</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_isEmpty">\n' +
                            '                <value name="VALUE">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT"></field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_indexOf">\n' +
                            '                <value name="VALUE">\n' +
                            '                    <block type="variables_get">\n' +
                            '                        <field name="VAR">abc</field>\n' +
                            '                    </block>\n' +
                            '                </value>\n' +
                            '                <value name="FIND">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT">abc</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_charAt">\n' +
                            '                <value name="VALUE">\n' +
                            '                    <block type="variables_get">\n' +
                            '                        <field name="VAR">abc</field>\n' +
                            '                    </block>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_getSubstring">\n' +
                            '                <value name="STRING">\n' +
                            '                    <block type="variables_get">\n' +
                            '                        <field name="VAR">abc</field>\n' +
                            '                    </block>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_changeCase">\n' +
                            '                <value name="TEXT">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT">abc</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_random"></block>\n' +
                            '            <block type="text_trim">\n' +
                            '                <value name="TEXT">\n' +
                            '                    <shadow type="text">\n' +
                            '                        <field name="TEXT">abc</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_replace">\n' +
                            '                <value name="TEXT">\n' +
                            '                     </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_split">\n' +
                            '                <value name="TEXT">\n' +
                            '                     </value>\n' +
                            '            </block>\n' +
                            '            <block type="text_decode_base64"></block>\n' +
                            '            <block type="text_decode_zip_content_bytes"></block>\n' +
                            // '            <block type="text_prompt_ext">\n' +
                            // '                <value name="TEXT">\n' +
                            // '                    <shadow type="text">\n' +
                            // '                        <field name="TEXT">abc</field>\n' +
                            // '                    </shadow>\n' +
                            // '                </value>\n' +
                            // '            </block>\n' +
                            '        </category>\n' +
                            '        <category name="Parse" >\n' +
                            '            <block type="parse_boolean"></block>\n' +
                            '            <block type="parse_byte"></block>\n' +
                            '            <block type="parse_character"></block>\n' +
                            '            <block type="parse_date"></block>\n' +
                            '            <block type="parse_double"></block>\n' +
                            '            <block type="parse_float"></block>\n' +
                            '            <block type="parse_int"></block>\n' +
                            '            <block type="parse_long"></block>\n' +
                            '            <block type="parse_short"></block>\n' +
                            '            <block type="parse_string"></block>\n' +
                            '            <block type="parse_timestamp"></block>\n' +
                            '            <block type="parse_datatype"></block>\n' +
                            '            <block type="parse_base64_as_string"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Loops" >\n' +
                            '            <block type="controls_repeat_ext">\n' +
                            '                <value name="TIMES">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">10</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="controls_whileUntil"></block>\n' +
                            '            <block type="controls_for">\n' +
                            '                <value name="FROM">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="TO">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">10</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="BY">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="controls_forEach"></block>\n' +
                            '            <block type="controls_flow_statements"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Math">\n' +
                            '            <block type="math_number"></block>\n' +
                            '            <block type="math_arithmetic">\n' +
                            '                <value name="A">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="B">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_single">\n' +
                            '                <value name="NUM">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">9</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_trig">\n' +
                            '                <value name="NUM">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">45</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_constant"></block>\n' +
                            '            <block type="math_number_property">\n' +
                            '                <value name="NUMBER_TO_CHECK">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">0</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_round">\n' +
                            '                <value name="NUM">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">3.1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_on_list"></block>\n' +
                            '            <block type="math_modulo">\n' +
                            '                <value name="DIVIDEND">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">64</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="DIVISOR">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">10</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_constrain">\n' +
                            '                <value name="VALUE">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">50</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="LOW">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="HIGH">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">100</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_random_int">\n' +
                            '                <value name="FROM">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">1</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '                <value name="TO">\n' +
                            '                    <shadow type="math_number">\n' +
                            '                        <field name="NUM">100</field>\n' +
                            '                    </shadow>\n' +
                            '                </value>\n' +
                            '            </block>\n' +
                            '            <block type="math_random_float"></block>\n' +
                            '        </category>\n' +

                            '        <category name="Code" >\n' +
                            '            <block type="code_executor"></block>\n' +
                            '            <block type="javascript_code_executor"></block>\n' +
                            '            <block type="python_code_executor"></block>\n' +
                            // '            <block type="code_executor_language"></block>\n' +
                            // '            <block type="code_editor"></block>\n' +
                            // '            <block type="code_variables"></block>\n' +
                            '        </category>\n' +

                            '        <category name="Files" >\n' +
                            // '            <block type="connect_workbook"></block>\n' +
                            // '            <block type="read_worksheet_cell"></block>\n' +
                            // '            <block type="write_cell_to_worksheet"></block>\n' +
                            // '            <block type="worksheet_url"></block>\n' +
                            '            <block type="file_size_of"></block>\n' +
                            '            <block type="file_name_of"></block>\n' +
                            '            <block type="file_extension_of"></block>\n' +
                            '            <block type="file_mime_type_of"></block>\n' +
                            '            <block type="read_csv"></block>\n' +
                            // '            <block type="write_csv"></block>\n' +
                            '            <block type="write_csv_block"></block>\n' +
                            '            <block type="read_csv_generic"></block>\n' +
                            '            <block type="write_csv_generic"></block>\n' +
                            '            <block type="read_file_input_bytes"></block>\n' +
                            '            <block type="read_file_as_base64"></block>\n' +
                            // '            <block type="read_file_as_text"></block>\n' +
                            '            <block type="read_content_from_file_url"></block>\n' +
                            '        </category>\n' +
                            '        <category name="PDF Files" >\n' +
                            '            <block type="pdf_file_get_no_of_pages"></block>\n' +
                            '            <block type="pdf_file_split_pages"></block>\n' +
                            // '            <block type="pdf_file_encrypt"></block>\n' +
                            '            <block type="pdf_file_decrypt"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Excel Files" >\n' +
                            '            <block type="xls_to_json"></block>\n' +
                            '            <block type="xlsx_to_json"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Date and Time">\n' +
                            '            <block type="current_timestamp"></block>\n' +
                            '            <block type="current_date"></block>\n' +
                            '            <block type="current_date_with_format"></block>\n' +
                            '            <block type="current_date_time"></block>\n' +
                            '            <block type="current_date_time_with_format"></block>\n' +
                            '            <block type="date_arithmetic"></block>\n' +
                            '            <block type="get_date_attribute"></block>\n' +
                            '            <block type="parse_date_from_string_with_format"></block>\n' +
                            '            <block type="format_date_with_string_formatter"></block>\n' +
                            '            <block type="parse_date_from_string"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Image Processing">\n' +
                            '            <block type="image_blur_with_coordinates"></block>\n' +
                            '            <block type="image_blur_full"></block>\n' +
                            '            <block type="image_get_width"></block>\n' +
                            '            <block type="image_get_height"></block>\n' +
                            '        </category>\n' +
                            '        <category name="Variables" custom="VARIABLE"></category>\n' +
                            '        <category name="Functions" custom="PROCEDURE"></category>\n' +
                            '</category>\n';
                            if (this.blComponentDataService.devToolsBlocksData && this.blComponentDataService.devToolsBlocksData.length > 0) {
                                this.blocklyXMLToolbox = this.blocklyXMLToolbox + '    <category name="Dev Tools" expanded="false" colour="230">';
                                    for (const val of this.blComponentDataService.devToolsBlocksData) {
                                        if (val && val.category && val.blocks) {
                                            this.blocklyXMLToolbox = this.blocklyXMLToolbox + '       <category name="' + val.category + '">';
                                                for (const itemBlock of val.blocks) {
                                                    if (itemBlock && itemBlock.name) {
                                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '            <block type="' + itemBlock.name + '"></block>\n';
                                                    }
                                                }
                                            this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
                                        }
                                        }
                                this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
                            }



                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '    <category name="API Builder" expanded="false" colour="230">' +
                            '       <category name="API Authorization">';
                        if (this.blComponentDataService.authorizationTypesData) {
                            this.blComponentDataService.authorizationTypesData.forEach(authBlock => {
                                this.blocklyXMLToolbox = this.blocklyXMLToolbox + '           <block type="' + authBlock.name + '"></block>\n';
                            });
                        }

                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '       </category>\n' +
                            '        <category name="API Execution">\n' +
                            '            <block type="execute_api"></block>\n' +
                            '            <block type="pass_parameters_to_api_executor"></block>\n' +
                            '            <block type="parallel_execution"></block>\n' +
                            '            <block type="parallel_execution_with_foreach_no_wait"></block>\n' +
                            '            <block type="parallel_execution_with_foreach_wait_until"></block>\n' +
                            '        </category>\n' +
                            '       <category name="API Return" custom="APIRESPONSE"></category>\n' +
                            '    <category name="API Attributes" custom="ATTRIBUTE_PALETTE"></category>\n' +
                            '    <category name="API Payload">\n' +
                            '          <block type="form_data"></block>\n' +
                            '          <block type="form_data_pair"></block>\n' +
                            '    </category>\n' +
                            '    <category name="Alerts and Triggers">\n' +
                            '          <block type="alert"></block>\n' +
                            '          <block type="trigger"></block>\n' +
                            '    </category>\n';


                        if (this.hasAcceleratorPermission('edit')) {
                            this.blocklyXMLToolbox += '        <category name="Accelerator Attributes">\n' +
                                '            <block type="accelerator_variables"></block>\n' +
                                '            <block type="accelerator_connector_variables"></block>\n' +
                                '        </category>\n';

                        }

                        this.blocklyXMLToolbox += '    <category name="API Connectors" custom="API_CONNECTORS"></category>\n' +
                            '    <category name="Add Authorization To" custom="ADDTO_PALETTE"></category>\n' +
                            '    </category>\n' +
                            '    <category name="Database Operations" custom="SQLOPERATIONS"></category>\n'; // SQLOPERATIONS is the older name. Haven't renamed to a general name for all databases




                        if ((this.blComponentDataService.myAPIsBlocksData && this.blComponentDataService.myAPIsBlocksData !== null && this.blComponentDataService.myAPIsBlocksData !== undefined && this.blComponentDataService.myAPIsBlocksData.length > 0) || (this.tempAPIEntities && this.tempAPIEntities.length > 0)) {
                            this.blocklyXMLToolbox += '<category name="My APIs" expanded="false" colour="300">';


                            this.blComponentDataService.myAPIsBlocksData.forEach((item) => {
                                if (item && item['executors'] && item['executors'] !== null && item['executors'] !== undefined) {
                                    item.executors.forEach((executor) => {
                                        if (executor && executor !== null && executor !== undefined && executor['executor_category'] && executor['executor_version'] && executor['executor_category'] !== null && executor['executor_category'] !== undefined && executor['executor_version'] !== null && executor['executor_version'] !== undefined) {
                                            const apiName = executor['executor_category'] + '_' + executor['executor_version'];
                                            if (this.entityName.includes(apiName) === false) {
                                                this.entityName.push(apiName);
                                            }
                                        }
                                    });
                                }
                            });

                            this.entityName.sort();
                            if (this.entityName && this.entityName !== undefined && this.entityName !== null) {
                                this.entityName.forEach((entity) => {
                                    if (entity && entity !== undefined && entity !== null) {
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '<category name="' + entity + '">';
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + this.loadExecutorBlockBasedOnEntity(entity);
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
                                    }
                                });
                            }

                            if (this.tempAPIEntities) {
                                for (const item of this.tempAPIEntities) {
                                    const tempExecutors = [];
                                    if (!item.isAvailable) {
                                        for (const method of item.entity.methods) {
                                            tempExecutors.push({
                                                executor_name: method.toLowerCase() + item.entity.entityname,
                                                executor_version: item.entity.version,
                                                executor_method_type: method,
                                                executor_type: 'API'
                                            })
                                        }
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '<category name="' + item.entity.entityname + ' (temp)">';
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + this.setTempBlocks(tempExecutors);
                                        this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
                                    }
                                }
                            }

                            this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</category>';
                        }

                        if (this.blComponentDataService.b2bServiceProviderAPIs && this.blComponentDataService.b2bServiceProviderAPIs !== undefined && this.blComponentDataService.b2bServiceProviderAPIs !== null && this.blComponentDataService.b2bServiceProviderAPIs.length > 0) {
                            this.blocklyXMLToolbox += '<category name="My Subscriptions" expanded="false" colour="300">';
                            this.blComponentDataService.b2bServiceProviderAPIs.forEach((b2b) => {

                                if (b2b && b2b.serviceProvider && b2b.serviceProvider !== null && b2b.serviceProvider !== undefined && b2b.serviceProvider !== '') {
                                    this.blocklyXMLToolbox += '<category name="' + b2b.serviceProvider + '" expanded="false" colour="350">';
                                    b2b.categories.forEach((category) => {
                                        if (category && category.category && category.category !== null && category.category !== undefined) {
                                            this.blocklyXMLToolbox += '<category name="' + category.category + '">';
                                            category.executors.forEach((executor) => {
                                                if (executor && executor.executor_category && executor.executor_category !== null
                                                    && executor.executor_category !== undefined && executor.executor_category !== '') {
                                                    const temp = (executor.executor_category_group !== null ? executor.executor_category_group + '>' : '') + executor.executor_category;
                                                    this.blocklyXMLToolbox += this.loadb2bExecutorBlockBasedOnEntity(temp, executor, category);
                                                }
                                            });
                                            this.blocklyXMLToolbox += '</category>';
                                        }
                                    });
                                    this.blocklyXMLToolbox += '</category>';
                                }
                            });
                            this.blocklyXMLToolbox += '</category>';
                        }

                        if (this.blComponentDataService.myServiceProviderAPIs && this.blComponentDataService.myServiceProviderAPIs !== undefined && this.blComponentDataService.myServiceProviderAPIs !== null && this.blComponentDataService.myServiceProviderAPIs.length > 0) {
                            this.blocklyXMLToolbox += '<category name="My Service Providers" expanded="false" colour="300">';
                            this.blComponentDataService.myServiceProviderAPIs.forEach((myProvider) => {
                                if (myProvider && myProvider.serviceProvider && myProvider.serviceProvider !== null && myProvider.serviceProvider !== undefined && myProvider.serviceProvider !== '') {
                                    this.blocklyXMLToolbox += '<category name="' + myProvider.serviceProvider + '" expanded="false" colour="350">';
                                    myProvider.categories.forEach((category) => {
                                        if (category && category.category && category.category !== null && category.category !== undefined) {
                                            this.blocklyXMLToolbox += '<category name="' + category.category + '">';
                                            category.executors.forEach((executor) => {
                                                if (executor && executor.executor_category && executor.executor_category !== null
                                                    && executor.executor_category !== undefined && executor.executor_category !== '') {
                                                    const temp = (executor.executor_category_group !== null ? executor.executor_category_group + '>' : '') + executor.executor_category;
                                                    this.blocklyXMLToolbox += this.loadMyServiceProvidersExecutorBlockBasedOnEntity(temp, executor, category);
                                                } else {
                                                    executor.executor_category_group = 'temp';
                                                    const temp = executor.executor_category_group + '>' + executor.executor_category;
                                                    this.blocklyXMLToolbox += this.loadMyServiceProvidersExecutorBlockBasedOnEntity(temp, executor, category);
                                                }
                                            });
                                            this.blocklyXMLToolbox += '</category>';
                                        }
                                    });
                                    this.blocklyXMLToolbox += '</category>';
                                }
                            });
                            this.blocklyXMLToolbox += '</category>';
                        }

                        // this.blocklyXMLToolbox = this.blocklyXMLToolbox + '</xml>';

                        this.blockRefreshLoading = false;
                        if (document.getElementById(this.workSpaceId)) {
                            that.setUpBlockly(action);
                        } else {
                            const observer = new MutationObserver((mutations, obs) => {
                                const blocklyDiv = document.getElementById(this.workSpaceId);
                                if (blocklyDiv) {
                                    obs.disconnect();
                                    that.setUpBlockly(action);
                                    return;
                                }
                            });
                            observer.observe(document, {
                                childList: true,
                                subtree: true
                            });
                        }
                        this.blocklyLoading = false;

                        resolve('success');
                    });

            } else {
                resolve('success');
            }
        });
    }

    collapseToolboxCategories(workspace) {
        const toolboxCategories = workspace.getToolbox().getToolboxItems()
            .filter(category => category instanceof Blockly.CollapsibleToolboxCategory);

        toolboxCategories.forEach((category: any) => {
            category.setExpanded(false);
        });
    }

    convertBlockToSaveInfo(block) {
        const xmlDom = Blockly.Xml.blockToDomWithXY(block);
        const rootBlockElement = xmlDom;
        const nextElements = xmlDom.getElementsByTagName('next');
        for (let i = nextElements.length - 1; i >= 0; i--) {
            const nextElement = nextElements[i];
            if (nextElement.parentElement === rootBlockElement) {
                nextElement.parentNode.removeChild(nextElement);
            }
        }
        const xmlString = new XMLSerializer().serializeToString(xmlDom);
        return {
            saveInfo: xmlString,
            typeCounts: Blockly.common.getBlockTypeCounts(block, true),
        };
    }

    async getSaveInfoFromNavigator() {
        const copiedData = await navigator.clipboard.readText();
        try {
            return JSON.parse(atob(copiedData));
        } catch (e) {
            return null;
        }
    }

    setUpBlockly(action) {
        const that = this;

        if (action === 'new') {
            this.workspace = Blockly.inject(this.workSpaceId, {
                toolbox: '<xml>' + this.blocklyXMLToolbox + '</xml>',
                zoom: {
                    controls: true,
                    wheel: false,
                    startScale: 1.0,
                    maxScale: 3,
                    minScale: 0.3,
                    scaleSpeed: 1.2,
                    pinch: true
                },
                move: {
                    scrollbars: {
                        horizontal: true,
                        vertical: true
                    },
                    drag: true,
                    wheel: true
                },
                // plugins: {
                //     'toolbox': BlocklyToolboxSearch
                // },
            });

            if (Blockly.ContextMenuRegistry.registry.getItem('blockCopyToExternal')) {
                Blockly.ContextMenuRegistry.registry.unregister('blockCopyToExternal');
            }
            const copyToStorageOption = {
                displayText: function () {
                    return 'Copy';
                },
                preconditionFn: function (scope) {
                    if (
                        Blockly.getSelected().isDeletable() &&
                        Blockly.getSelected().isMovable()) {
                        return 'enabled';
                    }
                    return 'disabled';
                },
                callback: function (scope) {
                    const blockText = btoa(JSON.stringify(
                        that.convertBlockToSaveInfo(scope.block)));
                    navigator.clipboard.writeText(blockText);
                },
                scopeType: Blockly.ContextMenuRegistry.ScopeType.BLOCK,
                id: 'blockCopyToExternal',
                weight: 0,
            };
            Blockly.ContextMenuRegistry.registry.register(copyToStorageOption);

            if (Blockly.ContextMenuRegistry.registry.getItem('blockPasteFromExternal')) {
                Blockly.ContextMenuRegistry.registry.unregister('blockPasteFromExternal');
            }
            const pasteFromStorageOption = {
                displayText: function () {
                    return 'Paste';
                },
                preconditionFn: function (scope) {
                    // const copyData = JSON.parse(atob(navigator.clipboard.readText()));
                    // if (copyData &&
                    //     scope.workspace.isCapacityAvailable(copyData.typeCounts)) {
                    //     return 'enabled';
                    // }
                    // return 'disabled';

                    // setting this to enabled because navigator.clipboard.readText is a promise and preconditionFn cannot be async
                    return 'enabled';
                },
                callback: function (scope) {
                    Promise.resolve(that.getSaveInfoFromNavigator()).then(resp => {
                        let saveInfo: any;
                        saveInfo = resp;
                        try {
                            if (saveInfo && saveInfo['saveInfo'] && saveInfo['typeCounts']) {
                                if (scope.workspace.isCapacityAvailable(saveInfo.typeCounts)) {
                                    that.appendToDom('xml', saveInfo['saveInfo'], []);
                                } else {
                                    that.platform.openSnackBar('Error while importing the blocks: Invalid blocks found', 'Error', {
                                        duration: 5000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                }
                            }
                        } catch (e) {
                            that.platform.openSnackBar('Error while importing the blocks: ' + e.message, 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    }, error => {});
                },
                scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
                id: 'blockPasteFromExternal',
                weight: 0,
            };
            Blockly.ContextMenuRegistry.registry.register(pasteFromStorageOption);

            // manually collapsing all categories (because in blockly 9 the toolbox automatically opens in expanded way
            this.collapseToolboxCategories(this.workspace);

            this.blocklyRenderedEdit.emit(true);

            Blockly.Generator.prototype.workspaceToCode = function (workspace) {
                if (!workspace) {
                    // Backwards compatibility from before there could be multiple workspaces.
                    console.warn('No workspace specified in workspaceToCode call.  Guessing.');
                    workspace = Blockly.getMainWorkspace();
                }
                let code: any;
                code = [];
                this.init(workspace);
                var blocks = workspace.getTopBlocks(true);
                for (var i = 0, block; (block = blocks[i]); i++) {
                    var line = this.blockToCode(block);
                    if (Array.isArray(line)) {
                        // Value blocks return tuples of code and operator order.
                        // Top-level blocks don't care about operator order.
                        line = line[0];
                    }
                    if (line) {
                        if (block.outputConnection) {
                            // This block is a naked value.  Ask the language's code generator if
                            // it wants to append a semicolon, or something.
                            line = this.scrubNakedValue(line);
                            if (this.STATEMENT_PREFIX && !block.suppressPrefixSuffix) {
                                line = this.injectId(this.STATEMENT_PREFIX, block) + line;
                            }
                            if (this.STATEMENT_SUFFIX && !block.suppressPrefixSuffix) {
                                line = line + this.injectId(this.STATEMENT_SUFFIX, block);
                            }
                        }
                        code.push(line);
                    }
                }

                code = 'def ' + ((that.executor_name && that.selectedVersion && that.executor_name !== '' &&
                    that.selectedVersion !== '') ? (that.executor_name + '_' + that.selectedVersion) : 'business_logic') + '():\n' +
                    Blockly.Python.INDENT + code.join('\n').replace(/\n/g, '\n' + Blockly.Python.INDENT);// Blank line between each section.
                code = this.finish(code);
                // Final scrubbing of whitespace.
                code = code.replace(/^\s+\n/, '');
                code = code.replace(/\n\s+$/, '\n');
                code = code.replace(/[ \t]+\n/g, '\n');
                return code;
            };

            Blockly.Python.finish = function (code) {
                // Convert the definitions dictionary into a list.
                var imports = [];
                var definitions = [];
                for (var name in Blockly.Python.definitions_) {
                    var def = Blockly.Python.definitions_[name];
                    if (def.match(/^(from\s+\S+\s+)?import\s+\S+/)) {
                        imports.push(def);
                    } else {
                        definitions.push(def);
                    }
                }
                // Clean up temporary data.
                delete Blockly.Python.definitions_;
                delete Blockly.Python.functionNames_;
                Blockly.Python.nameDB_.reset();
                var allDefs = imports.join('\n') + '\n\n' + definitions.join('\n\n');
                return allDefs.replace(/\n\n+/g, '\n\n').replace(/\n*$/, '\n\n\n') + code;
            };

            this.filteredBlocklyXMLToolbox = this.blocklyXMLToolbox;
            const searchEnabled = true;

            if (this.workspace) {
                const toolbox = this.workspace.getToolbox();
                if (toolbox) {
                    if (!this._searchbarInput && searchEnabled) {
                        const searchInput = document.createElement('input');
                        searchInput.placeholder = 'Search Blocks';
                        searchInput.className = 'blockly-toolbox-search';
                        searchInput.size = 1;
                        searchInput.addEventListener('keyup', this._searchBlocks.bind(this));

                        const filterInput = document.createElement('input');
                        filterInput.placeholder = 'Filter Blocks';
                        filterInput.className = 'blockly-toolbox-filter';
                        filterInput.size = 1;
                        filterInput.addEventListener('keyup', this._filterBlocks.bind(this));

                        // const refreshIcon = document.createElement('button');
                        // refreshIcon.className = 'blockly-refresh fa fa-refresh';
                        // refreshIcon.addEventListener('click', this._refreshBlocks.bind(this));


                        const factory = this.resolver.resolveComponentFactory(BlocklyAddButtonsComponent);

                        const refreshComponent = document.createElement('div');
                        refreshComponent.id = 'blockly-first-row-buttons';
                        this.setUpBlocklyButtons();

                        toolbox.HtmlDiv.firstChild.classList.add('toolbar');
                        toolbox.HtmlDiv.insertBefore(filterInput, toolbox.HtmlDiv.firstChild);
                        toolbox.HtmlDiv.insertBefore(searchInput, toolbox.HtmlDiv.firstChild);
                        toolbox.HtmlDiv.insertBefore(refreshComponent, toolbox.HtmlDiv.firstChild);

                        const ref = factory.create(this.injector, [], refreshComponent);
                        this.app.attachView(ref.hostView);
                    } else if (this._searchbarInput && !searchEnabled) {
                        toolbox.HtmlDiv.removeChild(this._searchbarInput);
                        toolbox.HtmlDiv.firstChild.classList.remove('toolbar');
                    }
                }
            }

            const onWorkspaceChange = (event) => {

                if (Blockly.getSelected()) {
                    that.selectedBlock = Blockly.getSelected();

                    if (that.selectedRightPanelComponent.value === 'docs-component') {
                        that.scrollToDocId(that.selectedBlock.type);
                    }
                }
                if (event.type === Blockly.Events.BLOCK_CREATE) {
                    const blockObjects = that.workspace.getAllBlocks(true);
                    Blockly.Events.setRecordUndo(false);
                    for (const block of blockObjects) {
                        if (!block.rendered) {
                            block.dispose();
                        }
                    }
                    setTimeout(() => {
                        Blockly.Events.setRecordUndo(true);
                    }, 100);
                }

                if (event.type === Blockly.Events.BLOCK_CHANGE ||
                    event.type === Blockly.Events.BLOCK_CREATE ||
                    event.type === Blockly.Events.BLOCK_DELETE) {
                    if (that.blocksContainsLogColour) {
                        that.restoreBlocks();
                    }
                }

                // try {
                //     if (that.workspace) {
                //         that.javascriptCode = Blockly.JavaScript.workspaceToCode(that.workspace);
                //     }
                // } catch (err) {
                //
                // }

                if (that.workspace) {
                    that.pythonCode = Blockly.Python.workspaceToCode(that.workspace);
                }
            };

            this.workspace.addChangeListener(onWorkspaceChange);
            this.finishBlocklySetup();
        } else {
            const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
            this.workspace.updateToolbox('<xml style="display: none;">' + (this.blocklyXMLToolbox) + '</xml>');
            this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
            this.finishBlocklySetup();
        }
    }

    setUpBlocklyButtons() {
        this.blocklyHeaderButtonService.autoSuggestKeyListener.subscribe(
            (eventObject) => {
                const flyout = this.workspace.getFlyout();
                if (flyout) {
                    flyout.hide();
                }
            });
        this.blocklyHeaderButtonService.refreshListener.subscribe(
            (eventObject) => {
                const possibleActions = ['refresh-blocks', 'add-api-block', 'request-new-block'];
                if (eventObject && eventObject.clickedButton && possibleActions.includes(eventObject.clickedButton)) {
                    if (eventObject.clickedButton === 'refresh-blocks') {
                        if (!this.blockRefreshLoading) {
                            this.renderBlockly('update', {myExecutors: true,
                                b2bExecutors: true,
                                alerts: true,
                                connectors: true,
                                triggers: true});
                        }
                    } else if (eventObject.clickedButton === 'add-api-block') {
                        this.addNewAPIBlock();
                    } else if (eventObject.clickedButton === 'request-new-block') {
                        this.requestAPIBlock();
                    }
                }
            });
    }

    scrollToDocId(blockType: string) {
        const id = 'docs_' + blockType;
        if (this.scrollService.elementByIdExists(id)) {
            this.scrollService.scrollToElementById(id);
        } else {
            let descriptionFound = false;
            for (const category of Object.keys(this.blComponentDataService.blockDescriptionCategories)) {
                if (this.blComponentDataService.blockDescriptionCategories[category].filter(x => x.block_type === blockType).length !== 0) {
                    descriptionFound = true;
                    // this.blockDescriptions = this.blComponentDataService.blockDescriptionCategories[category];
                    this.blockDescriptions = this.blComponentDataService.blockDescriptionCategories[category].filter(x => x.block_type === blockType)
                }
            }
            if (descriptionFound) {
                this.visibleDocumentationType = 'block';
                setTimeout(() => {
                    this.scrollService.scrollToElementById(id);
                }, 300);
            } else {
                const executorDescriptionSet = this.setAPIExecutorDocumentationByBlock(blockType);
                if (!executorDescriptionSet) {
                    if (!this.blComponentDataService.blockDescriptionCategories['notavailable']) {
                        this.blComponentDataService.blockDescriptionCategories['notavailable'] = [];
                    }

                    this.blComponentDataService.blockDescriptionCategories['notavailable'] = [];
                    this.blComponentDataService.blockDescriptionCategories['notavailable'].push({
                        block_type: blockType,
                        display_name: blockType,
                        description: [
                            {
                                type: 'block_type',
                                content: blockType
                            },
                            {
                                type: 'html',
                                content: '<p class="doc-dne">The Documentation for this block is not available yet. </p>'
                            }
                        ]
                    });
                    this.blockDescriptions = this.blComponentDataService.blockDescriptionCategories['notavailable'];
                    setTimeout(() => {
                        this.scrollService.scrollToElementById(id);
                    }, 300);
                } else {
                    this.visibleDocumentationType = 'api';
                }
            }
        }
    }

    private flatten(arr) {
        const that = this;
        return arr.reduce(function (flat, toFlatten) {
            return flat.concat(Array.isArray(toFlatten) ? that.flatten(toFlatten) : toFlatten);
        }, []);
    }

    setAPIExecutorDocumentationByBlock(blockType) {
        let executor: any;
        if (this.blComponentDataService.myAPIsBlocksData && this.blComponentDataService.myAPIsBlocksData.length > 0 && this.blComponentDataService.myAPIsBlocksData[0].executors) {
            const executorFilter = this.flatten(this.blComponentDataService.myAPIsBlocksData.map(k => k.executors.filter(x => x.executor_type + '_' + x.executor_name + '_' + x.executor_version === blockType)).filter(({length}) => length));
            if (executorFilter.length > 0) {
                executor = executorFilter[0];
            } else {
                if (this.blComponentDataService.b2bServiceProviderAPIs && this.blComponentDataService.b2bServiceProviderAPIs.length > 0 && this.blComponentDataService.b2bServiceProviderAPIs[0].categories && this.blComponentDataService.b2bServiceProviderAPIs[0].categories.length > 0 && this.blComponentDataService.b2bServiceProviderAPIs[0].categories[0].executors) {
                    const serviceProvidersFilter = this.flatten(this.blComponentDataService.b2bServiceProviderAPIs.map(k => this.flatten(k.categories.map(m => m.executors.filter(x => x.executor_type + '_' + x.executor_name + '_' + x.executor_version === blockType)))).filter(({length}) => length));
                    if (serviceProvidersFilter.length > 0) {
                        executor = serviceProvidersFilter[0];
                    }
                }
                if (executor === undefined || executor === null) {
                    if (this.blComponentDataService.myServiceProviderAPIs && this.blComponentDataService.myServiceProviderAPIs.length > 0 && this.blComponentDataService.myServiceProviderAPIs[0].categories && this.blComponentDataService.myServiceProviderAPIs[0].categories.length > 0 && this.blComponentDataService.myServiceProviderAPIs[0].categories[0].executors) {
                        const myProvidersFilter = this.flatten(this.blComponentDataService.myServiceProviderAPIs.map(k => this.flatten(k.categories.map(m => m.executors.filter(x => x.executor_type + '_' + x.executor_name + '_' + x.executor_version === blockType)))).filter(({length}) => length));
                        if (myProvidersFilter.length > 0) {
                            executor = myProvidersFilter[0];
                        }
                    }
                }
            }
        }
        if (executor) {
            this.apiBlockDescription = [{
                block_type: executor.executor_type + '_' + executor.executor_name + '_' + executor.executor_version,
                display_name: executor.executor_name + ' (' + executor.executor_version + ')',
                description: [
                    {
                        type: 'block_type',
                        content: executor.executor_type + '_' + executor.executor_name + '_' + executor.executor_version
                    },
                    {
                        type: 'executor',
                        content: executor
                    }
                ]
            }];
            return true;
        } else {
            return false;
        }
    }

    searchBlocksInWorkspaceToolbox(type) {
        const parentElements = [];
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString('<xml style="display: none;">' + this.filteredBlocklyXMLToolbox + '</xml>', 'text/xml');
        const xmlBlocks = xmlDoc.getElementsByTagName('block');
        const xmlCategories = xmlDoc.getElementsByTagName('category');
        let newBlocklyXMLToolBox = '<category name="Search" colour="#ccc">';
        // for (let i = 0; i < xmlCategories.length; i++) {
        //     if (xmlCategories[i].getAttribute('name').toLowerCase().includes(type.toLowerCase()) && !parentElements.includes(xmlCategories[i].outerHTML)) {
        //         newBlocklyXMLToolBox += xmlCategories[i].outerHTML;
        //         parentElements.push(xmlCategories[i].outerHTML);
        //     }
        // }
        let count = 0;
        if (xmlBlocks.length) {
            for (let i = 0; i < xmlBlocks.length; i++) {
                if (xmlBlocks[i].getAttribute('type').toLowerCase().includes(type.toLowerCase()) && !parentElements.includes(xmlBlocks[i].parentElement.outerHTML)) {
                    newBlocklyXMLToolBox += xmlBlocks[i].outerHTML;
                    parentElements.push(xmlBlocks[i].outerHTML);
                    count++;
                    if (count >= 20) {
                        break;
                    }
                }
            }
        }

        newBlocklyXMLToolBox += '\n</category>';

        return newBlocklyXMLToolBox;
    }

    getCategoryStatesForWorkspace(workspace) {
        const categoryStates = {};

        if (workspace) {
            const toolboxCategories = workspace.getToolbox().getToolboxItems()
                .filter(category => category instanceof Blockly.CollapsibleToolboxCategory);

            for (let i = 0; i < toolboxCategories.length; i++) {
                if (toolboxCategories[i] instanceof Blockly.CollapsibleToolboxCategory) {
                    categoryStates[toolboxCategories[i].getName()] = toolboxCategories[i].isExpanded();
                }
            }
        }
        return categoryStates;
    }

    restoreCategoryStatesForWorkspace(workspace, categoryStates) {

        if (workspace) {
            const toolboxCategories = workspace.getToolbox().getToolboxItems()
                .filter(category => category instanceof Blockly.CollapsibleToolboxCategory);
            for (let i = 0; i < toolboxCategories.length; i++) {
                if (toolboxCategories[i] instanceof Blockly.CollapsibleToolboxCategory) {
                    toolboxCategories[i].setExpanded(categoryStates[toolboxCategories[i].getName()]);
                }
            }
        }
    }

    private _searchBlocks(event) {
        clearTimeout(this._searchbarTimeout);
        if (this.workspace) {
            const toolbox = this.workspace.getToolbox();
            if (toolbox) {
                this._searchbarTimeout = setTimeout(() => {
                    if (event.target.value && event.target.value !== '') {
                        const blocks = this.searchBlocksInWorkspaceToolbox(event.target.value);
                        if (blocks) {
                            const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
                            this.workspace.updateToolbox('<xml style="display: none;">' + blocks + this.filteredBlocklyXMLToolbox + '</xml>');
                            this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
                            toolbox.selectItemByPosition(0);
                        } else {
                            const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
                            this.workspace.updateToolbox('<xml style="display: none;">' + this.filteredBlocklyXMLToolbox + '</xml>');
                            this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
                            const flyout = this.workspace.getFlyout();
                            if (flyout) {
                                flyout.hide();
                            }
                        }
                    } else {
                        const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
                        this.workspace.updateToolbox('<xml style="display: none;">' + this.filteredBlocklyXMLToolbox + '</xml>');
                        this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
                        const flyout = this.workspace.getFlyout();
                        if (flyout) {
                            flyout.hide();
                        }
                    }
                }, 100);
            }
        }
    }


    private _filterBlocks(event) {
        clearTimeout(this._filterbarTimeout);
        if (this.workspace) {
            const toolbox = this.workspace.getToolbox();
            if (toolbox) {
                this._filterbarTimeout = setTimeout(() => {
                    if (event.target.value) {
                        this.getBlocksByType(event.target.value);
                    } else {
                        this.getBlocksByType('');
                    }
                    const flyout = this.workspace.getFlyout();
                    if (flyout) {
                        flyout.hide();
                    }
                }, 100);
            }
        }
    }

    private get _searchbarInput() {
        let searchbar = null;
        if (this.workspace) {
            const toolbox = this.workspace.getToolbox();
            if (toolbox) {
                const elements = toolbox.HtmlDiv.getElementsByClassName('blockly-toolbox-search');
                searchbar = elements.length > 0 ? elements[0] : null;
            }
        }
        return searchbar;
    }

    finishBlocklySetup() {
        const that = this;
        this.workspace.registerToolboxCategoryCallback(
            'ATTRIBUTE_PALETTE', this.attributes);
        this.workspace.registerToolboxCategoryCallback(
            'ADDTO_PALETTE', this.addTo);
        this.workspace.registerToolboxCategoryCallback(
            'API_CONNECTORS', this.apiConnectors);
        this.workspace.registerToolboxCategoryCallback(
            'APIRESPONSE', this.apiResponse);
        this.workspace.registerToolboxCategoryCallback(
            'SQLOPERATIONS', this.sqlOperations);


        Blockly.svgResize(this.workspace);
        this.loadExecutor();
        this.blocklyRendered = true;
        this.loading = true;
        $('.blocklyFlyout').css('display', 'none');
    }

    resizeBlockly(s) {
        if (this.workspace) {
            setTimeout(() => {
                Blockly.svgResize(this.workspace);
            }, 351);
        }
    }

    resizeBlocklyWorkspace() {
        if (this.workspace) {
            Blockly.svgResize(this.workspace);
        }
    }

    getBlocksByType(type) {
        if (type === '') {
            this.filteredBlocklyXMLToolbox = this.blocklyXMLToolbox;
            const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
            this.workspace.updateToolbox('<xml style="display: none;">' + this.filteredBlocklyXMLToolbox + '</xml>');
            this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
            this.searchBlocklyText = '';
        } else {
            const parentElements = [];
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString('<xml style="display: none;">' + this.blocklyXMLToolbox + '</xml>', 'text/xml');
            const xmlBlocks = xmlDoc.getElementsByTagName('block');
            const xmlCategories = xmlDoc.getElementsByTagName('category');
            let newBlocklyXMLToolBox = '';
            for (let i = 0; i < xmlCategories.length; i++) {
                if (xmlCategories[i].getAttribute('name').toLowerCase().includes(type.toLowerCase()) && !parentElements.includes(xmlCategories[i].outerHTML)) {
                    newBlocklyXMLToolBox += xmlCategories[i].outerHTML;
                    parentElements.push(xmlCategories[i].outerHTML);
                }
            }
            for (let i = 0; i < xmlBlocks.length; i++) {
                if (xmlBlocks[i].getAttribute('type').toLowerCase().includes(type.toLowerCase()) && !parentElements.includes(xmlBlocks[i].parentElement.outerHTML)) {
                    newBlocklyXMLToolBox += xmlBlocks[i].parentElement.outerHTML;
                    parentElements.push(xmlBlocks[i].parentElement.outerHTML);
                }
            }

            this.filteredBlocklyXMLToolbox = newBlocklyXMLToolBox;
            newBlocklyXMLToolBox = '<xml style="display: none">' + newBlocklyXMLToolBox + '\n</xml>';

            const categoryStates = this.getCategoryStatesForWorkspace(this.workspace);
            this.workspace.updateToolbox(newBlocklyXMLToolBox);
            this.restoreCategoryStatesForWorkspace(this.workspace, categoryStates);
        }
        $('.blocklyFlyout').css('display', 'none');
    }

    capitalize(str) {
        const val = str;
        const substr = val.split(' ');
        const returnVal = [];

        substr.forEach((value) => {
            if (value) {
                returnVal.push(value.charAt(0).toUpperCase() + value.slice(1));
            }
        });
        return returnVal.join(' ');
    }

    copyMessage(event) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = $(event.target).text();
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    copyCode(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    loadAuthorization() {
        if (this.blComponentDataService.authorizationTypesData) {
            this.blComponentDataService.authorizationTypesData.forEach(block => {
                Blockly.Blocks[block.name] = {
                    init: function () {
                        this.appendDummyInput()
                            .appendField(block.displayName);
                        if (block.authAttributes) {
                            block.authAttributes.forEach(attribute => {
                                this.appendValueInput(attribute.key)
                                    .setCheck(null)
                                    .appendField(attribute.displayName);
                            });
                        }
                        this.setOutput(true, null);
                        this.setColour(230);
                        this.setTooltip('');
                        this.setHelpUrl('');
                    }
                };
            });

            Blockly.Python['basic_authentication'] = function (authBlock) {
                const username = Blockly.Python.valueToCode(authBlock, 'username', 0);
                const password = Blockly.Python.valueToCode(authBlock, 'password', 0);

                const code = 'HTTPBasicAuth(' + username + ', ' + password + ')';
                return [code, Blockly.Python.ORDER_NONE];
            };

            // Blockly.Javascript['basic_authentication'] = function(authBlock) {
            //     const username = Blockly.Python.valueToCode(authBlock, 'username', 0);
            //     const password = Blockly.Python.valueToCode(authBlock, 'password', 0);
            //
            //
            //     const code = 'HTTPBasicAuth(' + username + ', ' + password + ')';
            //
            //     return code;
            // };

            Blockly.Python['bearer_token'] = function (authBlock) {
                const token = Blockly.Python.valueToCode(authBlock, 'token', 0);
                const code = 'BearerToken(' + token + ')';

                return [code, Blockly.Python.ORDER_NONE];
            };

            Blockly.Python['connector'] = function (authBlock) {
                const name = Blockly.Python.valueToCode(authBlock, 'name', 0);
                const producer = Blockly.Python.valueToCode(authBlock, 'producer', 0);
                const type = Blockly.Python.valueToCode(authBlock, 'type', 0);
                const code = 'ConnectTo(' + producer + '_' + type + '_' + name + ')';

                return [code, Blockly.Python.ORDER_NONE];
            };

            Blockly.Python['api_key'] = function (authBlock) {
                const key = Blockly.Python.valueToCode(authBlock, 'key', 0);
                const value = Blockly.Python.valueToCode(authBlock, 'value', 0);
                let addTo = Blockly.Python.valueToCode(authBlock, 'addTo', 0);
                addTo = addTo === '(parameters)' ? 'parameters' : 'headers';

                const code = 'ApiKeyAuth(' + key + ', ' + value + ', ' + addTo + ')';
                return [code, Blockly.Python.ORDER_NONE];
            };

            Blockly.Python['aws_signature'] = function (authBlock) {
                const accessKeyID = Blockly.Python.valueToCode(authBlock, 'accessKeyID', 0);
                const secretAccessKey = Blockly.Python.valueToCode(authBlock, 'secretAccessKey', 0);
                const regionName = Blockly.Python.valueToCode(authBlock, 'regionName', 0);
                const serviceName = Blockly.Python.valueToCode(authBlock, 'serviceName', 0);
                const sessionToken = Blockly.Python.valueToCode(authBlock, 'session-token', 0);

                const code = 'AWSRequestsAuth(' + accessKeyID + ', ' + secretAccessKey + ', ' + regionName + ', ' + serviceName + ', ' + sessionToken + ')';
                return [code, Blockly.Python.ORDER_NONE];
            };

            Blockly.Python['oauth_2_0'] = function (authBlock) {
                return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
            };

            Blockly.Python['oauth_1_0'] = function (authBlock) {
                return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
            };
        }
    }

    constructExecutor() {
        const that = this;
        return new Promise((resolve, reject) => {
            if (that.isEditComponent && that.apiExecutor) {
                that.selectedExecutorType = that.apiExecutor['executor_type'];
                that.executor_name = that.apiExecutor['executor_name'];
                that.selectedVersion = that.apiExecutor['executor_version'];
                that.executor_display_name = that.apiExecutor['executor_display_name'];
                that.description = that.apiExecutor['executor_description'];
                that.executorCategory = that.apiExecutor['executor_category'];
                that.scopeSelected = that.apiExecutor.scopeOfAccess;
                that.selectedExecutor = that.apiExecutor['executor_method_type'];
                that.queryParams = that.apiExecutor['queryParams'];
                that.headers = that.apiExecutor['headers'];
                that.mockResponses = that.apiExecutor['mockResponses'];
                that.authModel = that.apiExecutor['authModel'];
                that.requestBody = that.apiExecutor['requestBody'];
                that.prerequisites = that.apiExecutor['prerequisites'];
                that.xml_content = that.apiExecutor['source'];
                that.customPathParams = that.apiExecutor['properties'] ? that.apiExecutor['properties']['pathValues'] ? that.apiExecutor['properties']['pathValues'] : [] : [];
                that.isCustomPath = that.customPathParams.length > 0;
                that.bodyParamDescription = that.apiExecutor['properties'] ? that.apiExecutor['properties']['bodyParamDescription'] ? that.apiExecutor['properties']['bodyParamDescription'] : [] : [];
                that.isBodyParamEnabled = that.apiExecutor['properties'] ? that.apiExecutor['properties']['showBodyParamDescription'] ? that.apiExecutor['properties']['showBodyParamDescription'] : false : false;
                that.attributeList = that.apiExecutor['block_attributes'];
                that.gatewayControl.setValue(['default']);

                resolve('success');
            } else {
                if (this.cloneable === false && this.isFromHistory === false) {
                    this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                        if (data != null) {
                            that.selectedExecutorType = data['executor_type'];
                            that.executor_name = data['executor_name'];
                            that.selectedVersion = data['executor_version'];
                            that.executor_display_name = data['executor_display_name'];
                            that.description = data['executor_description'];
                            that.executorCategory = data['executor_category'];
                            that.scopeSelected = data['scopeOfAccess'];
                            that.selectedExecutor = data['executor_method_type'];
                            that.queryParams = data['queryParams'];
                            that.headers = data['headers'];
                            that.mockResponses = data['mockResponses'];
                            that.authModel = data['authModel'];
                            that.requestBody = data['requestBody'];
                            that.prerequisites = data['prerequisites'];
                            that.xml_content = data['source'];
                            that.attributeList = data['block_attributes'];
                            that.customPathParams = data['properties'] ? data['properties']['pathValues'] ? data['properties']['pathValues'] : [] : [];
                            that.isCustomPath = that.customPathParams.length > 0;
                            that.bodyParamDescription = data['properties'] ? data['properties']['bodyParamDescription'] ? data['properties']['bodyParamDescription'] : [] : [];
                            that.isBodyParamEnabled = data['properties'] ? data['properties']['showBodyParamDescription'] ? data['properties']['showBodyParamDescription'] : false : false;


                            const gateways = [];

                            if (data['gatewaySettings']) {
                                if (data['gatewaySettings'].length > 0) {
                                    for (const gateway of data['gatewaySettings']) {
                                        gateways.push(gateway['name']);
                                    }
                                }
                            }
                            if (gateways.length === 0) {
                                gateways.push('default');
                            }
                            this.gatewayControl.setValue(gateways); // To trigger change detection

                            resolve('success');
                        }
                    }, error => {
                        reject('failed');
                    });
                } else if (this.isFromHistory === true && this.cloneable === false) {
                    if (this.historyData && this.historyData !== undefined && this.historyData !== null) {
                        that.selectedExecutorType = this.historyData['executor_type'];
                        that.executor_name = this.historyData['executor_name'];
                        that.selectedVersion = this.historyData['executor_version'];
                        that.executor_display_name = this.historyData['executor_display_name'];
                        that.description = this.historyData['executor_description'];
                        that.executorCategory = this.historyData['executor_category'];
                        that.scopeSelected = this.historyData['scopeOfAccess'];
                        that.selectedExecutor = this.historyData['executor_method_type'];
                        that.queryParams = this.historyData['queryParams'];
                        that.headers = this.historyData['headers'];
                        that.mockResponses = this.historyData['mockResponses'];
                        that.authModel = this.historyData['authModel'];
                        that.requestBody = this.historyData['requestBody'];
                        that.prerequisites = this.historyData['prerequisites'];
                        that.xml_content = this.historyData['source'];
                        that.attributeList = this.historyData['block_attributes'];
                        that.customPathParams = this.historyData['properties'] ? this.historyData['properties']['pathValues'] ? this.historyData['properties']['pathValues'] : [] : [];
                        that.isCustomPath = that.customPathParams.length > 0;
                        that.bodyParamDescription = this.historyData['properties'] ? this.historyData['properties']['bodyParamDescription'] ? this.historyData['properties']['bodyParamDescription'] : [] : [];
                        that.isBodyParamEnabled = this.historyData['properties'] ? this.historyData['properties']['showBodyParamDescription'] ? this.historyData['properties']['showBodyParamDescription'] : false : false;


                        const gateways = [];

                        if (this.historyData['gatewaySettings']) {
                            if (this.historyData['gatewaySettings'].length > 0) {
                                for (const gateway of this.historyData['gatewaySettings']) {
                                    gateways.push(gateway['name']);
                                }
                            }
                        }
                        if (gateways.length === 0) {
                            gateways.push('default');
                        }
                        this.gatewayControl.setValue(gateways);

                        resolve('success');
                    } else {
                        resolve('success');
                    }
                } else {
                    that.selectedExecutorType = this.platform.cloneableData['executor_type'];
                    that.executor_name = this.platform.cloneableData['executor_name'];
                    that.selectedVersion = this.platform.cloneableData['executor_version'];
                    that.executor_display_name = this.platform.cloneableData['executor_display_name'];
                    that.description = this.platform.cloneableData['executor_description'];
                    that.executorCategory = this.platform.cloneableData['executor_category'];
                    that.scopeSelected = this.platform.cloneableData['scopeOfAccess'];
                    that.selectedExecutor = this.platform.cloneableData['executor_method_type'];
                    that.queryParams = this.platform.cloneableData['queryParams'];
                    that.headers = this.platform.cloneableData['headers'];
                    that.mockResponses = this.platform.cloneableData['mockResponses'];
                    that.authModel = this.platform.cloneableData['authModel'];
                    that.requestBody = this.platform.cloneableData['requestBody'];
                    that.prerequisites = this.platform.cloneableData['prerequisites'];
                    that.xml_content = this.platform.cloneableData['source'];
                    that.attributeList = this.platform.cloneableData['block_attributes'];
                    that.customPathParams = this.platform.cloneableData['properties'] ? this.platform.cloneableData['properties']['pathValues'] ? this.platform.cloneableData['properties']['pathValues'] : [] : [];
                    that.isCustomPath = that.customPathParams.length > 0;
                    that.bodyParamDescription = this.platform.cloneableData['properties'] ? this.platform.cloneableData['properties']['bodyParamDescription'] ? this.platform.cloneableData['properties']['bodyParamDescription'] : [] : [];
                    that.isBodyParamEnabled = this.platform.cloneableData['properties'] ? this.platform.cloneableData['properties']['showBodyParamDescription'] ? this.platform.cloneableData['properties']['showBodyParamDescription'] : false : false;

                    resolve('success');
                }
            }
        });
    }

    async ngOnChanges(changes: SimpleChanges) {
        // for (const propName in changes) {
        //     if (changes.hasOwnProperty(propName)) {
        //     }
        // }
    }

    loadExecutor() {
        const that = this;
        this.loadResponse();
        this.loadParallel();
        this.loadSqlOperations();
        this.loadJsonObjects();
        this.loadAttributes();
        this.loadApiConnectors();
        this.loadAddToAttributes();
        this.loadAuthorization();
        // this.loadExecutorBlocks();

        // let partnerEdited = this.partner;
        // let accountEdited = this.account;
        // let entityEdited = this.entity;
        // let versionEdited = this.version;
        // if (this.cloneable) {
        //     partnerEdited = this.platform.cloneableData.partner;
        //     accountEdited = this.platform.cloneableData.account;
        //     entityEdited = this.platform.cloneableData.executor_name;
        //     versionEdited = this.platform.cloneableData.executor_version;
        // }
        if (this.isEditComponent && this.apiExecutor) {
            this.constructExecutorAndContinue();
        } else {
            if (this.entity !== null && this.entity !== undefined &&
                this.version !== null && this.version !== undefined) {
                if (this.businessLogicEdit === true) {
                    Promise.resolve(this.getAPIExecutor()).then(response => {
                        if (this.orig_executor && this.orig_executor !== null && this.orig_executor !== undefined) {
                            this.constructExecutorAndContinue();
                        } else {
                            this.platform.openSnackBar('Error while retrieving business logic API. Please try again after sometime ', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    });
                } else {
                    this.constructExecutorAndContinue();
                }
            } else {
                if (this.isFromHistory === true && this.cloneable === false) {
                    Promise.resolve(this.getHistory(this.partner, this.account_id, this.historyTimestamp)).then(response => {
                        if (this.entity !== null && this.entity !== undefined &&
                            this.version !== null && this.version !== undefined) {
                            this.constructExecutorAndContinue();
                        } else {
                            this.platform.openSnackBar('Error while retrieving business logic API. Please try again after sometime ', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    });
                }
            }
        }
    }

    constructExecutorAndContinue() {
        const that = this;
        Promise.resolve(this.constructExecutor()).then(response => {
            // this.devexHeader.setRequestBodyParameters();
            if (this.xml_content != null) {
                var blockText = this.xml_content;
                const parser = new DOMParser();
                const xml1 = parser.parseFromString(this.xml_content, 'text/xml');
                var xmlNode = xml1.getElementsByTagName('xml');
                if (xmlNode) {
                    // for (var i = 0; i < xmlNode.length; i++) {
                    //     for (var j = 0; j < xmlNode[i].childNodes.length; j++) {
                    //         var el = xmlNode[i].childNodes[j];
                    //         if (el.childNodes.length !== 1) {
                    //             blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + Blockly.Xml.domToText(el) + '</xml>';
                    //         }
                    //     }
                    // }
                    blockText = Blockly.Xml.domToText(xml1);
                } else {
                    blockText = '<xml xmlns="http://www.w3.org/1999/xhtml">' + this.xml_content + '</xml>';

                }
            }
            if (blockText) {
                try {
                    var xml1 = Blockly.utils.xml.textToDom(blockText);
                    if (that.workspace) {
                        that.workspace.clear();
                        Blockly.Xml.domToWorkspace(xml1, that.workspace);
                    }
                } catch (error) {
                    this.platform.openSnackBar('Error while loading business logic API: ' + error, 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }

            }
        }, error => {
            this.platform.openSnackBar('Error while loading business logic API: ' + error, 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    getExecutorList(data) {
        for (let cat of data) {
            for (let exe of cat.executors) {
                this.executorList.push(cat.category + '-' + exe.executor_name);
            }
        }
    }

    async setWorkSpaceOnChanges() {
        const that = this;
        // this.attributeList.push(['Select Target Attributes', 'null'],
        //     ['API.name', 'API.name'],
        //     ['API.version', 'API.version'],
        //     ['API.methodType', 'API.methodType'],
        //     ['API.type', 'API.type'],
        //     ['Headers', 'Headers'],
        //     ['Parameters', 'Parameters'],
        //     ['Authorization', 'Authorization']);

        if (this.attributeList.findIndex(p => p[0] === 'Select Target Attributes') === -1) {
            this.attributeList.push(['Select Target Attributes', 'null']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
            this.attributeList.push(['API.name', 'API.name']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
            this.attributeList.push(['API.version', 'API.version']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
            this.attributeList.push(['API.methodType', 'API.methodType']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
            this.attributeList.push(['API.type', 'API.type']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
            this.attributeList.push(['Headers', 'Headers']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
            this.attributeList.push(['Parameters', 'Parameters']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'Authorization') === -1) {
            this.attributeList.push(['Authorization', 'Authorization']);
        }

        this.addToList.push(['Headers', 'Headers'], ['Parameters', 'Parameters']);
        this.attributes = function () {
            return that.loadAttributes();
        };
        this.apiConnectors = function () {
            return that.loadApiConnectors();
        };
        this.addTo = function () {
            return that.loadAddToAttributes();
        };
        this.apiResponse = function () {
            return that.loadResponse();
        };
        this.sqlOperations = function () {
            return that.loadSqlOperations();
        };
        this.parallel = function () {
            return that.loadParallel();
        };
        // const that = this;
        const textWorkspace = new Blockly.Workspace();

        // this.executors = function() {
        //     return that.loadExecutorBlocks();
        // };
        // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
        // this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        // this.gatewayFullUrl = 'https://' + this.gatewayUrl;

        this.blComponentDataService.setAuthorizationTypesData();
    }

    async setWorkSpaceOnInit() {
        const that = this;
        // if (this.entity && this.version) {
        //     this.editFlag = true;
        // }
        if (this.attributeList !== null && this.attributeList !== undefined) {
            this.attributeList.push(['Select Target Attributes', 'null'],
                ['API.name', 'API.name'],
                ['API.version', 'API.version'],
                ['API.methodType', 'API.methodType'],
                ['API.type', 'API.type'],
                ['Headers', 'Headers'],
                ['Parameters', 'Parameters'],
                ['Payload', 'Payload'],
                ['Authorization', 'Authorization']);
        } else {
            // this.attributeList = [];
            // this.attributeList.push(
            //     ['Select Target Attributes', 'null'],
            //     ['API.name', 'API.name'],
            //     ['API.version', 'API.version'],
            //     ['API.methodType', 'API.methodType'],
            //     ['API.type', 'API.type'],
            //     ['Headers', 'Headers'],
            //     ['Parameters', 'Parameters'],
            //     ['Authorization', 'Authorization']);
            if (this.attributeList.findIndex(p => p[0] === 'Select Target Attributes') === -1) {
                this.attributeList.push(['Select Target Attributes', 'null']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
                this.attributeList.push(['API.name', 'API.name']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
                this.attributeList.push(['API.version', 'API.version']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
                this.attributeList.push(['API.methodType', 'API.methodType']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
                this.attributeList.push(['API.type', 'API.type']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
                this.attributeList.push(['Headers', 'Headers']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
                this.attributeList.push(['Parameters', 'Parameters']);
            }
            if (this.attributeList.findIndex(p => p[0] === 'Authorization') === -1) {
                this.attributeList.push(['Authorization', 'Authorization']);
            }
        }
        this.addToList.push(['Headers', 'Headers'], ['Parameters', 'Parameters']);
        this.attributes = function () {
            return that.loadAttributes();
        };
        this.addTo = function () {
            return that.loadAddToAttributes();
        };
        this.apiConnectors = function () {
            return that.loadApiConnectors();
        };
        this.apiResponse = function () {
            return that.loadResponse();
        };
        this.sqlOperations = function () {
            return that.loadSqlOperations();
        };
        this.parallel = function () {
            return that.loadParallel();
        };

        const textWorkspace = new Blockly.Workspace();

        // this.executors = function() {
        //     return that.loadExecutorBlocks();
        // };
        // this.gatewayUrl = (this.partner === this.account ? 'gateway.' + this.partner + '.apiplatform.io' : 'gateway.' + this.partner + '.' + this.account + '.apiplatform.io');
        // this.gatewayUrl = await this.platform.getDefaultGatewayURL();
        // this.gatewayFullUrl = 'https://' + this.gatewayUrl;
        this.blComponentDataService.setAuthorizationTypesData();

    }


    async ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }

        const permissionSubscription = interval(500).subscribe((async x => {
            permissionSubscription.unsubscribe();
            this.afterPermissionsLoaded();
        }));

        if (this.isEditComponent && this.apiExecutor) {
            this.setWorkSpaceOnInit();
            this.setWorkSpaceOnChanges();
            this.loadExecutor();
        } else {
            this.route.queryParams
                .subscribe(async params => {
                    this.cloneable = false;
                    this.isFromHistory = false;
                    this.businessLogicEdit = false;

                    if (this.retrieveExecutorFromRouteParams) {
                        if (params) {
                            if (params.clone && params.clone === 'true') {
                                this.cloneable = true;
                                this.businessLogicEdit = false;
                                this.isFromHistory = false;
                                if (this.platform.cloneableData !== undefined) {
                                    this.entity = this.platform.cloneableData['executor_name'];
                                    this.version = this.platform.cloneableData['executor_version'];
                                    this.orig_executor_name = this.platform.cloneableData['executor_name'];
                                    this.orig_executor_version = this.platform.cloneableData['executor_version'];
                                    this.editFlag = false;
                                } else {
                                    this.editFlag = false;
                                    this.router.navigateByUrl('/businesslogic');
                                }
                            } else if (params.timestamp && params.timestamp !== null && params.timestamp !== undefined) {
                                this.businessLogicEdit = false;
                                this.historyTimestamp = params.timestamp;
                                this.isFromHistory = true;
                                this.cloneable = false;
                                this.partner = params.partner;
                                this.account_id = params.account;
                                this.getHistory(params.partner, params.account, params.timestamp);
                            } else if (params.entity && params.version) {
                                this.businessLogicEdit = true;
                                this.isFromHistory = false;
                                this.cloneable = false;
                                this.entity = params.entity;
                                this.version = params.version;
                                this.orig_executor_name = params.entity;
                                this.orig_executor_version = params.version;
                                this.editFlag = true;
                                this.orig_executor = undefined;
                                const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                                    maxWidth: '95vw',
                                    maxHeight: '60vh',
                                });
                                this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                                    loaderDialog.close();
                                    if (data != null) {
                                        this.orig_executor = data;
                                        this.backupExecutor = data;
                                        if (this.loading) {
                                            Blockly.mainWorkspace.clear();
                                            this.loadExecutor();
                                        }
                                    }
                                }, error => {
                                    loaderDialog.close();
                                });
                            } else if (this.isApiDiscovery && this.entity && this.version) {
                                this.editFlag = true;
                                this.businessLogicEdit = true;
                                this.isFromHistory = false;
                                this.cloneable = false;
                                this.orig_executor_name = this.entity;
                                this.orig_executor_version = this.version;
                                this.orig_executor = undefined;
                                this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                                    if (data != null) {
                                        this.orig_executor = data;
                                        this.backupExecutor = data;
                                        if (this.loading) {
                                            Blockly.mainWorkspace.clear();
                                            this.loadExecutor();
                                        }
                                    }
                                });
                            } else {
                                this.editFlag = false;
                                this.businessLogicEdit = false;
                                this.isFromHistory = false;
                                this.cloneable = false;
                                this.selectedExecutorType = 'BUSINESSLOGIC';
                                this.executor_name = undefined;
                                this.selectedVersion = undefined;
                                this.executor_display_name = undefined;
                                this.description = undefined;
                                this.executorCategory = undefined;
                                this.scopeSelected = 'public';
                                this.selectedExecutor = undefined;
                                this.queryParams = [];
                                this.headers = [];
                                this.mockResponses = [];
                                this.requestBody = {};
                                this.attributeList = [];
                            }
                            this.setWorkSpaceOnInit();
                        } else {
                            this.editFlag = false;
                        }
                    } else {
                        this.setWorkSpaceOnInit();
                        if (this.location['_platformLocation'].location.pathname === '/businesslogic') {
                            this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                                if (data != null) {
                                    this.orig_executor = data;
                                }
                            });
                        }
                    }
                });
        }

        if (this.platform.apiGateways !== null && this.platform.apiGateways !== undefined) {
            this.apiGateways = this.platform.apiGateways;
        } else {
            await this.cfgSrv.getPartnerSettings(localStorage.getItem('partner'), localStorage.getItem('account'), localStorage.getItem('partnerKey')).toPromise().then(data => {
                    let resp: any;
                    resp = data;
                    this.apiGateways = resp['apigateway'];
                    this.platform.apiGateways = resp['apigateway'];
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of API Gateways. Please try again after sometime.');
                });
        }


        this.appComp.currentPageTitle = 'Create Business Logic API';
        if (this.platform.partnerEntities !== null && this.platform.partnerEntities !== undefined) {
            this.partnerEntities = this.platform.partnerEntities;
        } else {
            this.cfgSrv.getEntitiesForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).toPromise().then(data1 => {
                if (data1 && data1 !== undefined && data1 !== null) {
                    this.partnerEntities = data1;
                    this.platform.partnerEntities = this.partnerEntities;
                } else {
                    this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                        duration: 30000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }, error => {
                this.platform.openSnackBar('Error while retrieving data access entities for your account', 'Error', {
                    duration: 30000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }

        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            await this.platform.updateIsNoSQLForMongo(this.platform.databases);
            this.databases = this.platform.databases;
        } else {
            // this.platform.getDatabasesForPartnerAccount();
            await this.cfgSrv.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
            this.databases = this.platform.databases;
        }
        if (this.databases) {
            if (this.databases && this.databases !== null && this.databases !== undefined) {
                this.databases.forEach(database => {
                    if (!database.is_nosql) {
                        this.sqlDatabases.push([database.database_name, database.database_name]);
                    } else {
                        if (database.database_type === 'mongodb') {
                            this.mongodbDatabases.push([database.database_name, database.database_name]);
                        }
                    }
                });
            }
        }
    }

    setAcceleratorsData(force = false) {
        Promise.resolve(this.blComponentDataService.setAcceleratorsData(force)).then(data => {

            this.acceleratorsList = [];
            if (this.blComponentDataService.acceleratorsData && this.blComponentDataService.acceleratorsData['subscribedAccelerators']) {
                for (const val of this.blComponentDataService.acceleratorsData['subscribedAccelerators']) {
                    this.acceleratorsList.push({
                        title: val['title'],
                        image: val['image'],
                        display_name: val['display_name'],
                        accelerators: [],
                        connector_variables: val.connector_variables ? val.connector_variables : []
                    });
                    for (const accelerator of val['accelerators']) {
                        this.acceleratorsList[this.acceleratorsList.length - 1].accelerators.push(accelerator);
                        const variables = accelerator.accelerator_source ? accelerator.accelerator_source.accelerator_variables ? accelerator.accelerator_source.accelerator_variables : [] : [];
                        if (variables) {
                            for (const vari of variables) {
                                if (vari && vari['name']) {
                                    this.addAcceleratorVariable(vari['name']);
                                }
                            }
                        }
                    }

                    const connectorVariables = val.connector_variables ? val.connector_variables : [];
                    if (connectorVariables) {
                        for (const vari of connectorVariables) {
                            if (vari && vari['name']) {
                                this.addAcceleratorConnectorVariable(vari['name']);
                            }
                        }
                    }
                }
            }

        });
    }

    setBlocksDocumentation() {
        Promise.resolve(this.blComponentDataService.setAndGetDocumentationInitialData()).then(initialBlockDescription => {
            this.blockDescriptions = initialBlockDescription['initialDocumentation'];
        }, error => {});
    }

    addAcceleratorVariable(variableName) {
        const a = [variableName, variableName];
        const containsVariable = this.acceleratorVariablesList.some(e => JSON.stringify(e) === JSON.stringify(a));

        if (!containsVariable) {
            this.acceleratorVariablesList.push([variableName, variableName]);
            this.acceleratorVariableName = '';
        }
    }

    addAcceleratorConnectorVariable(variableName) {
        const a = [variableName, variableName];
        const containsVariable = this.acceleratorConnectorVariablesList.some(e => JSON.stringify(e) === JSON.stringify(a));

        if (!containsVariable) {
            this.acceleratorConnectorVariablesList.push([variableName, variableName]);
            this.acceleratorConnectorName = '';
        }
    }

    async updateAttributes() {
        this.requestBody = this.devexHeader.getRequestBody();
        if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
            this.requestBody = this.requestBody['__zone_symbol__value'];
        }
        const that = this;
        // this.attributeList = [];
        // this.attributeList[0] = ['Select Target Attributes', 'null'];
        this.attributeList.forEach((attr, index) => {
            if (attr[0].includes('Parameter') || attr[0].includes('Header') || attr[0].includes('Payload')) {
                that.attributeList.splice(index, 1);
            }
        });
        if (this.attributeList.findIndex(p => p[0] === 'API.name') === -1) {
            this.attributeList.push(['API.name', 'API.name']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.version') === -1) {
            this.attributeList.push(['API.version', 'API.version']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.methodType') === -1) {
            this.attributeList.push(['API.methodType', 'API.methodType']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'API.type') === -1) {
            this.attributeList.push(['API.type', 'API.type']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'Headers') === -1) {
            this.attributeList.push(['Headers', 'Headers']);
        }
        if (this.attributeList.findIndex(p => p[0] === 'Parameters') === -1) {
            this.attributeList.push(['Parameters', 'Parameters']);
        }


        this.headers.forEach((queryParam) => {
            if (queryParam && queryParam.key !== '') {
                if (that.attributeList.findIndex(p => p[0] === 'Header.' + queryParam.key) === -1) {
                    that.attributeList.push(['Header.' + queryParam.key, 'Header.' + queryParam.key]);
                }
            }
        });
        this.queryParams.forEach((queryParam) => {
            if (queryParam && queryParam.key !== '') {
                if (that.attributeList.findIndex(p => p[0] === 'Parameter.' + queryParam.key) === -1) {
                    that.attributeList.push(['Parameter.' + queryParam.key, 'Parameter.' + queryParam.key]);
                }
            }
        });
        if (this.devexHeader.isCustomPath) {
            Promise.resolve(this.devexHeader.isCustomPathValid()).then(response => {

                const pathParams = this.devexHeader.getCustomPathAsParams();
                pathParams.forEach((queryParam) => {
                    if (queryParam && queryParam.key !== '') {
                        if (that.attributeList.findIndex(p => p[0] === 'Parameter.' + queryParam.key) === -1) {
                            that.attributeList.push(['Parameter.' + queryParam.key, 'Parameter.' + queryParam.key]);
                        }
                    }
                });
            }, error => {
                this.platform.openSnackBar(error, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }

        if (this.devexHeader.requestBodySelected !== 'raw') {
            if (this.attributeList.findIndex(p => p[0] === 'Payload') === -1) {
                this.attributeList.push(['Payload', 'Payload']);
            }
            if (this.requestBody && this.requestBody['value'].length > 0) {
                this.requestBody['value'].forEach((queryParam) => {
                    if (queryParam && queryParam.key !== '') {
                        if (that.attributeList.findIndex(p => p[0] === 'Payload.' + queryParam.key) === -1) {
                            that.attributeList.push(['Payload.' + queryParam.key, 'Payload.' + queryParam.key]);
                        }
                    }
                });
                // this.requestBody = {};
            }
        } else {
            if (this.requestBody && this.requestBody['value'] !== '') {
                if (this.attributeList.findIndex(p => p[0] === 'Payload') === -1) {
                    this.attributeList.push(['Payload', 'Payload']);
                }
                // this.requestBody = {};
            }
        }
        this.platform.openSnackBar('Header and Parameter Updated successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    getAttributeKeyValue(block) {
        const keyPairBlock = block.getParent();
        if (keyPairBlock && keyPairBlock.type === 'key_value_pair') {
            const keyParent = keyPairBlock.getParent();

            const a = keyPairBlock.getInputTargetBlock('A');
            if (a.type === 'text') {
                return a.getFieldValue('TEXT');
            }

            if (keyParent && keyParent.type === 'json_object') {
                const fieldname = keyParent.getInputWithBlock();
            }
        }
        return '';
    }

    loadAttributes() {
        const that = this;
        Blockly.Blocks['attributes'] = {
            currentAttributes: [],
            matchKey: '',
            init: function () {
                const generateOptions = (function(that1) {
                    return function() {
                        return that.getSuggestedSortedAttributeList(that.getAttributeKeyValue(that1));
                    };
                })(this);
                const parentBlock = this.getParent();
                this.setColour(80);
                this.setOutput(true);
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown(generateOptions), 'MODE');
            },
            updateMatchKey: function(key) {
                this._matchKey = key;
            },
            getMatchKey: function() {
                const keyPairBlock = this.getParent();
                if (keyPairBlock && keyPairBlock.type === 'key_value_pair') {
                    const keyParent = keyPairBlock.getParent();

                    const a = keyPairBlock.getInputTargetBlock('A');
                    if (a.type === 'text') {
                        return a.getFieldValue('TEXT');
                    }

                    if (keyParent && keyParent.type === 'json_object') {
                        const fieldname = keyParent.getInputWithBlock();
                    }
                }
                return '';
            },
        };

        Blockly.Python['attributes'] = function (block1) {
            const mode = block1.getFieldValue('MODE');

            let code = mode;
            if (mode.includes('>')) {
                const name = mode.substring(0, mode.indexOf('>'));
                const varSplit = mode.substring(mode.indexOf('>') + 1).split(/[>.]+/);
                code = name;
                if (varSplit[0] === 'response' && varSplit.length > 1) {
                    if (varSplit[1] === 'statusCode') {
                        code += '.status_code';
                    } else if (varSplit[1] === 'headers') {
                        code += '.headers';
                    } else if (varSplit[1] === 'body') {
                        code += '.json()';
                        if (varSplit.length > 2) {
                            if (varSplit[2] === '_isList') {
                                code = '(type(' + code + ') is list)';
                            } else if (varSplit[2] === '_first') {
                                code += '[0]';
                                for (const val of varSplit.splice(3, varSplit.length - 1)) {
                                    code += '[\'' + val + '\']';
                                }
                            } else {
                                for (const val of varSplit.splice(2, varSplit.length - 1)) {
                                    code += '[\'' + val + '\']';
                                }
                            }
                        }
                    } else {
                        code = mode;
                    }
                } else {
                    if (varSplit[0] === 'response') {
                        code = name;
                    } else {
                        code = mode;
                    }
                }
            }

            return [code, Blockly.Python.ORDER_NONE];
        };
        var xmlList = [];
        var blockText = '<xml><block type="attributes"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);
        return xmlList;
    }

    loadApiConnectors() {
        const that = this;
        Blockly.Blocks['api_connector'] = {
            init: function () {
                this.setColour(110);
                this.setOutput(true);
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown(that.blComponentDataService.providerConnectorsData), 'MODE');
            },
            onchange: function (event) {
            }
        };
        Blockly.Python['api_connector'] = function (block1) {
            const mode = block1.getFieldValue('MODE');

            let code = mode;
            return [code, Blockly.Python.ORDER_NONE];
        };
        var xmlList = [];
        var blockText = '<xml><block type="api_connector"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);
        return xmlList;
    }

    loadAddToAttributes() {
        const that = this;
        Blockly.Blocks['addTo'] = {
            init: function () {
                this.setColour(80);
                this.setOutput(true);
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown(that.addToList), 'MODE');
            },
            onchange: function (event) {
            }
        };

        Blockly.Python['addTo'] = function (block1) {
            const mode = block1.getFieldValue('MODE');

            let code = '<not selected>';
            switch (mode) {
                case 'Headers':
                    code = 'headers';
                    break;
                case 'Parameters':
                    code = 'parameters';
                    break;
                default:
                    break;
            }
            return [code, Blockly.Python.ORDER_NONE];
        };

        var xmlList = [];
        var blockText = '<xml><block type="addTo"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);
        return xmlList;
    }

    addExecuteMongodbBlockAttributes() {
        for (const attribute of this.mongoExecuteQueryAttributes) {
            const value = [this.mongodbExecuteQueryName + '>' + attribute, this.mongodbExecuteQueryName + '>' + attribute];
            const exists = this.attributeList.find(a => a[0] === value[0] && a[1] === value[1]);

            if (!exists) {
                this.attributeList.push(value);
            }
        }
    }

    loadSqlOperations() {

        if ((this.sqlDatabases && this.sqlDatabases.length > 0) || (this.mongodbDatabases && this.mongodbDatabases.length > 0)) {
            if (this.sqlDatabases && this.sqlDatabases.length > 0) {
                Blockly.defineBlocksWithJsonArray([
                    {
                        'type': 'sql_transactions',
                        'message0': 'database transactions on %1',
                        'args0': [
                            {
                                'type': 'field_dropdown',
                                'name': 'MODE',
                                'options': this.sqlDatabases
                            }
                        ],
                        'message1': 'DO %1',
                        'args1': [{
                            'type': 'input_statement',
                            'name': 'DO'
                        }],
                        'previousStatement': null,
                        'nextStatement': null,
                        'style': 'loop_blocks',
                        'helpUrl': '%{BKY_CONTROLS_WHILEUNTIL_HELPURL}',
                        'extensions': ['controls_whileUntil_tooltip']
                    }
                ]);

                Blockly.Python['sql_transactions'] = function (authBlock) {
                    return '# Not implemented';
                };

                var xmlList = [];
                var blockText = '<xml><block type="sql_transactions"></block></xml>';

                var block = Blockly.utils.xml.textToDom(blockText).firstChild;
                xmlList.push(block);

                Blockly.Blocks['sql_commit'] = {
                    init: function () {
                        this.setColour(100);
                        this.setNextStatement(true);
                        this.setPreviousStatement(true);
                        this.appendDummyInput().appendField('commit');
                    },
                    onchange: function (event) {
                    }
                };

                Blockly.Python['sql_commit'] = function (authBlock) {
                    return '# Not implemented';
                };

                var blockText = '<xml><block type="sql_commit"></block></xml>';
                var block = Blockly.utils.xml.textToDom(blockText).firstChild;
                xmlList.push(block);

                Blockly.Blocks['sql_rollback'] = {
                    init: function () {
                        this.setColour(100);
                        this.setNextStatement(true);
                        this.setPreviousStatement(true);
                        this.appendDummyInput().appendField('rollback');
                    },
                    onchange: function (event) {
                    }
                };

                Blockly.Python['sql_rollback'] = function (authBlock) {
                    return '# Not implemented';
                };

                var blockText = '<xml><block type="sql_rollback"></block></xml>';
                var block = Blockly.utils.xml.textToDom(blockText).firstChild;
                xmlList.push(block);
            }

            if (this.mongodbDatabases && this.mongodbDatabases.length > 0) {
                const that = this;
                Blockly.Blocks['execute_mongodb_query'] = {
                    init: function() {
                        this.appendDummyInput()
                            .appendField('Execute MongoDB Query');
                        this.appendDummyInput()
                            .appendField('Database :')
                            .appendField(new Blockly.FieldDropdown(that.mongodbDatabases), 'DATABASE');
                        this.appendValueInput('COLLECTION')
                            .setCheck(null)
                            .appendField('Collection');
                        this.appendValueInput('MATCH')
                            .setCheck(null)
                            .appendField('Match');
                        this.appendValueInput('SORT')
                            .setCheck(null)
                            .appendField('Sort');
                        this.setPreviousStatement(true, null);
                        this.setNextStatement(true, null);
                        this.setColour(100);
                        this.setTooltip('');
                        this.setHelpUrl('');
                    },
                    mutationToDom: function() {
                        const container = document.createElement('mutation');
                        container.setAttribute('partner', that.accountInfoService.partner);
                        container.setAttribute('account', that.accountInfoService.account);
                        return container;
                    },
                    domToMutation: function(xmlElement) {
                    },
                    onchange: function (event) {
                        if (event.ids) {
                            if (that.workspace.getBlockById(event.blockId)) {
                                if (that.workspace.getBlockById(event.blockId).type != null) {
                                    that.addExecuteMongodbBlockAttributes();
                                }
                            }
                        }
                    }
                };

                Blockly.Python['execute_mongodb_query'] = function (block1) {
                    return '# Not implemented';
                };
                var blockText = '<xml><block type="execute_mongodb_query"></block></xml>';

                var block = Blockly.utils.xml.textToDom(blockText).firstChild;
                xmlList.push(block);
            }

            return xmlList;
        } else {
            return [];
        }
    }

    loadResponse() {
        Blockly.Blocks['api_response'] = {
            init: function () {
                this.setColour(100);
                // this.setNextStatement(true);
                this.setPreviousStatement(true);
                this.appendValueInput('VALUE').appendField('return');
            },
            onchange: function (event) {
            }
        };
        Blockly.Python['api_response'] = function (authBlock) {
            const input = Blockly.Python.valueToCode(authBlock, 'VALUE', 0);

            return '\nreturn ' + input + '\n';
        };
        var xmlList = [];
        var blockText = '<xml><block type="api_response"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);

        Blockly.Blocks['api_response_error'] = {
            init: function () {
                this.setColour(100);
                this.setPreviousStatement(true);
                this.appendDummyInput()
                    .appendField('return custom error');
                this.appendValueInput('errorCode')
                    .setCheck(null)
                    .appendField('Error Code');
                this.appendValueInput('errorMessage')
                    .setCheck(null)
                    .appendField('Error Message');
                this.appendValueInput('headers')
                    .setCheck(null)
                    .appendField('Headers');
                // this.setOutput(true, null);
                this.setTooltip('');
                this.setHelpUrl('');
            },
            onchange: function (event) {
            }
        };
        Blockly.Python['api_response_error'] = function (authBlock) {
            const statusCode = Blockly.Python.valueToCode(authBlock, 'errorCode', 0);
            const errorMessage = Blockly.Python.valueToCode(authBlock, 'errorMessage', 0);
            const headers = Blockly.Python.valueToCode(authBlock, 'headers', 0);

            // Blockly.Python.definitions_['import_requests'] = 'import requests';
            // Blockly.Python.definitions_['response_variable'] = 'response = requests.models.Response()';

            // let code = '';
            // code += statusCode && statusCode !== '' ? 'response.status_code = ' + statusCode : '';
            // code += errorMessage && errorMessage !== '' ? '\nresponse._content = ' + errorMessage : '';
            // code += headers && headers !== '' ? '\nresponse.headers = ' + headers : '';
            const code = '\nreturn ' + (statusCode && statusCode !== '' ? statusCode : 'None') + ', ' + (errorMessage && errorMessage !== '' ? +errorMessage : 'None') + ', ' + (headers && headers !== '' ? headers : 'None') + '\n';

            return code;
        };
        var blockText = '<xml><block type="api_response_error"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);

        Blockly.Blocks['api_response_custom'] = {
            init: function () {
                this.setPreviousStatement(true);
                this.appendDummyInput()
                    .appendField('return custom response');
                this.appendValueInput('statusCode')
                    .setCheck(null)
                    .appendField('Status Code');
                this.appendValueInput('responseBody')
                    .setCheck(null)
                    .appendField('Response Body');
                this.appendValueInput('headers')
                    .setCheck(null)
                    .appendField('Headers');
                // this.setOutput(true, null);
                this.setColour(100);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['api_response_custom'] = function (authBlock) {
            const statusCode = Blockly.Python.valueToCode(authBlock, 'statusCode', 0);
            const responseBody = Blockly.Python.valueToCode(authBlock, 'responseBody', 0);
            const headers = Blockly.Python.valueToCode(authBlock, 'headers', 0);

            // Blockly.Python.definitions_['import_requests'] = 'import requests';
            // Blockly.Python.definitions_['response_variable'] = 'response = requests.models.Response()';

            // let code = '';
            // code += statusCode && statusCode !== '' ? 'response.status_code = ' + statusCode : '';
            // code += responseBody && responseBody !== '' ? '\nresponse._content = ' + responseBody : '';
            // code += headers && headers !== '' ? '\nresponse.headers = ' + headers : '';

            const code = '\nreturn ' + (statusCode && statusCode !== '' ? statusCode : 'None') + ', ' + (responseBody && responseBody !== '' ? responseBody : 'None') + ', ' + (headers && headers !== '' ? headers : 'None') + '\n';


            return code;
        };
        var blockText = '<xml><block type="api_response_custom"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);
        return xmlList;
    }

    loadParallel() {

        Blockly.defineBlocksWithJsonArray([
            {
                'type': 'parallel_execution',
                'message0': 'Parallel Executor %1',
                'args0': [
                    {
                        'type': 'field_dropdown',
                        'name': 'MODE',
                        'options': [
                            ['NO WAIT', 'NO WAIT'],
                            ['WAIT UNTIL', 'WAIT UNTIL']
                        ]
                    }
                ],
                'message1': 'DO %1',
                'args1': [{
                    'type': 'input_statement',
                    'name': 'DO'
                }],
                'previousStatement': null,
                'nextStatement': null,
                'style': 'loop_blocks',
                'helpUrl': '%{BKY_CONTROLS_WHILEUNTIL_HELPURL}',
                'extensions': ['controls_whileUntil_tooltip']
            }
        ]);

        Blockly.Python['parallel_execution'] = function (authBlock) {
            return '# Not implemented';
        };


        // Blockly.Blocks['parallel_execution'] = {
        //     init: function () {
        //         this.setColour(100);
        //         // this.setNextStatement(true);
        //         this.setPreviousStatement(true);
        //         this.appendValueInput('VALUE').appendField('return');
        //     },
        //     onchange: function(event) {
        //     }
        // };
        var xmlList = [];
        var blockText = '<xml><block type="parallel_execution"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);


        Blockly.defineBlocksWithJsonArray([
            {
                'type': 'parallel_execution_with_foreach_wait_until',
                'message0': '%{BKY_CONTROLS_FOREACH_TITLE} execute in parallel WAIT UNTIL',
                'args0': [
                    {
                        'type': 'field_variable',
                        'name': 'VAR',
                        'variable': null
                    },
                    {
                        'type': 'input_value',
                        'name': 'LIST',
                        'check': 'Array'
                    }
                ],
                'message1': '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
                'args1': [{
                    'type': 'input_statement',
                    'name': 'DO'
                }],
                'previousStatement': null,
                'nextStatement': null,
                'style': 'loop_blocks',
                'helpUrl': '%{BKY_CONTROLS_FOREACH_HELPURL}',
                'extensions': [
                    'contextMenu_newGetVariableBlock',
                    'controls_forEach_tooltip'
                ]
            }
        ]);

        Blockly.Python['parallel_execution_with_foreach_wait_until'] = function (authBlock) {
            return '# Not implemented';
        };

        // var xmlList = [];
        var blockText = '<xml><block type="parallel_execution_with_foreach_wait_until"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);

        Blockly.defineBlocksWithJsonArray([
            {
                'type': 'parallel_execution_with_foreach_no_wait',
                'message0': '%{BKY_CONTROLS_FOREACH_TITLE} execute in parallel NO WAIT',
                'args0': [
                    {
                        'type': 'field_variable',
                        'name': 'VAR',
                        'variable': null
                    },
                    {
                        'type': 'input_value',
                        'name': 'LIST',
                        'check': 'Array'
                    }
                ],
                'message1': '%{BKY_CONTROLS_REPEAT_INPUT_DO} %1',
                'args1': [{
                    'type': 'input_statement',
                    'name': 'DO'
                }],
                'previousStatement': null,
                'nextStatement': null,
                'style': 'loop_blocks',
                'helpUrl': '%{BKY_CONTROLS_FOREACH_HELPURL}',
                'extensions': [
                    'contextMenu_newGetVariableBlock',
                    'controls_forEach_tooltip'
                ]
            }
        ]);

        Blockly.Python['parallel_execution_with_foreach_no_wait'] = function (authBlock) {
            return '# Not implemented';
        };

        // var xmlList = [];
        var blockText = '<xml><block type="parallel_execution_with_foreach_no_wait"></block></xml>';
        var block = Blockly.utils.xml.textToDom(blockText).firstChild;
        xmlList.push(block);


        return xmlList;
    }

    loadJsonObjects() {
        const that = this;
        Blockly.defineBlocksWithJsonArray([
            {
                'type': 'key_value_pair',
                'message0': '%1 %2 %3',
                'args0': [
                    {
                        'type': 'input_value',
                        'name': 'A',
                        'check': null
                    },
                    {
                        'type': 'field_dropdown',
                        'name': 'OP',
                        'options': [
                            [':', 'COLON']
                        ]
                    },
                    {
                        'type': 'input_value',
                        'name': 'B',
                        'check': null
                    }
                ],
                'inputsInline': true,
                'output': 'Boolean',
                'style': 'logic_blocks',
                'helpUrl': '%{BKY_LOGIC_COMPARE_HELPURL}',
                'extensions': ['logic_op_tooltip']
            }
        ]);

        Blockly.JavaScript['key_value_pair'] = function (block) {
            // Operations 'and', 'or'.
            const operator = ':';
            const order = 0;
            let argument0 = Blockly.JavaScript.valueToCode(block, 'A', order);
            let argument1 = Blockly.JavaScript.valueToCode(block, 'B', order);
            if (!argument0 && !argument1) {
                // If there are no arguments, then the return value is false.
                argument0 = null;
                argument1 = null;
            } else {
                // Single missing arguments have no effect on the return value.
                const defaultArgument = null;
                if (!argument0) {
                    argument0 = defaultArgument;
                }
                if (!argument1) {
                    argument1 = defaultArgument;
                }
            }
            const code = argument0 + ' ' + operator + ' ' + argument1;
            return [code, order];
        };

        Blockly.Python['key_value_pair'] = function (block) {
            // Operations 'and', 'or'.
            const operator = ':';
            const order = 0;
            let argument0 = Blockly.Python.valueToCode(block, 'A', order);
            let argument1 = Blockly.Python.valueToCode(block, 'B', order);
            if (!argument0 && !argument1) {
                // If there are no arguments, then the return value is false.
                argument0 = null;
                argument1 = null;
            } else {
                // Single missing arguments have no effect on the return value.
                const defaultArgument = null;
                if (!argument0) {
                    argument0 = defaultArgument;
                }
                if (!argument1) {
                    argument1 = defaultArgument;
                }
            }
            const code = argument0 + ' ' + operator + ' ' + argument1;
            return [code, order];
        };

        Blockly.Blocks['text_split'] = {
            /**
             * Block for replacing one string with another in the text.
             * @this Blockly.Block
             */
            init: function () {
                this.jsonInit({
                    'message0': 'split %1 with %2',
                    'args0': [
                        {
                            'type': 'input_value',
                            'name': 'TEXT',
                            'check': 'String'
                        },
                        {
                            'type': 'input_value',
                            'name': 'WITH',
                            'check': 'String'
                        }
                    ],
                    'output': 'String',
                    'inputsInline': true,
                    'style': 'text_blocks',
                    'tooltip': 'Split text with some text',
                    'helpUrl': 'https://github.com/google/blockly/wiki/Text#reversing-text'
                });
            }
        };

        Blockly.Python['text_split'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        }

        Blockly.Blocks['lists_append'] = {
            /**
             * Block for setting the element at index.
             * @this Blockly.Block
             */
            init: function () {
                var MODE =
                    [
                        [Blockly.Msg['LISTS_SET_INDEX_SET'], 'SET'],
                        [Blockly.Msg['LISTS_SET_INDEX_INSERT'], 'INSERT']
                    ];
                this.WHERE_OPTIONS =
                    [
                        [Blockly.Msg['LISTS_GET_INDEX_FROM_START'], 'FROM_START'],
                        [Blockly.Msg['LISTS_GET_INDEX_FROM_END'], 'FROM_END'],
                        [Blockly.Msg['LISTS_GET_INDEX_FIRST'], 'FIRST'],
                        [Blockly.Msg['LISTS_GET_INDEX_LAST'], 'LAST'],
                        [Blockly.Msg['LISTS_GET_INDEX_RANDOM'], 'RANDOM']
                    ];
                this.setHelpUrl(Blockly.Msg['LISTS_SET_INDEX_HELPURL']);
                this.setStyle('list_blocks');
                this.appendValueInput('LIST')
                    .setCheck('Array')
                    .appendField('in list');
                // this.appendDummyInput()
                //     .appendField(new Blockly.FieldDropdown(MODE), 'MODE')
                //     .appendField('', 'SPACE');

                // this.appendDummyInput('AT');
                this.appendValueInput('APPEND')
                    .appendField('append');
                this.setInputsInline(true);
                this.setPreviousStatement(true);
                this.setNextStatement(true);
                this.setTooltip(Blockly.Msg['LISTS_SET_INDEX_TOOLTIP']);
                this.updateAt_(true);
                // Assign 'this' to a variable for use in the tooltip closure below.
                var thisBlock = this;
                this.setTooltip('Append items to the list');
            },
            /**
             * Create XML to represent whether there is an 'AT' input.
             * @return {Element} XML storage element.
             * @this Blockly.Block
             */
            mutationToDom: function () {
                var container = Blockly.utils.xml.createElement('mutation');
                // var isAt = this.getInput('AT').type == Blockly.INPUT_VALUE;
                // container.setAttribute('at', isAt);
                return container;
            },
            /**
             * Parse XML to restore the 'AT' input.
             * @param {!Element} xmlElement XML storage element.
             * @this Blockly.Block
             */
            domToMutation: function (xmlElement) {
                // Note: Until January 2013 this block did not have mutations,
                // so 'at' defaults to true.
                // var isAt = (xmlElement.getAttribute('at') != 'false');
                // this.updateAt_(isAt);
            },
            /**
             * Create or delete an input for the numeric index.
             * @param {boolean} isAt True if the input should exist.
             * @private
             * @this Blockly.Block
             */
            updateAt_: function (isAt) {
                // Destroy old 'AT' and 'ORDINAL' input.
                // this.removeInput('AT');
                // this.removeInput('ORDINAL', true);
                // // Create either a value 'AT' input or a dummy input.
                // if (isAt) {
                //     this.appendValueInput('AT').setCheck('Number');
                //     if (Blockly.Msg['ORDINAL_NUMBER_SUFFIX']) {
                //         this.appendDummyInput('ORDINAL')
                //             .appendField(Blockly.Msg['ORDINAL_NUMBER_SUFFIX']);
                //     }
                // } else {
                //     this.appendDummyInput('AT');
                // }
                // var menu = new Blockly.FieldDropdown(this.WHERE_OPTIONS, function(value) {
                //     var newAt = (value == 'FROM_START') || (value == 'FROM_END');
                //     // The 'isAt' variable is available due to this function being a closure.
                //     if (newAt != isAt) {
                //         var block = this.getSourceBlock();
                //         block.updateAt_(newAt);
                //         // This menu has been destroyed and replaced.  Update the replacement.
                //         block.setFieldValue(value, 'WHERE');
                //         return null;
                //     }
                //     return undefined;
                // });
                // this.moveInputBefore('AT', 'TO');
                if (this.getInput('ORDINAL')) {
                    this.moveInputBefore('ORDINAL', 'APPEND');
                }

                // this.getInput('AT').appendField(menu, 'WHERE');
            }
        };

        Blockly.Python['lists_append'] = function (authBlock) {
            const list = Blockly.Python.valueToCode(authBlock, 'LIST', 0);
            const append = Blockly.Python.valueToCode(authBlock, 'APPEND', 0);
            const code = list + '.append(' + append + ')\n';
            return code;
        };

        Blockly.Blocks['lists_contains'] = {
            /**
             * Block for creating a list with any number of elements of any type.
             * @this Blockly.Block
             */
            init: function () {
                this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL']);
                this.setStyle('list_blocks');
                this.appendValueInput('LIST')
                    .setCheck('Array')
                    .appendField('check list');
                this.itemCount_ = 3;
                this.updateShape_();
                this.setOutput(true, 'Boolean');
                this.setMutator(new Blockly.Mutator(['lists_create_with_item']));
                // this.setTooltip(Blockly.Msg['LISTS_CREATE_WITH_TOOLTIP']);
                this.setTooltip('Checks if list contains given items');
            },
            /**
             * Create XML to represent list inputs.
             * @return {!Element} XML storage element.
             * @this Blockly.Block
             */
            mutationToDom: function () {
                var container = Blockly.utils.xml.createElement('mutation');
                container.setAttribute('items', this.itemCount_);
                return container;
            },
            /**
             * Parse XML to restore the list inputs.
             * @param {!Element} xmlElement XML storage element.
             * @this Blockly.Block
             */
            domToMutation: function (xmlElement) {
                this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10);
                this.updateShape_();
            },
            /**
             * Populate the mutator's dialog with this block's components.
             * @param {!Blockly.Workspace} workspace Mutator's workspace.
             * @return {!Blockly.Block} Root block in mutator.
             * @this Blockly.Block
             */
            decompose: function (workspace) {
                var containerBlock = workspace.newBlock('lists_create_with_container');
                containerBlock.initSvg();
                var connection = containerBlock.getInput('STACK').connection;
                for (var i = 0; i < this.itemCount_; i++) {
                    var itemBlock = workspace.newBlock('lists_create_with_item');
                    itemBlock.initSvg();
                    connection.connect(itemBlock.previousConnection);
                    connection = itemBlock.nextConnection;
                }
                return containerBlock;
            },
            /**
             * Reconfigure this block based on the mutator dialog's components.
             * @param {!Blockly.Block} containerBlock Root block in mutator.
             * @this Blockly.Block
             */
            compose: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                // Count number of inputs.
                var connections = [];
                while (itemBlock) {
                    connections.push(itemBlock.valueConnection_);
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
                // Disconnect any children that don't belong.
                for (var i = 0; i < this.itemCount_; i++) {
                    var connection = this.getInput('ADD' + i).connection.targetConnection;
                    if (connection && connections.indexOf(connection) === -1) {
                        connection.disconnect();
                    }
                }
                this.itemCount_ = connections.length;
                this.updateShape_();
                // Reconnect any child blocks.
                for (var i = 0; i < this.itemCount_; i++) {
                    Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i);
                }
            },
            /**
             * Store pointers to any connected child blocks.
             * @param {!Blockly.Block} containerBlock Root block in mutator.
             * @this Blockly.Block
             */
            saveConnections: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                var i = 0;
                while (itemBlock) {
                    var input = this.getInput('ADD' + i);
                    itemBlock.valueConnection_ = input && input.connection.targetConnection;
                    i++;
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
            },
            /**
             * Modify this block to have the correct number of inputs.
             * @private
             * @this Blockly.Block
             */
            updateShape_: function () {
                if (this.itemCount_ && this.getInput('EMPTY')) {
                    this.removeInput('EMPTY');
                } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
                    this.appendDummyInput('EMPTY')
                        .appendField(Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']);
                }
                // Add new inputs.
                for (var i = 0; i < this.itemCount_; i++) {
                    if (!this.getInput('ADD' + i)) {
                        var input = this.appendValueInput('ADD' + i);
                        if (i === 0) {
                            input.appendField('contains items');
                        }
                    }
                }
                // Remove deleted inputs.
                while (this.getInput('ADD' + i)) {
                    this.removeInput('ADD' + i);
                    i++;
                }
            }
        };
        Blockly.Python['lists_contains'] = function (block) {
            // Create a list with any number of elements of any type.
            const elements = new Array(block.itemCount_);
            const list = Blockly.Python.valueToCode(block, 'LIST', 0);
            for (let i = 0; i < block.itemCount_; i++) {
                elements[i] = Blockly.Python.valueToCode(block, 'ADD' + i,
                    Blockly.Python.ORDER_NONE) || 'null';
            }
            const code = 'all(item in ' + list + ' for item in ' + '[' + elements.join(',') + ']' + ')';
            return [code, Blockly.Python.ORDER_ATOMIC];
        };

        Blockly.Blocks['lists_splice'] = {
            init: function () {
                this.appendValueInput('list')
                    .setCheck(null)
                    .appendField('in list');
                this.appendValueInput('start_index')
                    .setCheck(null)
                    .appendField('splice from');
                this.appendValueInput('end_index')
                    .setCheck(null)
                    .appendField('to');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(260);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['lists_splice'] = function (authBlock) {
            const list = Blockly.Python.valueToCode(authBlock, 'list', 0);
            const startIndex = Blockly.Python.valueToCode(authBlock, 'start_index', 0);
            const endIndex = Blockly.Python.valueToCode(authBlock, 'end_index', 0);
            const code = list + '[' + startIndex + ':' + endIndex + ']';
            return [code, Blockly.Python.ORDER_NONE];
        };

        Blockly.Blocks['form_data'] = {
            init: function () {
                this.setHelpUrl('');
                this.setStyle('list_blocks');
                this.itemCount_ = 1;
                this.updateShape_();
                this.setOutput(true, 'Array');
                this.setColour(15);
                this.setMutator(new Blockly.Mutator(['lists_create_with_item']));
                this.setTooltip('Construct a Form Data');
            },
            mutationToDom: function () {
                var container = Blockly.utils.xml.createElement('mutation');
                container.setAttribute('items', this.itemCount_);
                return container;
            },
            domToMutation: function (xmlElement) {
                this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10);
                this.updateShape_();
            },
            decompose: function (workspace) {
                var containerBlock = workspace.newBlock('lists_create_with_container');
                containerBlock.initSvg();
                var connection = containerBlock.getInput('STACK').connection;
                for (var i = 0; i < this.itemCount_; i++) {
                    var itemBlock = workspace.newBlock('lists_create_with_item');
                    itemBlock.initSvg();
                    connection.connect(itemBlock.previousConnection);
                    connection = itemBlock.nextConnection;
                }
                return containerBlock;
            },
            compose: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                // Count number of inputs.
                var connections = [];
                while (itemBlock) {
                    connections.push(itemBlock.valueConnection_);
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
                // Disconnect any children that don't belong.
                for (var i = 0; i < this.itemCount_; i++) {
                    var connection = this.getInput('ADD' + i).connection.targetConnection;
                    if (connection && connections.indexOf(connection) === -1) {
                        connection.disconnect();
                    }
                }
                this.itemCount_ = connections.length;
                this.updateShape_();
                // Reconnect any child blocks.
                for (var i = 0; i < this.itemCount_; i++) {
                    Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i);
                }
            },
            saveConnections: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                var i = 0;
                while (itemBlock) {
                    var input = this.getInput('ADD' + i);
                    itemBlock.valueConnection_ = input && input.connection.targetConnection;
                    i++;
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
            },
            updateShape_: function () {
                if (this.itemCount_ && this.getInput('EMPTY')) {
                    this.removeInput('EMPTY');
                } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
                    this.appendDummyInput('EMPTY').appendField('create Form Data');
                    // .appendField(Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']);
                }
                // Add new inputs.
                for (var i = 0; i < this.itemCount_; i++) {
                    if (!this.getInput('ADD' + i)) {
                        var input = this.appendValueInput('ADD' + i);
                        if (i === 0) {
                            input.appendField('create Form Data');
                        }
                    }
                }
                // Remove deleted inputs.
                while (this.getInput('ADD' + i)) {
                    this.removeInput('ADD' + i);
                    i++;
                }
            }
        };

        Blockly.Python['form_data'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['form_data_pair'] = {
            init: function() {
                this.appendValueInput('A')
                    .setCheck('String');
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown([['Text', 'TEXT'], ['File', 'File']]), 'TYPE')
                    .appendField(':');
                this.appendValueInput('B')
                    .setCheck(null);
                this.setInputsInline(true);
                this.setColour(15);
                this.setTooltip('');
                this.setOutput(true, null);
                this.setHelpUrl('');
            }
        };

        Blockly.Python['form_data_pair'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['json_object'] = {
            init: function () {
                this.setHelpUrl(Blockly.Msg['LISTS_CREATE_WITH_HELPURL']);
                this.setStyle('list_blocks');
                this.itemCount_ = 3;
                this.updateShape_();
                this.setOutput(true, 'Array');
                this.setMutator(new Blockly.Mutator(['lists_create_with_item']));
                this.setTooltip('Construct a JSON Object with key value pairs');
            },
            mutationToDom: function () {
                var container = Blockly.utils.xml.createElement('mutation');
                container.setAttribute('items', this.itemCount_);
                return container;
            },
            domToMutation: function (xmlElement) {
                this.itemCount_ = parseInt(xmlElement.getAttribute('items'), 10);
                this.updateShape_();
            },
            decompose: function (workspace) {
                var containerBlock = workspace.newBlock('lists_create_with_container');
                containerBlock.initSvg();
                var connection = containerBlock.getInput('STACK').connection;
                for (var i = 0; i < this.itemCount_; i++) {
                    var itemBlock = workspace.newBlock('lists_create_with_item');
                    itemBlock.initSvg();
                    connection.connect(itemBlock.previousConnection);
                    connection = itemBlock.nextConnection;
                }
                return containerBlock;
            },
            compose: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                // Count number of inputs.
                var connections = [];
                while (itemBlock) {
                    connections.push(itemBlock.valueConnection_);
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
                // Disconnect any children that don't belong.
                for (var i = 0; i < this.itemCount_; i++) {
                    var connection = this.getInput('ADD' + i).connection.targetConnection;
                    if (connection && connections.indexOf(connection) === -1) {
                        connection.disconnect();
                    }
                }
                this.itemCount_ = connections.length;
                this.updateShape_();
                // Reconnect any child blocks.
                for (var i = 0; i < this.itemCount_; i++) {
                    Blockly.Mutator.reconnect(connections[i], this, 'ADD' + i);
                }
            },
            saveConnections: function (containerBlock) {
                var itemBlock = containerBlock.getInputTargetBlock('STACK');
                var i = 0;
                while (itemBlock) {
                    var input = this.getInput('ADD' + i);
                    itemBlock.valueConnection_ = input && input.connection.targetConnection;
                    i++;
                    itemBlock = itemBlock.nextConnection &&
                        itemBlock.nextConnection.targetBlock();
                }
            },
            updateShape_: function () {
                if (this.itemCount_ && this.getInput('EMPTY')) {
                    this.removeInput('EMPTY');
                } else if (!this.itemCount_ && !this.getInput('EMPTY')) {
                    this.appendDummyInput('EMPTY').appendField('create JSON object');
                    // .appendField(Blockly.Msg['LISTS_CREATE_EMPTY_TITLE']);
                }
                // Add new inputs.
                for (var i = 0; i < this.itemCount_; i++) {
                    if (!this.getInput('ADD' + i)) {
                        var input = this.appendValueInput('ADD' + i);
                        if (i === 0) {
                            input.appendField('create JSON object');
                        }
                    }
                }
                // Remove deleted inputs.
                while (this.getInput('ADD' + i)) {
                    this.removeInput('ADD' + i);
                    i++;
                }
            }
        };

        Blockly.JavaScript['json_object'] = function (block) {
            // Create a list with any number of elements of any type.
            const elements = new Array(block.itemCount_);
            for (let i = 0; i < block.itemCount_; i++) {
                elements[i] = Blockly.JavaScript.valueToCode(block, 'ADD' + i,
                    Blockly.JavaScript.ORDER_COMMA) || 'null';
            }
            const code = '{' + elements.join(', ') + '}';
            return [code, Blockly.JavaScript.ORDER_ATOMIC];
        };

        Blockly.Python['json_object'] = function (block) {
            // Create a list with any number of elements of any type.
            const elements = new Array(block.itemCount_);
            for (let i = 0; i < block.itemCount_; i++) {
                elements[i] = Blockly.Python.valueToCode(block, 'ADD' + i,
                    Blockly.Python.ORDER_NONE) || 'null';
            }
            const code = '{' + elements.join(', ') + '}';
            return [code, Blockly.Python.ORDER_ATOMIC];
        };

        Blockly.Blocks['get_keys_from_json_object'] = {
            init: function () {
                this.appendValueInput('NAME')
                    .setCheck(null)
                    .setAlign(Blockly.ALIGN_CENTRE)
                    .appendField(' get keys from JSON object');
                this.setOutput(true, null);
                this.setColour(330);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['get_keys_from_json_object'] = function (authBlock) {
            const input = Blockly.Python.valueToCode(authBlock, 'NAME', 0);
            const code = input + '.keys()';
            return [code, Blockly.Python.ORDER_NONE];
        };

        Blockly.Blocks['get_a_key_from_json_object'] = {
            init: function () {
                this.appendValueInput('key')
                    .setCheck(null)
                    .setAlign(Blockly.ALIGN_CENTRE)
                    .appendField(' get value of key');
                this.appendValueInput('object')
                    .setCheck(null)
                    .appendField('from JSON object');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(45);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['get_a_key_from_json_object'] = function (authBlock) {
            const key = Blockly.Python.valueToCode(authBlock, 'key', 0);
            const object = Blockly.Python.valueToCode(authBlock, 'object', 0);
            const code = object + '[' + key + ']';
            return [code, Blockly.Python.ORDER_NONE];
        };

        Blockly.Blocks['execute_api'] = {
            init: function () {
                this.appendValueInput('NAME')
                    .setCheck(null)
                    .setAlign(Blockly.ALIGN_CENTRE)
                    .appendField('execute API');
                this.setOutput(true, null);
                this.setColour(315);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['execute_api'] = function (authBlock) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_json'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('parse string to JSON');
                this.setOutput(true, null);
                this.setColour(120);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['parse_json'] = function (authBlock) {
            Blockly.Python.definitions_['import_json'] = 'import json';
            const string = Blockly.Python.valueToCode(authBlock, 'Name', 0);
            const code = 'json.loads(' + string + ')';
            return [code, Blockly.Python.ORDER_NONE];
        };

        Blockly.Blocks['parse_int'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Integer of');
                this.setOutput(true, null);
                this.setColour(130);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_int'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['int(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_long'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Long of');
                this.setOutput(true, null);
                this.setColour(140);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_long'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['int(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_double'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Double of');
                this.setOutput(true, null);
                this.setColour(150);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_double'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['float(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_string'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('String of');
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_string'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['str(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_base64_as_string'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('String of base64');
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_base64_as_string'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['base64.b64decode(' + text + ').decode(\'utf-8\')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_boolean'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Boolean of');
                this.setOutput(true, null);
                this.setColour(170);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_boolean'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['bool(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_date'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Date of');
                this.setOutput(true, null);
                this.setColour(180);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_date'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            Blockly.Python.definitions_['import_datetime'] = 'from datetime import datetime';
            return ['datetime.fromtimestamp(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['text_get_ascii_code'] = {
            init: function () {
                this.appendValueInput('character')
                    .setCheck(null)
                    .appendField('get ASCII value of character');
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['text_get_ascii_code'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'character',
                Blockly.Python.ORDER_NONE) || '';
            return ['ord(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_timestamp'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Timestamp of');
                this.setOutput(true, null);
                this.setColour(190);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_timestamp'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            Blockly.Python.definitions_['import_datetime'] = 'from datetime import datetime';
            return ['datetime.timestamp(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_float'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Float of');
                this.setOutput(true, null);
                this.setColour(200);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_float'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['float(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_character'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Character of');
                this.setOutput(true, null);
                this.setColour(210);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_character'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['\'' + text + '\'', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_byte'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Byte of');
                this.setOutput(true, null);
                this.setColour(220);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_byte'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return [text, Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_short'] = {
            init: function () {
                this.appendValueInput('Name')
                    .setCheck(null)
                    .appendField('Short of');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_short'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            return ['int(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_datatype'] = {
            init: function () {
                this.appendValueInput('value')
                    .setCheck(null)
                    .appendField('Datatype of');
                this.setInputsInline(false);
                this.setOutput(true, null);
                this.setColour(0);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_datatype'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'Name',
                Blockly.Python.ORDER_NONE) || '';
            Blockly.Python.definitions_['import_datetime'] = 'from datetime import datetime';
            return ['type(' + text + ')', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['pass_parameters_to_api_executor'] = {
            init: function () {
                this.appendValueInput('NAME')
                    .setCheck(null)
                    .appendField('pass dynamic parameters to API executor');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['pass_parameters_to_api_executor'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['connect_workbook'] = {
            init: function () {
                this.appendValueInput('connection')
                    .setCheck(null)
                    .appendField('Connect Workbook');
                this.appendStatementInput('statements')
                    .setCheck(null)
                    .appendField('do');
                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(0);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['connect_workbook'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['read_worksheet_cell'] = {
            init: function () {
                this.appendValueInput('worksheet')
                    .setCheck(null)
                    .appendField('(Read cell) From worksheet');
                this.appendValueInput('row')
                    .setCheck(null)
                    .appendField('Row');
                this.appendValueInput('column')
                    .setCheck(null)
                    .appendField('Column');
                this.setInputsInline(false);
                this.setOutput(true, null);
                this.setColour(180);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_worksheet_cell'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['write_cell_to_worksheet'] = {
            init: function () {
                this.appendValueInput('worksheet')
                    .setCheck(null)
                    .appendField('(Write Cell) Worksheet');
                this.appendValueInput('row')
                    .setCheck(null)
                    .appendField('Row');
                this.appendValueInput('column')
                    .setCheck(null)
                    .appendField('Column');
                this.appendValueInput('value')
                    .setCheck(null)
                    .appendField('Value');
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['write_cell_to_worksheet'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['worksheet_url'] = {
            init: function () {
                this.appendValueInput('worksheet_url')
                    .setCheck(null)
                    .appendField('worksheet URL');
                this.setOutput(true, null);
                this.setColour(120);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['worksheet_url'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['current_timestamp'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('current timestamp');
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['current_timestamp'] = function (block) {
            Blockly.Python.definitions_['import_time'] = 'import time';
            Blockly.Python.definitions_['import_datetime'] = 'from datetime import datetime';
            const functionName = Blockly.Python.provideFunction_(
                'current_timestamp',
                ['def ' + Blockly.Python.FUNCTION_NAME_PLACEHOLDER_ + '():',
                    Blockly.Python.INDENT + 'ms = datetime.now()',
                    Blockly.Python.INDENT + 'return (int(time.mktime(ms.timetuple()) * 1000))']);
            return [functionName + '()', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['current_date'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('current date');
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['current_date'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['current_date_with_format'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('current date');
                this.appendValueInput('format')
                    .setCheck(null)
                    .appendField('with format');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['current_date_with_format'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['current_date_time'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('current date time');
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['current_date_time'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['current_date_time_with_format'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('current date time');
                this.appendValueInput('format')
                    .setCheck(null)
                    .appendField('with format');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['current_date_time_with_format'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['date_arithmetic'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown([['add', 'add'], ['subtract', 'subtract']]), 'operation');
                this.appendValueInput('value')
                    .setCheck('Number')
                    .appendField('value');
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown([['years', 'years'], ['months', 'months'], ['days', 'days'], ['hours', 'hours'], ['minutes', 'minutes'], ['seconds', 'seconds']]), 'unit');
                this.appendDummyInput()
                    .appendField('to/from');
                this.appendValueInput('datefield')
                    .setCheck(null)
                    .appendField('date');

                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['date_arithmetic'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['get_date_attribute'] = {
            init: function () {
                this.appendDummyInput().appendField('get')
                    .appendField(new Blockly.FieldDropdown([['year', 'year'], ['month', 'month'], ['day', 'day'], ['dayOfYear', 'dayOfYear'], ['dayOfMonth', 'dayOfMonth'], ['dayOfWeek', 'dayOfWeek'], ['hour', 'hour'], ['minute', 'minute'], ['second', 'second'], ['nano', 'nano']]), 'attribute');
                this.appendDummyInput()
                    .appendField('of date');
                this.appendValueInput('datefield')
                    .setCheck(null);
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['get_date_attribute'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_date_from_string_with_format'] = {
            init: function () {
                this.appendValueInput('datefield')
                    .setCheck(null)
                    .appendField('parse string');
                this.appendValueInput('format')
                    .setCheck(null)
                    .appendField('to date with format');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['parse_date_from_string_with_format'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['format_date_with_string_formatter'] = {
            init: function () {
                this.appendValueInput('datefield')
                    .setCheck(null)
                    .appendField('format datefield');
                this.appendValueInput('format')
                    .setCheck(null)
                    .appendField('with format');
                this.appendDummyInput()
                    .appendField('returns string');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['format_date_with_string_formatter'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['parse_date_from_string'] = {
            init: function () {
                this.appendValueInput('datefield')
                    .setCheck(null)
                    .appendField('parse string');
                this.appendDummyInput()
                    .appendField('to date at yyyy-MM-dd');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(240);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['parse_date_from_string'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['code_variables'] = {
            length: 0,
            init: function () {
                this.setColour(330);
                this.setOutput(true, ['element']);

                this.appendDummyInput('open_bracket')
                    .appendField(' ( ')
                    .appendField(new BlocklyFieldTextbutton('+', function () {
                        this.sourceBlock_.appendVariable();
                    }));

                this.appendDummyInput('close_bracket')
                    .appendField(' ) ');

                this.setInputsInline(false);
                this.setDeletable(false);
                this.setMovable(false);
            },

            appendVariableWrapper: function () {

                const lastIndex = this.length++;

                const appended_input = this.appendDummyInput('element_' + lastIndex);
                const fieldTextButton = new BlocklyFieldTextbutton('–', function () {
                    this.sourceBlock_.deleteVariable(appended_input);
                });

                appended_input.appendField(fieldTextButton)
                    .appendField(new Blockly.FieldVariable('item'), 'element_' + lastIndex);

                this.moveInputBefore('element_' + lastIndex, 'close_bracket');

                return [appended_input, appended_input.fieldRow[1]];
            },
            appendVariable: function () {
                const appended_input = this.appendVariableWrapper();
                return appended_input[0];
            },

            deleteVariable: function (inputToDelete) {

                const inputNameToDelete = inputToDelete.name;
                const substructure = this.getInputTargetBlock(inputNameToDelete);
                if (substructure) {
                    substructure.dispose(true, true);
                }
                this.removeInput(inputNameToDelete);
                const inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0], 2);
                const lastIndex = --this.length;
                for (let i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent element-inputs
                    const input = this.getInput('element_' + i);
                    input.name = 'element_' + (i - 1);
                }
            },
            // !important - need to override the default - so we can add the dynamic fields
            getField: function (key) {
                for (let b = 0, c; c = this.inputList[b]; b++) {
                    for (let d = 0, e; e = c.fieldRow[d]; d++) {
                        if (e.name === key) {
                            return e;
                        }
                    }
                }
                const added = this.appendVariableWrapper();
                return added[1];
            },
        };

        Blockly.Python['code_variables'] = function (block) {
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['code_libraries'] = {
            length: 0,
            init: function () {
                this.setColour(330);
                this.setOutput(true, ['string']);
                this.appendDummyInput('open_bracket')
                    .appendField(' ( ')
                    .appendField(new BlocklyFieldTextbutton('+', function () {
                        this.sourceBlock_.appendString();
                    }));

                this.appendDummyInput('close_bracket')
                    .appendField(' ) ');

                this.setInputsInline(false);
                this.setDeletable(false);
                this.setMovable(false);
            },

            appendStringWrapper: function () {

                const lastIndex = this.length++;

                const appended_input = this.appendDummyInput('lib_' + lastIndex);
                const fieldTextButton = new BlocklyFieldTextbutton('–', function () {
                    this.sourceBlock_.deleteString(appended_input);
                });

                appended_input.appendField(fieldTextButton)
                    .appendField(new Blockly.FieldTextInput(''), 'lib_' + lastIndex);

                this.moveInputBefore('lib_' + lastIndex, 'close_bracket');

                return [appended_input, appended_input.fieldRow[1]];
            },
            appendString: function () {
                const appended_input = this.appendStringWrapper();
                return appended_input[0];
            },

            deleteString: function (inputToDelete) {

                const inputNameToDelete = inputToDelete.name;
                this.removeInput(inputNameToDelete);
                const inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0], 2);
                const lastIndex = --this.length;
                for (let i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent string-inputs
                    const input = this.getInput('lib_' + i);
                    input.name = 'lib_' + (i - 1);
                }
            },
            // !important - need to override the default - so we can add the dynamic fields
            getField: function (key) {
                for (let b = 0, c; c = this.inputList[b]; b++) {
                    for (let d = 0, e; e = c.fieldRow[d]; d++) {
                        if (e.name === key) {
                            return e;
                        }
                    }
                }
                const added = this.appendStringWrapper();
                return added[1];
            },

            updateStringValues: function (values) {
                // values is the array of objects you want to update the string values with
                if (values) {
                    // remove excess string inputs if needed
                    for (let i = 0; i < this.length; i++) {
                        this.deleteString(this.getInput('lib_' + i));
                    }
                    const newValues = [];
                    for (let i = 0; i < values.length; i++) {
                        const value = values[i];
                        if (typeof value === 'object') {
                            try {
                                newValues.push(JSON.stringify(value));
                            } catch {}
                        }
                    }
                    for (let i = 0; i < newValues.length; i++) {
                        const value = newValues[i];
                        const stringInput = this.getInput('lib_' + i);
                        if (stringInput) {
                            stringInput.fieldRow[1].setValue(value);
                        } else {
                            this.appendStringWrapper()[1].setValue(value);
                        }
                    }

                }
            },

            getValuesOfLibraries: function () {
                const values = [];
                for (let i = 0; i < this.length; i++) {
                    const stringInput = this.getInput('lib_' + i);
                    if (stringInput) {
                        try {
                            values.push(JSON.parse(stringInput.fieldRow[1].getValue()));
                        } catch (e) {
                            console.error('Error parsing JSON string:', e);
                        }
                    }
                }
                return values;
            },
        };

        Blockly.Python['code_libraries'] = function (block) {
            const code = '...\n';
            return code;
        };


        Blockly.Blocks['code_editor'] = {

            init: function () {
                this.setOutput(true, ['element']);
                this.setColour(330);
                this.appendDummyInput()
                    .appendField(new CodeDisplayField('', null, null),
                        'CODE')
                    .appendField(new BlocklyFieldImagebutton('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAhElEQVRIie2TwQnAIAxF35Klh3YBdxDqPh3HQdq7gj00ooi3xkvxQ0BzeD8JfJh6ZYEbWEfAHZCkIrCPgAfgrN4qm9STG+llk0sTngAvJkH+VgMeBOobM6cFz3c22vAIbNJbKGc5JnzCfwCHEpgcorWCfwpRawDKk7cGdanBewaq8KmuHlYrZbGe+TNUAAAAAElFTkSuQmCC', function () {
                        const block = this.sourceBlock_;

                        if (block.isInFlyout) {
                            return;
                        }
                        const code = block.getFieldValue('CODE');

                        const parentBlock = block.getParent();

                        let language = '';
                        if (parentBlock.type === 'code_executor') {
                            language = parentBlock.getFieldValue('LANGUAGE');
                        } else if (parentBlock.type === 'python_code_executor') {
                            language = 'PYTHON';
                        }

                        const libBlock = parentBlock.getInputTargetBlock('LIBRARIES');
                        let libsEnabled = false;
                        if (libBlock) {
                            libsEnabled = true;
                        }

                        const input = {code: code,
                            language: language
                        };
                        if (libsEnabled) {
                            input['enableLibraries'] = true;
                            input['libraries'] = that.blComponentDataService.jsScriptLibs;
                            input['selectedLibraries'] = libBlock.getValuesOfLibraries();
                        }
                        const dialogRef = that.dialog.open(BlockCodeEditorComponent, {
                            width: '80%',
                            height: '80%',
                            data: input
                        });

                        dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                if (result.code) {
                                    block.setFieldValue(result.code, 'CODE');
                                }
                                if (libsEnabled && result.selectedLibraries) {
                                    libBlock.updateStringValues(result.selectedLibraries);
                                }
                            }
                        });
                    }));
                // .appendField(OpenCodeEditorOnBlock(that.dialog));

                this.setDeletable(false);
                this.setMovable(false);
            }
        };

        Blockly.Python['code_editor'] = function (block) {
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['code_executor'] = {
            init: function () {
                const blockThis = this;
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown([['Java Script', 'JAVASCRIPT'], ['Python', 'PYTHON']]), 'LANGUAGE');

                this.appendValueInput('INPUT_VARIABLES')
                    .appendField('Input Variables');

                const input_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('INPUT_VARIABLES').connection.connect(input_variables.outputConnection);

                this.appendValueInput('SCRIPT')
                    .appendField('Code');
                const code_block = blockThis.workspace.newBlock('code_editor');
                blockThis.getInput('SCRIPT').connection.connect(code_block.outputConnection);

                this.appendValueInput('OUTPUT_VARIABLES')
                    .appendField('Output Variables');

                const output_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('OUTPUT_VARIABLES').connection.connect(output_variables.outputConnection);

                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(330);
                this.setTooltip('');
                this.setHelpUrl('');
            },
        };
        Blockly.Python['code_executor'] = function (block) {
            // var dropdown_language = block.getFieldValue('LANGUAGE');
            // var text_name = block.getFieldValue('NAME');
            // var variable_name = Blockly.Python.nameDB_.getName(block.getFieldValue('NAME'), Blockly.Variables.NAME_TYPE);
            // TODO: Assemble Python into code variable.
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['javascript_code_executor'] = {
            init: function () {
                const blockThis = this;
                this.appendDummyInput()
                    .appendField('Javascript (Advanced)');

                this.appendValueInput('INPUT_VARIABLES')
                    .appendField('Input Variables');

                const input_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('INPUT_VARIABLES').connection.connect(input_variables.outputConnection);

                this.appendValueInput('SCRIPT')
                    .appendField('Code');
                const code_block = blockThis.workspace.newBlock('code_editor');
                blockThis.getInput('SCRIPT').connection.connect(code_block.outputConnection);

                this.appendValueInput('OUTPUT_VARIABLES')
                    .appendField('Output Variables');

                const output_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('OUTPUT_VARIABLES').connection.connect(output_variables.outputConnection);


                this.appendValueInput('LIBRARIES')
                    .appendField('')
                    .setCheck(null)
                    .setVisible(false);

                const library_inputs = blockThis.workspace.newBlock('code_libraries');
                blockThis.getInput('LIBRARIES').connection.connect(library_inputs.outputConnection);

                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(330);
                this.setTooltip('');
                this.setHelpUrl('');
            },
        };
        Blockly.Python['javascript_code_executor'] = function (block) {
            // var dropdown_language = block.getFieldValue('LANGUAGE');
            // var text_name = block.getFieldValue('NAME');
            // var variable_name = Blockly.Python.nameDB_.getName(block.getFieldValue('NAME'), Blockly.Variables.NAME_TYPE);
            // TODO: Assemble Python into code variable.
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['python_code_executor'] = {
            init: function () {
                const blockThis = this;
                this.appendDummyInput()
                    .appendField('Python')
                    .appendField(new Blockly.FieldDropdown([['3.6', '3.6'], ['3.7', '3.7'], ['3.8', '3.8'], ['3.9', '3.9'], ['3.10', '3.10']]), 'VERSION');

                this.appendValueInput('INPUT_VARIABLES')
                    .appendField('Input Variables');

                const input_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('INPUT_VARIABLES').connection.connect(input_variables.outputConnection);

                this.appendValueInput('SCRIPT')
                    .appendField('Code');
                const code_block = blockThis.workspace.newBlock('code_editor');
                blockThis.getInput('SCRIPT').connection.connect(code_block.outputConnection);

                this.appendValueInput('OUTPUT_VARIABLES')
                    .appendField('Output Variables');

                const output_variables = blockThis.workspace.newBlock('code_variables');
                blockThis.getInput('OUTPUT_VARIABLES').connection.connect(output_variables.outputConnection);

                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(330);
                this.setTooltip('');
                this.setHelpUrl('');
            },
        };
        Blockly.Python['python_code_executor'] = function (block) {
            // var dropdown_language = block.getFieldValue('LANGUAGE');
            // var text_name = block.getFieldValue('NAME');
            // var variable_name = Blockly.Python.nameDB_.getName(block.getFieldValue('NAME'), Blockly.Variables.NAME_TYPE);
            // TODO: Assemble Python into code variable.
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['code_executor_language'] = {
            inputLength: 0,
            outputLength: 0,
            init: function () {
                this.appendDummyInput()
                    .appendField(new Blockly.FieldDropdown([['Java Script', 'JAVASCRIPT']]), 'LANGUAGE');
                this.appendDummyInput('input_start')
                    .appendField('Variables: ')
                    .appendField(' ( ').appendField(new BlocklyFieldTextbutton('+', function () {
                    this.sourceBlock_.appendInputVariable();
                }));
                this.appendDummyInput('input_end')
                    .appendField(' ) ');
                this.appendDummyInput();

                this.appendDummyInput()
                    .appendField('Code: ')
                    .appendField(new CodeDisplayField('// Enter your code here', null, null),
                        'CODE')
                    .appendField(OpenCodeEditorOnBlock(that.dialog));
                this.appendDummyInput();

                this.appendDummyInput('output_start')
                    .appendField('Output Variables: ')
                    .appendField(' ( ').appendField(new BlocklyFieldTextbutton('+', function () {
                    this.sourceBlock_.appendOutputVariable();
                }));
                this.appendDummyInput('output_end')
                    .appendField(' ) ');

                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(330);
                this.setTooltip('');
                this.setHelpUrl('');
            },

            appendInputVariableWrapper: function () {

                const lastIndex = this.inputLength++;

                const appended_input = this.appendDummyInput('input_var_' + lastIndex);
                // .setAlign(Blockly.ALIGN_RIGHT);
                const fieldTextButton = new BlocklyFieldTextbutton('–', function () {
                    this.sourceBlock_.deleteInputVariable(appended_input);
                });

                appended_input.appendField(fieldTextButton)
                    .appendField(new Blockly.FieldVariable('item'), 'INPUT_VAR_NAME');

                this.moveInputBefore('input_var_' + lastIndex, 'input_end');

                return [appended_input, appended_input.fieldRow[1]];
            },
            appendInputVariable: function () {
                const appended_input = this.appendInputVariableWrapper();
                return appended_input[0];
            },
            deleteInputVariable: function (inputToDelete) {
                const inputNameToDelete = inputToDelete.name;

                const substructure = this.getInputTargetBlock(inputNameToDelete);
                if (substructure) {
                    substructure.dispose(true, true);
                }
                this.removeInput(inputNameToDelete);

                const inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0], 2);

                const lastIndex = --this.inputLength;

                for (let i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent element-inputs
                    const input = this.getInput('input_var_' + i);

                    input.name = 'input_var_' + (i - 1);
                }
            },
            appendOutputVariableWrapper: function () {

                const lastIndex = this.outputLength++;

                const appended_input = this.appendDummyInput('output_var_' + lastIndex);
                const fieldTextButton = new BlocklyFieldTextbutton('–', function () {
                    this.sourceBlock_.deleteOutputVariable(appended_input);
                });

                appended_input.appendField(fieldTextButton)
                    .appendField(new Blockly.FieldVariable('item'), 'OUTPUT_VAR_NAME');

                this.moveInputBefore('output_var_' + lastIndex, 'output_end');

                return [appended_input, appended_input.fieldRow[1]];
            },
            appendOutputVariable: function () {
                const appended_input = this.appendOutputVariableWrapper();
                return appended_input[0];
            },
            deleteOutputVariable: function (inputToDelete) {
                const inputNameToDelete = inputToDelete.name;

                const substructure = this.getInputTargetBlock(inputNameToDelete);
                if (substructure) {
                    substructure.dispose(true, true);
                }
                this.removeInput(inputNameToDelete);

                const inputIndexToDelete = parseInt(inputToDelete.name.match(/\d+/)[0], 2);

                const lastIndex = --this.outputLength;

                for (let i = inputIndexToDelete + 1; i <= lastIndex; i++) { // rename all the subsequent element-inputs
                    const input = this.getInput('output_var_' + i);

                    input.name = 'output_var_' + (i - 1);
                }
            },
        };

        Blockly.Python['code_executor_language'] = function (block) {
            const code = '...\n';
            return code;
        };


        Blockly.Blocks['text_random'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Random string of');
                this.appendValueInput('NAME')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Length: ');
                this.appendDummyInput()
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Letters:')
                    .appendField(new Blockly.FieldCheckbox('TRUE'), 'LETTERS')
                    .appendField('Numbers:')
                    .appendField(new Blockly.FieldCheckbox('TRUE'), 'NUMBERS');
                this.setOutput(true, 'String');
                this.setColour(160);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['text_random'] = function(block) {
            const number_length = block.getFieldValue('LENGTH');
            const checkbox_letters = block.getFieldValue('LETTERS') === 'TRUE';
            const checkbox_numbers = block.getFieldValue('NUMBERS') === 'TRUE';
            // TODO: Assemble Python into code variable.
            const code = '...';
            // TODO: Change ORDER_NONE to the correct strength.
            return [code, Blockly.Python.ORDER_NONE];
        };

        Blockly.Blocks['accelerator_variables'] = {
            init: function () {
                this.setColour(345);
                this.setOutput(true);
                this.appendDummyInput()
                    .appendField('Variable:')
                    .appendField(new Blockly.FieldDropdown(that.acceleratorVariablesList), 'MODE');
            },
            onchange: function (event) {
            }
        };

        Blockly.Python['accelerator_variables'] = function (block) {
            const code = '...\n';
            return [code, Blockly.JavaScript.ORDER_NONE];
        };

        Blockly.Blocks['accelerator_connector_variables'] = {
            init: function () {
                this.setColour(285);
                this.setOutput(true);
                this.appendDummyInput()
                    .appendField('Connector:')
                    .appendField(new Blockly.FieldDropdown(that.acceleratorConnectorVariablesList), 'MODE');
            },
            onchange: function (event) {
            }
        };

        Blockly.Python['accelerator_connector_variables'] = function (block) {
            const code = '...\n';
            return [code, Blockly.JavaScript.ORDER_NONE];
        };


        Blockly.Blocks['alert'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Alert to')
                    .appendField(new Blockly.FieldDropdown(that.blComponentDataService.alertsTopicAttributeData), 'TOPIC');
                this.appendValueInput('TITLE')
                    .setCheck('String')
                    .appendField('Title');
                this.appendValueInput('MESSAGE')
                    .setCheck('String')
                    .appendField('Message');
                this.appendDummyInput()
                    .appendField('Log Level')
                    .appendField(new Blockly.FieldDropdown([['FATAL', 'FATAL'],
                        ['ERROR', 'ERROR'],
                        ['WARN', 'WARN'],
                        ['INFO', 'INFO'],
                        ['DEBUG', 'DEBUG'],
                        ['TRACE', 'TRACE'],
                        ['ALL', 'ALL']]),
                        'LOG_LEVEL');
                this.setInputsInline(false);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            },
            mutationToDom: function() {
                const container = document.createElement('mutation');
                container.setAttribute('partner', that.partner);
                container.setAttribute('account', that.account_id);
                container.setAttribute('pkey', that.partnerKey);
                return container;
            },
            domToMutation: function(xmlElement) {
            }
        };

        Blockly.Python['alert'] = function (block) {
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['trigger'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Trigger: ')
                    .appendField(new Blockly.FieldDropdown(that.blComponentDataService.triggersTopicAttributeData), 'TRIGGER_NAME');
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            },
            mutationToDom: function() {
                const container = document.createElement('mutation');
                container.setAttribute('partner', that.partner);
                container.setAttribute('account', that.account_id);
                container.setAttribute('pkey', that.partnerKey);
                return container;
            },
            domToMutation: function(xmlElement) {
            }
        };

        Blockly.Python['trigger'] = function (block) {
            const code = '...\n';
            return code;
        };

        Blockly.Blocks['cloudfront_url_signer'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Cloudfront URL Signer');
                this.appendValueInput('CLOUDFRONT_KEYPAIR_ID')
                    .setCheck('String')
                    .appendField('Cloudfront Keypair ID');
                this.appendValueInput('PRIVATE_KEY')
                    .setCheck('String')
                    .appendField('Private Key (as String)');
                this.appendValueInput('TIMESTAMP')
                    .setCheck('Number')
                    .appendField('Date less than (timestamp)');
                this.appendValueInput('URL')
                    .setCheck('String')
                    .appendField('URL');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['cloudfront_url_signer'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['file_size_of'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Size of (File): ');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['file_size_of'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['file_name_of'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Name of (File): ');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['file_name_of'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['file_extension_of'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Extension of (File): ');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['file_extension_of'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['file_mime_type_of'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('MIME Type of (File): ');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['file_mime_type_of'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };


        Blockly.Blocks['read_csv'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('read CSV');
                this.appendValueInput('url')
                    .setCheck(null)
                    .appendField('URL');
                this.appendValueInput('s3_connector')
                    .setCheck(null)
                    .appendField('S3 connector');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_csv'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };


        Blockly.Blocks['read_content_from_file_url'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('read content from file url');
                this.appendValueInput('url')
                    .setCheck(null)
                    .appendField('URL');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_content_from_file_url'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['read_file_as_text'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('read file as text');
                this.appendValueInput('url')
                    .setCheck(null)
                    .appendField('URL');
                this.appendValueInput('s3_connector')
                    .setCheck(null)
                    .appendField('S3 connector');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_file_as_text'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['stripe_construct_event'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Stripe construct event');
                this.appendValueInput('PAYLOAD')
                    .setCheck('String')
                    .appendField('Payload');
                this.appendValueInput('SIG')
                    .setCheck('String')
                    .appendField('Stripe Signature');
                this.appendValueInput('SECRET')
                    .setCheck('String')
                    .appendField('Secret');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['stripe_construct_event'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['nft_token_get_owner'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Get owner of NFT Token');
                this.appendValueInput('TOKEN_ID')
                    .setCheck('String')
                    .appendField('Token ID');
                this.appendValueInput('NFT_CONTRACT')
                    .setCheck(null)
                    .appendField('NFT Contract');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['nft_token_get_owner'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['nft_connect_to_contract'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Connect to NFT contract');
                this.appendDummyInput()
                    .appendField('Provider: ')
                    .appendField(new Blockly.FieldDropdown([['rinkeby', 'rinkeby']]), 'PROVIDER');
                this.appendValueInput('ADDRESS')
                    .setCheck('String')
                    .appendField('Address');
                this.appendValueInput('INTERFACE')
                    .setCheck('Array')
                    .appendField('Interface');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['nft_connect_to_contract'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['image_blur_with_coordinates'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Blur Image');
                this.appendValueInput('FILE')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Image');
                this.appendValueInput('X')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('x coordinate (Starting point)');
                this.appendValueInput('Y')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('y coordinate (Starting point)');
                this.appendValueInput('WIDTH')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('width (of blur in pixels)');
                this.appendValueInput('HEIGHT')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('height (of blur in pixels)');
                this.appendValueInput('BLUR_RADIUS')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Blur radius');
                this.setOutput(true, null);
                this.setColour(75);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['image_blur_with_coordinates'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['image_blur_full'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Blur Image');
                this.appendValueInput('FILE')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Image');
                this.appendValueInput('BLUR_RADIUS')
                    .setCheck('Number')
                    .setAlign(Blockly.ALIGN_RIGHT)
                    .appendField('Blur radius');
                this.setOutput(true, null);
                this.setColour(75);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['image_blur_full'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['image_get_width'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('get width of image');
                this.setOutput(true, null);
                this.setColour(75);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['image_get_width'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['image_get_height'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('get height of image');
                this.setOutput(true, null);
                this.setColour(75);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['image_get_height'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['write_csv'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('write CSV');
                this.appendValueInput('folder')
                    .setCheck(null)
                    .appendField('folder');
                this.appendValueInput('file_name')
                    .setCheck(null)
                    .appendField('file name');
                this.appendValueInput('column_order')
                    .setCheck(null)
                    .appendField('column order');
                this.appendValueInput('content')
                    .setCheck(null)
                    .appendField('content');
                this.appendValueInput('s3_connector')
                    .setCheck(null)
                    .appendField('S3 connector');
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['write_csv'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['read_csv_generic'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('read CSV');
                this.appendValueInput('folder')
                    .setCheck(null)
                    .appendField('folder');
                this.appendValueInput('file_name')
                    .setCheck(null)
                    .appendField('file name');
                this.appendValueInput('file_storage_connector')
                    .setCheck(null)
                    .appendField('file storage connector');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_csv_generic'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['write_csv_generic'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('write CSV');
                this.appendValueInput('folder')
                    .setCheck(null)
                    .appendField('folder');
                this.appendValueInput('file_name')
                    .setCheck(null)
                    .appendField('file name');
                this.appendValueInput('column_order')
                    .setCheck(null)
                    .appendField('column order');
                this.appendValueInput('content')
                    .setCheck(null)
                    .appendField('content');
                this.appendValueInput('file_storage_connector')
                    .setCheck(null)
                    .appendField('file storage connector');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['write_csv_generic'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['write_csv_block'] = {
            init: function () {
                this.appendDummyInput()
                    .appendField('write CSV');
                this.appendValueInput('folder')
                    .setCheck(null)
                    .appendField('folder');
                this.appendValueInput('file_name')
                    .setCheck(null)
                    .appendField('file name');
                this.appendValueInput('column_order')
                    .setCheck(null)
                    .appendField('column order');
                this.appendValueInput('content')
                    .setCheck(null)
                    .appendField('content');
                this.appendValueInput('s3_connector')
                    .setCheck(null)
                    .appendField('S3 connector');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['write_csv_block'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['pdf_file_encrypt'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Encrypt PDF File');
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('File');
                this.appendValueInput('PASSWORD')
                    .setCheck(null)
                    .appendField('Password');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['pdf_file_encrypt'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['pdf_file_decrypt'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('Unlock PDF File');
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('File');
                this.appendValueInput('PASSWORD')
                    .setCheck(null)
                    .appendField('Password');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['pdf_file_decrypt'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['pdf_file_get_no_of_pages'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Number of pages (PDF): ');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['pdf_file_get_no_of_pages'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['pdf_file_split_pages'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('In file (PDF)');
                this.appendValueInput('PAGE_START')
                    .setCheck('Number')
                    .appendField('split pages from');
                this.appendValueInput('PAGE_END')
                    .setCheck('Number')
                    .appendField('to');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['pdf_file_split_pages'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['xls_to_json'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Read Excel (xls)');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['xls_to_json'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['xlsx_to_json'] = {
            init: function() {
                this.appendValueInput('FILE')
                    .setCheck(null)
                    .appendField('Read Excel (xlsx)');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['xlsx_to_json'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
        Blockly.Blocks['parse_bearer_jwt_without_validation'] = {
            init: function() {
                this.appendValueInput('token')
                    .setCheck('String')
                    .appendField('Parse JWT Token (Bearer)');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['parse_bearer_jwt_without_validation'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['validate_jwt_bearer'] = {
            init: function() {
                this.appendDummyInput()
                    .appendField('is Valid JWT');
                this.appendDummyInput()
                    .appendField('Signature Algorithm')
                    .appendField(new Blockly.FieldDropdown([
                        ['HS256', 'HS256'],
                        ['HS384', 'HS384'],
                        ['HS512', 'HS152'],
                        ['RS256', 'RS256'],
                        ['RS384', 'RS384'],
                        ['RS512', 'RS512'],
                        ['ES256', 'ES256'],
                        ['ES384', 'ES384'],
                        ['ES512', 'ES512'],
                        ['PS256', 'PS256'],
                        ['PS384', 'PS384'],
                        ['PS512', 'PS512']]
                    ), 'ALGORITHM');
                this.appendValueInput('TOKEN')
                    .setCheck('String')
                    .appendField('Token (Bearer)');
                this.appendValueInput('SECRET')
                    .setCheck('String')
                    .appendField('Secret');
                this.appendValueInput('RSAPUBLICKEY')
                    .setCheck('String')
                    .appendField('RSA Public Key');
                this.setInputsInline(false);
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['validate_jwt_bearer'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['read_file_input_bytes'] = {
            init: function () {
                this.appendValueInput('read_file_input_bytes')
                    .setCheck(null)
                    .appendField('read file URL as bytes');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_file_input_bytes'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['read_file_as_base64'] = {
            init: function () {
                this.appendValueInput('URL')
                    .setCheck(null)
                    .appendField('read file URL as base64');
                this.setOutput(true, null);
                this.setColour(230);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['read_file_as_base64'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Python['connect_workbook'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };

        Blockly.Blocks['text_decode_base64'] = {
            init: function () {
                this.appendValueInput('text_decode_base64')
                    .setCheck(null)
                    .appendField('decode base64');
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('Decode base64 encoded string');
                this.setHelpUrl('');
            }
        };

        Blockly.JavaScript['text_decode_base64'] = function (block) {
            const text = Blockly.JavaScript.valueToCode(block, 'text_decode_base64',
                Blockly.Python.ORDER_FUNCTION_CALL) || '\'\'';
            return ['decodebase64(' + text + ')', Blockly.JavaScript.ORDER_MEMBER];
        };

        Blockly.Python['text_decode_base64'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'text_decode_base64',
                Blockly.Python.ORDER_FUNCTION_CALL) || '\'\'';
            Blockly.Python.definitions_['import_base64'] = 'import base64';
            return ['base64.b64decode(' + text + ')', Blockly.Python.ORDER_MEMBER];
        };


        Blockly.Blocks['text_decode_zip_content_bytes'] = {
            init: function () {
                this.appendValueInput('text_decode_zip_content_bytes')
                    .setCheck(null)
                    .appendField('decode ContentBytes of zip');
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('Decode ContentBytes of zip');
                this.setHelpUrl('');
            }
        };

        Blockly.Python['text_decode_zip_content_bytes'] = function (block) {
            const text = Blockly.Python.valueToCode(block, 'text_decode_zip_content_bytes',
                Blockly.Python.ORDER_FUNCTION_CALL) || '\'\'';
            return ['# Not implemented', Blockly.Python.ORDER_MEMBER];
        };

        Blockly.Blocks['replace_key_in_json'] = {
            init: function () {
                this.appendValueInput('KEY')
                    .setCheck(null)
                    .appendField('Replace key');
                this.appendValueInput('VALUE')
                    .setCheck(null)
                    .appendField('with value');
                this.appendValueInput('JSON')
                    .setCheck(null)
                    .appendField('in JSON ');
                this.setInputsInline(true);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(0);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['replace_key_in_json'] = function (authBlock) {
            const key = Blockly.Python.valueToCode(authBlock, 'KEY', 0);
            const value = Blockly.Python.valueToCode(authBlock, 'VALUE', 0);
            const object = Blockly.Python.valueToCode(authBlock, 'JSON', 0);
            const code = object + '[' + key + '] = ' + value + '\n';
            return code;
        };

        Blockly.Blocks['insert_key_value_pair_in_json'] = {
            init: function () {
                this.appendValueInput('KEY')
                    .setCheck(null)
                    .appendField('Insert key value pair');
                this.appendValueInput('JSON')
                    .setCheck(null)
                    .appendField('into JSON ');
                this.setInputsInline(true);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(0);
                this.setTooltip('Insert Key Value Pair into JSON');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['insert_key_value_pair_in_json'] = function (authBlock) {
            const keyValue = Blockly.Python.valueToCode(authBlock, 'KEY', 0);
            const object = Blockly.Python.valueToCode(authBlock, 'JSON', 0);
            const code = object + '.update({' + keyValue + '})\n';
            return code;
        };

        Blockly.Blocks['remove_key_from_json'] = {
            init: function () {
                this.appendValueInput('key')
                    .setCheck(null)
                    .appendField('Remove key');
                this.appendValueInput('json')
                    .setCheck(null)
                    .appendField('from JSON');
                this.setInputsInline(true);
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour(285);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['remove_key_from_json'] = function (authBlock) {
            const key = Blockly.Python.valueToCode(authBlock, 'key', 0);
            const object = Blockly.Python.valueToCode(authBlock, 'json', 0);
            const code = 'del ' + object + '[' + key + ']\n';
            return code;
        };

        Blockly.Blocks['text_substring_count'] = {
            init: function () {
                this.appendValueInput('substring')
                    .setCheck(null)
                    .appendField('get the count of');
                this.appendValueInput('from_text')
                    .setCheck(null)
                    .appendField('in');
                this.setInputsInline(true);
                this.setOutput(true, null);
                this.setColour(160);
                this.setTooltip('');
                this.setHelpUrl('');
            }
        };
        Blockly.Python['text_substring_count'] = function (block) {
            return ['# Not implemented', Blockly.Python.ORDER_FUNCTION_CALL];
        };
    }

    loadExecutorBlockBasedOnEntity(entityNames) {

        let name = entityNames.split('_');
        let xmlList = [];
        const that = this;

        this.blComponentDataService.myAPIsBlocksData.forEach((catExe) => {
            if (catExe && catExe['executors'] && catExe['executors'] !== null && catExe['executors'] !== undefined) {
                catExe.executors.forEach((exect) => {
                    if (exect && exect !== null && exect !== undefined && exect.executor_name && exect.executor_name != null) {
                        if (exect.executor_category === name[0] && exect.executor_version === name[1]) {
                            let params;
                            Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
                                init: function () {

                                    if (exect.executor_method_type === 'GET') {
                                        this.setColour(100);
                                    } else if (exect.executor_method_type === 'POST') {
                                        this.setColour(220);
                                    } else if (exect.executor_method_type === 'PUT') {
                                        this.setColour(45);
                                    } else if (exect.executor_method_type === 'DELETE') {
                                        this.setColour(0);
                                    } else {
                                        this.setColour(160);
                                    }
                                    this.setTooltip((exect.executor_category_group !== null ? exect.executor_category_group + ' > ' : null) + exect.executor_category);
                                    this.setNextStatement(true);
                                    this.setPreviousStatement(true);
                                    this.appendDummyInput()
                                        .appendField(exect.executor_name + '(' + exect.executor_version + ')')
                                        // .appendField(new BlocklyFieldImagebutton('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE00lEQVR4nO2aWWhdVRSGP6xJixm01qoYW4fYwRSxILGtig8VfFD0QWlFELHUJ/tisaDUAaR1qm2ijU8OLxWHN4cHp6JWwfqirVAFFa1DakUQ1CQ114yy4D+wPDl373PPPTdytT9ccnPX2sPaZ++1/rX2geP4f+AxYBKYTn3GgS00EQYzjEg+B2gSdAJTwCgwx/3eod8rwIk0AVZr5Q9myL6XbDn/Is4BNgMLI3obNNkXM2SvS7Yu0sdC4E5gESVjCXBEk/gFuDag+7j07suQPSzZg4H2a4GfpPcj0E1JuMAZ8bv+2l7vA+amdFuA96RzQ0ZfN0v2Zur8GFqBHc7b/VGmMd6IfTqw9wBj+u0zoAc4H3gK+NV5J2ubxnIn/1lP7yxgKfCJc9Fb5TQ+LMOYs1NGtDlZL/C1ZKMa3L5PAO8Dtwb6vR34WE91Wl5sRN+/AVY53faUMV1FDEkO7Z/AqRlyG+Q56QwDjwJn1Og8BmSI9bFHTyGNBZqD6dxWxBB7Al+pg50BvYs1WFF0pZ5CGrs0hy9Tu6ImXKLzMClvMtu4UmOPR4zNhQe0IkeqbLFG4RTgh4ArrxlGJ/arwxeYPbykMT/KcNV1BcTkwK2k8bjCOZHSAiLy8xMKUvNz6K8A+oHP5VpH9L1fshgW62za4p1OiXhGK7QtotcqlzoRoPEm2y3dEJ6W/vayjJinJ2ErdFrEiL0uSD4BXCqX2Sav86SLG3sjxiyVnh34E4pM/GRgjSLwLhdZ3460G3AR+KJI3EkSL3syIRyQ3jviYRu0OFmB8x/pabXMbipCvVdoy4xGjPDGVNTGuFo13BHYorZgj2Q1SljnMRG4PSKI1+vwhdCvtvY3L3arjbHomMe8EbhXOc5BLdi05jwDiaVF9uMXamtkMi9Wqc2hAuPNcfOdgaqCHBhWWyOSedGuNkMFx5xuhCFDBQzpdAlUQwzpqGNrmUeptUhRZGt1hAwZdx7qW+AVBcB1OWhCctgtTuRF4q7NxYewDLgJeAh4DTjskjKb8wxskd+u1OF+K3KtMRhf+yuH+91UxfVWNNe7Ymy3x63Cu2r8Vk53OhgxZqVLoS365wmIb2h3rAcuLFrgm6fqyVgkE2xxFKUiw1bLAbSLLQzoSSQUxdo0jKLUQ+BaZUCINI7rSbTkHHMbJWKJJjdUA43vk0ca1ueQDnboTCRY1Cga3+NoQR4uVS8u01gj2mKlYK74jXX8LLOH5zXmpzlyl1zod8WzIsGyKNpdEdAofF24WjGklHJMAfTqrNgcrinaiZX2j2pF7o4MFsoc8xTo7ExUw1bN4WiOK41MbFYHv1XJyOa7ks2IErMza+j/XBW+EybxchWP2OluAezOpGYsdhnjB6ly5VplaEki5ovYVvC+JdDvxowidpIGDAJXOd02jZ1khIUvfrqdMfsU2Xe6bHK/dM5TIEyuFaZUpM6KR/5aYYeuFbpdEXBS8WaBxqz7WiHLmKRIN6YyZroC2OIGvy6jr/WumJBua//f7+5ekrEGyyzS2ep+p46N4l8e0O0LOIjtOWhHryrviRFZF0Z1oUv3EydF9Da6+440XpXMmHUIbSr9FLrYKQtrNFmrxKRxWDKj4k3zwsCxFP1uuhcGcIlTU7/Cge4Tq71UE0xPj4P/CP4GdM3Fkxh1C08AAAAASUVORK5CYII=', function () {
                                        //     const block = this.sourceBlock_;
                                        //     if (block.isInFlyout) {
                                        //         return;
                                        //     }
                                        //     const headers = block.getInputTargetBlock('headers');
                                        //
                                        //     const headersData = that.getAPIBlockDataAsDetails(headers);
                                        //
                                        //     const headersvaluList = [
                                        //         {
                                        //             blockType: 'text',
                                        //             match: 'pkey',
                                        //             value: that.partnerKey
                                        //         },
                                        //         {
                                        //             blockType: 'text',
                                        //             match: 'apikey',
                                        //             value: that.apiKey
                                        //         }
                                        //     ];
                                        //
                                        //     for (const value of that.attributeList) {
                                        //         if (value[0] && value[1] && value[1] !== 'null') {
                                        //             headersvaluList.push({
                                        //                 blockType: 'attributes',
                                        //                 match: value[1],
                                        //                 value: value[0]
                                        //             });
                                        //         }
                                        //     }
                                        //
                                        //
                                        //
                                        //     const dialogRef = that.dialog.open(ApiBlockAdvancedSettingsComponent, {
                                        //         width: '80%',
                                        //         height: '80%',
                                        //         data: {
                                        //             headersData: headersData,
                                        //             headersvalueList: headersvaluList
                                        //         }
                                        //     });
                                        //
                                        //     dialogRef.afterClosed().subscribe(result => {
                                        //         if (result) {
                                        //             // block.setFieldValue(result, 'CODE');
                                        //         }
                                        //     });
                                        // }));


                                    this.appendValueInput('headers').appendField('headers');
                                    this.appendValueInput('parameters').appendField('parameters');
                                    this.appendValueInput('path_parameters').appendField('path_parameters');
                                    // this.appendValueInput('request_body').appendField('request_body');
                                    this.appendValueInput('authorization').appendField('authorization');

                                    const blockThis = this;
                                    if (exect.headers != null) {
                                        var headerBlock = blockThis.workspace.newBlock('json_object');
                                        headerBlock.itemCount_ = 0;
                                        headerBlock.updateShape_();
                                        var i = 0;
                                        exect.headers.forEach((attr) => {
                                            if (attr && attr.key && attr.key != null) {
                                                headerBlock.appendValueInput('ADD' + i);
                                                var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                                                var keyBlock = key_value_1.workspace.newBlock('text');
                                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                } else {
                                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                }

                                                headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                                                i++;
                                            }

                                        });
                                        headerBlock.itemCount_ = i;
                                        headerBlock.updateShape_();
                                        blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);

                                    } else {

                                    }
                                    if (exect.queryParams != null) {
                                        var queryParamsBlock = blockThis.workspace.newBlock('json_object');
                                        queryParamsBlock.itemCount_ = 0;
                                        queryParamsBlock.updateShape_();
                                        var j = 0;
                                        exect.queryParams.forEach((attr) => {
                                            if (attr && attr.key && attr.key != null) {
                                                queryParamsBlock.appendValueInput('ADD' + j);

                                                var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                                                var keyBlock = key_value_1.workspace.newBlock('text');
                                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                } else {
                                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                }

                                                queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                                                j++;
                                            }

                                        });
                                        queryParamsBlock.itemCount_ = j;
                                        queryParamsBlock.updateShape_();
                                        blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

                                    } else {

                                    }
                                    if (exect.pathParams != null) {
                                        var pathParamsBlock = blockThis.workspace.newBlock('json_object');
                                        pathParamsBlock.itemCount_ = 0;
                                        pathParamsBlock.updateShape_();
                                        var k = 0;
                                        exect.pathParams.forEach((attr) => {
                                            if (attr && attr.key && attr.key != null) {
                                                pathParamsBlock.appendValueInput('ADD' + k);
                                                var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                                                var keyBlock = key_value_1.workspace.newBlock('text');
                                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                } else {
                                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                                }
                                                // var valueBlock = key_value_1.workspace.newBlock('text');
                                                // valueBlock.setFieldValue(attr.value, 'TEXT');
                                                // key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                                                pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                                                k++;
                                            }

                                        });
                                        pathParamsBlock.itemCount_ = k;
                                        pathParamsBlock.updateShape_();
                                        blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
                                        // }

                                    } else {

                                    }
                                    if (exect.authModel) {
                                        if (that.blComponentDataService.authorizationTypesData) {
                                            that.blComponentDataService.authorizationTypesData.forEach(authBlock => {
                                                if (authBlock.name === exect.authModel.authType) {
                                                    var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                                                    const authAttributes = authBlock.authAttributes;
                                                    if (authAttributes) {
                                                        authAttributes.forEach(attribute => {
                                                            var dynItemBlock = dynBlock.workspace.newBlock('text');
                                                            dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                                                            dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);
                                                        });
                                                    }
                                                    blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                                                }
                                            });
                                        }
                                    }
                                    if (exect.requestBody != null) {
                                        if (exect.requestBody.hasOwnProperty('__zone_symbol__value')) {
                                            blockThis.appendValueInput(exect.requestBody['__zone_symbol__value'].key).appendField(exect.requestBody['__zone_symbol__value'].key);
                                        } else if (exect.requestBody.key && exect.requestBody.key != null) {
                                            blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
                                            // var numberShadowBlock = blockThis.workspace.newBlock('text');
                                            // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
                                            // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
                                            // delete blockThis.workspace.Blocks['text'];
                                        }
                                    }
                                },
                                onchange: function (event) {
                                    if (event.ids) {
                                        if (that.workspace.getBlockById(event.blockId)) {
                                            if (that.workspace.getBlockById(event.blockId).type === exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version) {
                                                // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                                                // that.findExecutorAttibutes(exect.category, that.workspace.getBlockById(event.blockId).type);
                                                that.findExecutorAttibutes(exect.executor_category, that.workspace.getBlockById(event.blockId).type);
                                            }
                                        }
                                    }
                                    // if (event.type === Blockly.Events.BLOCK_CREATE && event.group) {
                                    //
                                    //     if (event.blockId === this.id) {
                                    //         var input = this.getInput('parameters');
                                    //         var oldBlock = input.connection.targetBlock();
                                    //         if (oldBlock && oldBlock.type === 'json_object') {
                                    //             var count = 0;
                                    //             while (true) {
                                    //                 const addedBlock = oldBlock.getInputTargetBlock('ADD' + count);
                                    //                 if (addedBlock) {
                                    //                     count++;
                                    //                     if (addedBlock.type === 'key_value_pair') {
                                    //                         const a = addedBlock.getInputTargetBlock('A');
                                    //                         const b = addedBlock.getInputTargetBlock('B');
                                    //                         if (a.getFieldValue('TEXT')) {
                                    //
                                    //                             setInterval(() => {
                                    //                                 var input1 = addedBlock.getInput('B');
                                    //                                 var oldBlock1 = input1.connection.targetBlock();
                                    //                                 var valueBlock = addedBlock.workspace.newBlock('attributes');
                                    //                                 valueBlock.setFieldValue('null', 'MODE');
                                    //                                 input1.connection.disconnect();
                                    //                                 addedBlock.getInput('B').connection.connect(valueBlock.outputConnection);
                                    //
                                    //                                 oldBlock1.dispose();
                                    //                             }, 1000)
                                    //
                                    //                         }
                                    //                     }
                                    //                 } else {
                                    //                     break;
                                    //                 }
                                    //             }
                                    //         }
                                    //     }
                                    // }
                                }
                            };
                            that.addApiBlockCode(exect);
                            var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
                            xmlList.push(blockText);
                        }
                    }

                });
                // }
            }
        });
        return xmlList;
    }

    getSuggestedSortedAttributeList(stringToMatch) {
        if (stringToMatch && this.attributeList) {
            const options = this.attributeList.map(element => element[0]);
            const bestMatch = stringSimilarity.findBestMatch(stringToMatch, options);
            const sortedList = bestMatch.ratings.sort((a, b) => b.rating - a.rating).map(
                element => this.attributeList.find(elem => elem[0] === element.target));
            return sortedList;
        } else {
            return this.attributeList;
        }
    }

    // function to get data from json block connected to a API block
    getAPIBlockDataAsDetails(block) {
        const headersValue = [];
        if (block) {
            if (block.type === 'json_object') {
                const connectedBlocks = [];
                let count = 0;
                while (true) {
                    const addedBlock = block.getInputTargetBlock('ADD' + count);
                    if (addedBlock) {
                        count++;
                        connectedBlocks.push(addedBlock);
                        if (addedBlock.type === 'key_value_pair') {
                            const a = addedBlock.getInputTargetBlock('A');
                            const b = addedBlock.getInputTargetBlock('B');
                            const value = {
                                keyType: 'text',
                                keyValue: null,
                                valueType: 'text',
                                valueValue: null
                            };
                            if (a.type === 'text') {
                                value.keyValue = a.getFieldValue('TEXT');
                            }
                            if (b.type === 'text') {
                                value.valueValue = b.getFieldValue('TEXT');
                            }
                            headersValue.push(value);
                        }
                    } else {
                        break;
                    }
                }
            }
        }
        return headersValue;
    }

    parseJsonString(str) {
        const result = [];
        let item = '', depth = 0;

        function push() {
            if (item) {
                result.push(item);
                item = '';
            }
        }

        for (let i = 0, c; c = str[i], i < str.length; i++) {
            if (!depth && c === ',') {
                push();
            } else {
                item += c;
                if (c === '[') {
                    depth++;
                }
                if (c === ']') {
                    depth--;
                }
            }
        }
        push();
        return result;
    }

    // Avoid passing values with arrays and nested objects - (To be used mainly for API parameters, headers, path params)
    fixIssuesInBlockJSON(jsonStr, count = 0) {
        const jsonStrKeyPairs = this.parseJsonString(jsonStr);
        let isValid = true;
        for (const pair of jsonStrKeyPairs) {
            if (!pair.includes(':')) {
                isValid = false;
                break;
            }
        }

        if (isValid) {
            if (jsonStrKeyPairs.length > 0) {
                try {
                    return JSON5.parse(jsonStr);
                } catch (error) {
                    if (count < 100) {
                        count++;
                        const errorMessage = error.message;
                        const errorStartIndex = errorMessage.split('at')[1].trim().split(':')[1];
                        const wordEndIndex = jsonStr.indexOf(',', errorStartIndex) >= 0 ? jsonStr.indexOf(',', errorStartIndex) : jsonStr.indexOf('}', errorStartIndex);
                        let actualStartIndex = jsonStr.lastIndexOf(' ', wordEndIndex) + 1;
                        if (jsonStr[actualStartIndex] === '[') {
                            actualStartIndex++;
                        }
                        const replacedStr = jsonStr.substring(0, actualStartIndex - 1) + '"var^=' + jsonStr.substring(actualStartIndex, wordEndIndex) + '"' + jsonStr.substring(wordEndIndex, jsonStr.length);

                        return this.fixIssuesInBlockJSON(replacedStr, count);
                    } else {
                        return null;
                    }
                }
            } else {
                return {};
            }
        } else {
            return null;
        }
        return null;
    }

    setTempBlocks(tempApiExecutors) {
        const that = this;
        const xmlList = [];
        if (tempApiExecutors) {
            for (const exect of tempApiExecutors) {
                Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
                    init: function () {

                        if (exect.executor_method_type === 'GET') {
                            this.setColour(100);
                        } else if (exect.executor_method_type === 'POST') {
                            this.setColour(220);
                        } else if (exect.executor_method_type === 'PUT') {
                            this.setColour(45);
                        } else if (exect.executor_method_type === 'DELETE') {
                            this.setColour(0);
                        } else {
                            this.setColour(160);
                        }
                        this.setTooltip('This is a temporary block. Please deploy the actual APIs of these blocks before testing/using this businesslogic API.');
                        this.setNextStatement(true);
                        this.setPreviousStatement(true);
                        this.appendDummyInput()
                            .appendField( '(Temp) ' + exect.executor_name + '(' + exect.executor_version + ')')

                        this.appendValueInput('headers').appendField('headers');
                        this.appendValueInput('parameters').appendField('parameters');
                        this.appendValueInput('path_parameters').appendField('path_parameters');
                        this.appendValueInput('authorization').appendField('authorization');

                        const blockThis = this;
                        if (exect.headers != null) {
                            var headerBlock = blockThis.workspace.newBlock('json_object');
                            headerBlock.itemCount_ = 0;
                            headerBlock.updateShape_();
                            var i = 0;
                            exect.headers.forEach((attr) => {
                                if (attr && attr.key && attr.key != null) {
                                    headerBlock.appendValueInput('ADD' + i);
                                    var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                                    var keyBlock = key_value_1.workspace.newBlock('text');
                                    keyBlock.setFieldValue(attr.key, 'TEXT');
                                    key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                    if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                        var valueBlock = key_value_1.workspace.newBlock('text');
                                        valueBlock.setFieldValue(attr.value, 'TEXT');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    } else {
                                        var valueBlock = key_value_1.workspace.newBlock('attributes');
                                        valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    }

                                    headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                                    i++;
                                }

                            });
                            headerBlock.itemCount_ = i;
                            headerBlock.updateShape_();
                            blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);

                        } else {

                        }
                        if (exect.queryParams != null) {
                            var queryParamsBlock = blockThis.workspace.newBlock('json_object');
                            queryParamsBlock.itemCount_ = 0;
                            queryParamsBlock.updateShape_();
                            var j = 0;
                            exect.queryParams.forEach((attr) => {
                                if (attr && attr.key && attr.key != null) {
                                    queryParamsBlock.appendValueInput('ADD' + j);

                                    var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                                    var keyBlock = key_value_1.workspace.newBlock('text');
                                    keyBlock.setFieldValue(attr.key, 'TEXT');
                                    key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                    if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                        var valueBlock = key_value_1.workspace.newBlock('text');
                                        valueBlock.setFieldValue(attr.value, 'TEXT');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    } else {
                                        var valueBlock = key_value_1.workspace.newBlock('attributes');
                                        valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    }

                                    queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                                    j++;
                                }

                            });
                            queryParamsBlock.itemCount_ = j;
                            queryParamsBlock.updateShape_();
                            blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

                        } else {

                        }
                        if (exect.pathParams != null) {
                            var pathParamsBlock = blockThis.workspace.newBlock('json_object');
                            pathParamsBlock.itemCount_ = 0;
                            pathParamsBlock.updateShape_();
                            var k = 0;
                            exect.pathParams.forEach((attr) => {
                                if (attr && attr.key && attr.key != null) {
                                    pathParamsBlock.appendValueInput('ADD' + k);
                                    var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                                    var keyBlock = key_value_1.workspace.newBlock('text');
                                    keyBlock.setFieldValue(attr.key, 'TEXT');
                                    key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                    if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                        var valueBlock = key_value_1.workspace.newBlock('text');
                                        valueBlock.setFieldValue(attr.value, 'TEXT');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    } else {
                                        var valueBlock = key_value_1.workspace.newBlock('attributes');
                                        valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                        key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                    }
                                    // var valueBlock = key_value_1.workspace.newBlock('text');
                                    // valueBlock.setFieldValue(attr.value, 'TEXT');
                                    // key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);

                                    pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                                    k++;
                                }

                            });
                            pathParamsBlock.itemCount_ = k;
                            pathParamsBlock.updateShape_();
                            blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
                            // }

                        } else {

                        }
                        if (exect.authModel) {
                            if (that.blComponentDataService.authorizationTypesData) {
                                that.blComponentDataService.authorizationTypesData.forEach(authBlock => {
                                    if (authBlock.name === exect.authModel.authType) {
                                        var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                                        const authAttributes = authBlock.authAttributes;
                                        if (authAttributes) {
                                            authAttributes.forEach(attribute => {
                                                var dynItemBlock = dynBlock.workspace.newBlock('text');
                                                dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                                                dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);
                                            });
                                        }
                                        blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                                    }
                                });
                            }
                        }
                        if (exect.requestBody != null) {
                            if (exect.requestBody.hasOwnProperty('__zone_symbol__value')) {
                                blockThis.appendValueInput(exect.requestBody['__zone_symbol__value'].key).appendField(exect.requestBody['__zone_symbol__value'].key);
                            } else if (exect.requestBody.key && exect.requestBody.key != null) {
                                blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
                                // var numberShadowBlock = blockThis.workspace.newBlock('text');
                                // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
                                // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
                                // delete blockThis.workspace.Blocks['text'];
                            }
                        }
                    },
                    onchange: function (event) {
                        if (event.ids) {
                            if (that.workspace.getBlockById(event.blockId)) {
                                if (that.workspace.getBlockById(event.blockId).type === exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version) {
                                    // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                                    // that.findExecutorAttibutes(exect.category, that.workspace.getBlockById(event.blockId).type);
                                    that.findExecutorAttibutes(exect.executor_category, that.workspace.getBlockById(event.blockId).type);
                                }
                            }
                        }
                        // if (event.type === Blockly.Events.BLOCK_CREATE && event.group) {
                        //
                        //     if (event.blockId === this.id) {
                        //         var input = this.getInput('parameters');
                        //         var oldBlock = input.connection.targetBlock();
                        //         if (oldBlock && oldBlock.type === 'json_object') {
                        //             var count = 0;
                        //             while (true) {
                        //                 const addedBlock = oldBlock.getInputTargetBlock('ADD' + count);
                        //                 if (addedBlock) {
                        //                     count++;
                        //                     if (addedBlock.type === 'key_value_pair') {
                        //                         const a = addedBlock.getInputTargetBlock('A');
                        //                         const b = addedBlock.getInputTargetBlock('B');
                        //                         if (a.getFieldValue('TEXT')) {
                        //
                        //                             setInterval(() => {
                        //                                 var input1 = addedBlock.getInput('B');
                        //                                 var oldBlock1 = input1.connection.targetBlock();
                        //                                 var valueBlock = addedBlock.workspace.newBlock('attributes');
                        //                                 valueBlock.setFieldValue('null', 'MODE');
                        //                                 input1.connection.disconnect();
                        //                                 addedBlock.getInput('B').connection.connect(valueBlock.outputConnection);
                        //
                        //                                 oldBlock1.dispose();
                        //                             }, 1000)
                        //
                        //                         }
                        //                     }
                        //                 } else {
                        //                     break;
                        //                 }
                        //             }
                        //         }
                        //     }
                        // }
                    }
                };

                var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
                xmlList.push(blockText);
                that.addApiBlockCode(exect);
            }
        }
        return xmlList;

    }

    loadb2bExecutorBlockBasedOnEntity(entityNames, exect, category) {
        let xmlList = [];
        const that = this;
        // this.blComponentDataService.b2bServiceProviderAPIs.forEach((catExe) => {
        //     catExe.categories.forEach((category) => {
        //         category.executors.forEach((exect) => {
        //             if (exect.executor_name && exect.executor_name != null) {
        const t = (exect.executor_category_group !== null ? exect.executor_category_group + '>' : '') + exect.executor_category;
        if (t === entityNames) {
            Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
                init: function () {
                    if (exect.executor_method_type === 'GET') {
                        this.setColour(100);
                    } else if (exect.executor_method_type === 'POST') {
                        this.setColour(220);
                    } else if (exect.executor_method_type === 'PUT') {
                        this.setColour(45);
                    } else if (exect.executor_method_type === 'DELETE') {
                        this.setColour(0);
                    } else {
                        this.setColour(160);
                    }
                    this.setTooltip((exect.executor_category_group !== null ? exect.executor_category_group + ' > ' : '') + exect.executor_category + ' > ' + exect.executor_name + '_' + exect.executor_version);
                    this.setNextStatement(true);
                    this.setPreviousStatement(true);
                    this.appendDummyInput()
                        .appendField(exect.executor_name + '(' + exect.executor_version + ')');

                    this.appendValueInput('headers').appendField('headers');
                    this.appendValueInput('parameters').appendField('parameters');
                    this.appendValueInput('path_parameters').appendField('path_parameters');
                    // this.appendValueInput('request_body').appendField('request_body');
                    this.appendValueInput('authorization').appendField('authorization');

                    const blockThis = this;
                    if (exect.headers != null) {
                        var headerBlock = blockThis.workspace.newBlock('json_object');
                        headerBlock.itemCount_ = 0;
                        headerBlock.updateShape_();
                        var i = 0;
                        exect.headers.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                headerBlock.appendValueInput('ADD' + i);
                                var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                                i++;
                            }

                        });
                        headerBlock.itemCount_ = i;
                        headerBlock.updateShape_();
                        blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);
                    } else {

                    }
                    if (exect.queryParams != null) {
                        var queryParamsBlock = blockThis.workspace.newBlock('json_object');
                        queryParamsBlock.itemCount_ = 0;
                        queryParamsBlock.updateShape_();
                        var j = 0;
                        exect.queryParams.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                queryParamsBlock.itemCount_++;
                                queryParamsBlock.appendValueInput('ADD' + j);

                                var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                                j++;
                            }

                        });
                        queryParamsBlock.itemCount_ = j;
                        queryParamsBlock.updateShape_();
                        blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

                    } else {

                    }
                    if (exect.pathParams != null) {
                        var pathParamsBlock = blockThis.workspace.newBlock('json_object');
                        pathParamsBlock.itemCount_ = 0;
                        pathParamsBlock.updateShape_();
                        var k = 0;
                        exect.pathParams.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                pathParamsBlock.appendValueInput('ADD' + k);
                                var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                                k++;
                            }

                        });
                        pathParamsBlock.itemCount_ = k;
                        pathParamsBlock.updateShape_();
                        blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
                    } else {

                    }
                    if (exect.authModel) {
                        if (that.blComponentDataService.authorizationTypesData) {
                            that.blComponentDataService.authorizationTypesData.forEach(authBlock => {
                                if (authBlock.name === exect.authModel.authType) {
                                    var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                                    const authAttributes = authBlock.authAttributes;
                                    if (authAttributes) {
                                        authAttributes.forEach(attribute => {
                                            var dynItemBlock = dynBlock.workspace.newBlock('text');
                                            dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                                            dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);

                                        });
                                    }
                                    blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                                }
                            });
                        }


                    }
                    if (exect.requestBody != null) {
                        if (exect.requestBody.key && exect.requestBody.key != null) {
                            blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
                            // var numberShadowBlock = blockThis.workspace.newBlock('text');
                            // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
                            // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
                            // delete blockThis.workspace.Blocks['text'];
                        }
                    }
                },
                onchange: function (event) {
                    if (event.ids) {
                        if (that.workspace.getBlockById(event.blockId)) {
                            if (that.workspace.getBlockById(event.blockId).type != null) {
                                // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                                that.findExecutorAttibutesforB2B(category, that.workspace.getBlockById(event.blockId).type);
                            }
                        }
                    }
                }
            };
            var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
            xmlList.push(blockText);

            that.addApiBlockCode(exect);

        }
        //             }
        //         });
        //     });
        // });
        return xmlList;
    }

    loadMyServiceProvidersExecutorBlockBasedOnEntity(entityNames, exect, category) {
        let xmlList = [];
        const that = this;
        // this.blComponentDataService.b2bServiceProviderAPIs.forEach((catExe) => {
        //     catExe.categories.forEach((category) => {
        //         category.executors.forEach((exect) => {
        //             if (exect.executor_name && exect.executor_name != null) {
        const t = (exect.executor_category_group !== null ? exect.executor_category_group + '>' : '') + exect.executor_category;
        if (t === entityNames) {
            Blockly.Blocks[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = {
                init: function () {
                    if (exect.executor_method_type === 'GET') {
                        this.setColour(100);
                    } else if (exect.executor_method_type === 'POST') {
                        this.setColour(220);
                    } else if (exect.executor_method_type === 'PUT') {
                        this.setColour(45);
                    } else if (exect.executor_method_type === 'DELETE') {
                        this.setColour(0);
                    } else {
                        this.setColour(160);
                    }
                    this.setTooltip((exect.executor_category_group !== null ? exect.executor_category_group + ' > ' : '') + exect.executor_category + ' > ' + exect.executor_name + '_' + exect.executor_version);
                    this.setNextStatement(true);
                    this.setPreviousStatement(true);
                    this.appendDummyInput()
                        .appendField(exect.executor_name + '(' + exect.executor_version + ')');

                    this.appendValueInput('headers').appendField('headers');
                    this.appendValueInput('parameters').appendField('parameters');
                    this.appendValueInput('path_parameters').appendField('path_parameters');
                    // this.appendValueInput('request_body').appendField('request_body');
                    this.appendValueInput('authorization').appendField('authorization');

                    const blockThis = this;
                    if (exect.headers != null) {
                        var headerBlock = blockThis.workspace.newBlock('json_object');
                        headerBlock.itemCount_ = 0;
                        headerBlock.updateShape_();
                        var i = 0;
                        exect.headers.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                headerBlock.appendValueInput('ADD' + i);
                                var key_value_1 = headerBlock.workspace.newBlock('key_value_pair');

                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                headerBlock.getInput('ADD' + i).connection.connect(key_value_1.outputConnection);
                                i++;
                            }

                        });
                        headerBlock.itemCount_ = i;
                        headerBlock.updateShape_();
                        blockThis.getInput('headers').connection.connect(headerBlock.outputConnection);
                    } else {

                    }
                    if (exect.queryParams != null) {
                        var queryParamsBlock = blockThis.workspace.newBlock('json_object');
                        queryParamsBlock.itemCount_ = 0;
                        queryParamsBlock.updateShape_();
                        var j = 0;
                        exect.queryParams.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                queryParamsBlock.itemCount_++;
                                queryParamsBlock.appendValueInput('ADD' + j);

                                var key_value_1 = queryParamsBlock.workspace.newBlock('key_value_pair');
                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                queryParamsBlock.getInput('ADD' + j).connection.connect(key_value_1.outputConnection);
                                j++;
                            }

                        });
                        queryParamsBlock.itemCount_ = j;
                        queryParamsBlock.updateShape_();
                        blockThis.getInput('parameters').connection.connect(queryParamsBlock.outputConnection);

                    } else {

                    }
                    if (exect.pathParams != null) {
                        var pathParamsBlock = blockThis.workspace.newBlock('json_object');
                        pathParamsBlock.itemCount_ = 0;
                        pathParamsBlock.updateShape_();
                        var k = 0;
                        exect.pathParams.forEach((attr) => {
                            if (attr && attr.key && attr.key != null) {
                                pathParamsBlock.appendValueInput('ADD' + k);
                                var key_value_1 = pathParamsBlock.workspace.newBlock('key_value_pair');

                                var keyBlock = key_value_1.workspace.newBlock('text');
                                keyBlock.setFieldValue(attr.key, 'TEXT');
                                key_value_1.getInput('A').connection.connect(keyBlock.outputConnection);

                                if (attr.value || !that.blocklyHeaderButtonService.predicativeAutoSuggest) {
                                    var valueBlock = key_value_1.workspace.newBlock('text');
                                    valueBlock.setFieldValue(attr.value, 'TEXT');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                } else {
                                    var valueBlock = key_value_1.workspace.newBlock('attributes');
                                    valueBlock.setFieldValue(that.getSuggestedSortedAttributeList(attr.key)[0][1], 'MODE');
                                    key_value_1.getInput('B').connection.connect(valueBlock.outputConnection);
                                }

                                pathParamsBlock.getInput('ADD' + k).connection.connect(key_value_1.outputConnection);
                                k++;
                            }

                        });
                        pathParamsBlock.itemCount_ = k;
                        pathParamsBlock.updateShape_();
                        blockThis.getInput('path_parameters').connection.connect(pathParamsBlock.outputConnection);
                    } else {

                    }
                    if (exect.authModel) {
                        if (that.blComponentDataService.authorizationTypesData) {
                            that.blComponentDataService.authorizationTypesData.forEach(authBlock => {
                                if (authBlock.name === exect.authModel.authType) {
                                    var dynBlock = blockThis.workspace.newBlock(authBlock.name);
                                    const authAttributes = authBlock.authAttributes;
                                    if (authAttributes) {
                                        authAttributes.forEach(attribute => {
                                            var dynItemBlock = dynBlock.workspace.newBlock('text');
                                            dynItemBlock.setFieldValue(exect.authModel.authAttributes[attribute.key], 'TEXT');
                                            dynBlock.getInput(attribute.key).connection.connect(dynItemBlock.outputConnection);

                                        });
                                    }
                                    blockThis.getInput('authorization').connection.connect(dynBlock.outputConnection);

                                }
                            });
                        }


                    }
                    if (exect.requestBody != null) {
                        if (exect.requestBody.key && exect.requestBody.key != null) {
                            blockThis.appendValueInput(exect.requestBody.key).appendField(exect.requestBody.key);
                            // var numberShadowBlock = blockThis.workspace.newBlock('text');
                            // numberShadowBlock.setFieldValue(exect.requestBody.value, 'TEXT');
                            // blockThis.getInput(exect.requestBody.key).connection.connect(numberShadowBlock.outputConnection);
                            // delete blockThis.workspace.Blocks['text'];
                        }
                    }
                },
                onchange: function (event) {
                    if (event.ids) {
                        if (that.workspace.getBlockById(event.blockId)) {
                            if (that.workspace.getBlockById(event.blockId).type != null) {
                                // if(that.workspace.getBlockById(event.blockId).type && that.workspace.getBlockById(event.blockId).type != null) {
                                that.findExecutorAttibutesforMyServiceProvider(category, that.workspace.getBlockById(event.blockId).type);
                            }
                        }
                    }
                }
            };
            var blockText = '<block type="' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + '"></block>';
            xmlList.push(blockText);

            that.addApiBlockCode(exect);

        }
        //             }
        //         });
        //     });
        // });
        return xmlList;
    }

    addApiBlockCode(exect) {
        const that = this;
        Blockly.Python[exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version] = function (block) {

            Blockly.Python.definitions_['import_requests'] = 'import requests';
            const headerVal = Blockly.Python.valueToCode(block, 'headers', 0);
            const parameterVal = Blockly.Python.valueToCode(block, 'parameters', 0);
            const path_parameterVal = Blockly.Python.valueToCode(block, 'path_parameters', 0);
            const authorizationVal = Blockly.Python.valueToCode(block, 'authorization', 0);


            const parsedPathParams = that.fixIssuesInBlockJSON(path_parameterVal);

            let apiUrl = '\'' + exect.apiUrl + '\'';
            if (parsedPathParams) {
                const keys = Object.keys(parsedPathParams);
                for (const val of keys) {
                    const pathParam = '{' + val + '}';
                    if (apiUrl.includes(pathParam)) {
                        let replacement = parsedPathParams[val];

                        if (replacement) {
                            replacement = replacement.toString();
                            let isVariable = false;
                            if (replacement.startsWith('var^=')) {
                                replacement = replacement.substring(5);
                                isVariable = true;
                            }
                            if (isVariable) {
                                replacement = '\' + ' + replacement + ' + \'';
                            }
                            // else {
                            //     replacement = '\' + \'' +  replacement + '\' + \'';
                            // }
                            apiUrl = apiUrl.replace(new RegExp(pathParam, 'g'), replacement);
                            // if (apiUrl.endsWith('\' + \'\'')) {
                            //     const n = apiUrl.lastIndexOf(' + \'\'');
                            //     apiUrl = apiUrl.slice(0, n) + apiUrl.slice(n).replace(' + \'\'', '');
                            // }
                            if (apiUrl.endsWith(' + \'\'')) {
                                const n = apiUrl.lastIndexOf(' + \'\'');
                                apiUrl = apiUrl.slice(0, n) + apiUrl.slice(n).replace(' + \'\'', '');
                            }

                        }
                    }
                }
            }


            let code = '\n' + exect.executor_type + '_' + exect.executor_name + '_' + exect.executor_version + ' = requests.' + exect.executor_method_type.toLowerCase() + '(url = ' + apiUrl;

            let headerOutput: any;
            let parameterOutput: any;
            let authorizationOutput: any;


            if (authorizationVal && authorizationVal !== '') {
                if (authorizationVal.startsWith('(HTTPBasicAuth')) {
                    const authorizationString = authorizationVal.substring(1, authorizationVal.length - 1);
                    authorizationOutput = ',\n' + Blockly.Python.INDENT + 'auth = ' + authorizationString;
                } else if (authorizationVal.startsWith('(BearerToken')) {
                    const authorizationString = authorizationVal.substring(1, authorizationVal.length - 1);
                    const openingIndex = authorizationString.indexOf('(');
                    const closingIndex = authorizationString.indexOf(')');
                    const token = authorizationString.substring(openingIndex + 1, closingIndex);

                    if (token !== '\'\'' && token !== '') {
                        let headerParsed: any;
                        if (headerVal === '{}') {
                            headerParsed = {'Authorization': ''};
                        } else {
                            headerParsed = that.fixIssuesInBlockJSON(headerVal);
                        }

                        if (headerParsed) {
                            headerOutput = headerParsed;
                            if (token.startsWith('\'') && token.endsWith('\'')) {
                                headerOutput['Authorization'] = 'Bearer ' + token.substring(1, token.length - 1);
                            } else {
                                headerOutput['Authorization'] = 'var^= \'Bearer \' + ' + token.toString();
                            }
                        }

                    }
                } else if (authorizationVal.startsWith('(ApiKeyAuth')) {
                    const authorizationString = authorizationVal.substring(1, authorizationVal.length - 1);
                    const openingIndex = authorizationString.indexOf('(');
                    const closingIndex = authorizationString.indexOf(')');

                    const splitAuth = authorizationString.substring(openingIndex + 1, closingIndex).split(',');
                    const key = splitAuth[0] ? splitAuth[0].trim() : '';
                    const value = splitAuth[1] ? splitAuth[1].trim() : '';
                    const addTo = splitAuth[2] ? splitAuth[2].trim() : 'headers';

                    if (addTo === 'headers') {
                        let headerParsed: any;
                        if (headerVal === '{}') {
                            headerParsed = {};
                        } else {
                            headerParsed = that.fixIssuesInBlockJSON(headerVal);
                        }

                        if (headerParsed) {
                            headerOutput = headerParsed;
                            headerOutput[that.checkStringType(key)] = that.checkStringType(value);
                        }
                    } else {
                        let paramParsed: any;
                        if (parameterVal === '{}') {
                            paramParsed = {};
                        } else {
                            paramParsed = that.fixIssuesInBlockJSON(parameterVal);
                        }

                        if (paramParsed) {
                            parameterOutput = paramParsed;
                            parameterOutput[that.checkStringType(key)] = that.checkStringType(value);
                        }
                    }
                } else if (authorizationVal.startsWith('(AWSRequestsAuth')) {
                    const authorizationString = authorizationVal.substring(1, authorizationVal.length - 1);
                    authorizationOutput = ',\n' + Blockly.Python.INDENT + 'auth = ' + authorizationString;
                }
            }

            // headers
            if (headerOutput) {
                code += ',\n' + Blockly.Python.INDENT + 'headers = ' + that.convertJsonObjToPythonObjString(headerOutput);
            } else if (headerVal && headerVal !== '') {
                code += ',\n' + Blockly.Python.INDENT + 'headers = ' + headerVal;
            }

            // parameters
            if (parameterOutput) {
                code += ',\n' + Blockly.Python.INDENT + 'params = ' + that.convertJsonObjToPythonObjString(parameterOutput);
            } else if (parameterVal && parameterVal !== '') {
                code += ',\n' + Blockly.Python.INDENT + 'params = ' + parameterVal;
            }

            // requestBody
            if (exect.requestBody != null) {
                if (exect.requestBody.key && exect.requestBody.key != null) {
                    const requestBody = Blockly.Python.valueToCode(block, exect.requestBody.key, 0);
                    if (requestBody && requestBody !== '') {
                        code += ',\n' + Blockly.Python.INDENT + 'data=json.dumps(' + requestBody + ')';
                        Blockly.Python.definitions_['import_json'] = 'import json';
                    }
                }
            }

            if (authorizationOutput) {
                code += authorizationOutput;
            }

            code += ')\n';

            return code;
        };
    }

    checkStringType(val) {
        if (val !== '') {
            if (val.startsWith('\'') && val.endsWith('\'')) {
                return val.substring(1, val.length - 1);
            } else {
                return 'var^=' + val.toString();
            }
        } else {
            return '';
        }
    }

    convertJsonObjToPythonObjString(jsonObj) {
        const keys = Object.keys(jsonObj);
        if (keys.length > 0) {
            let pythonObj = '{';
            let isFirst = true;
            for (const key of keys) {
                if (!isFirst) {
                    pythonObj += ', ';
                } else {
                    isFirst = !isFirst;
                }
                pythonObj += this.covertJsonObjectToPythonObject(key) + ': ' + this.covertJsonObjectToPythonObject(jsonObj[key]);
            }
            pythonObj += '}';
            return pythonObj;
        } else {
            return '{}';
        }
    }

    covertJsonObjectToPythonObject(obj) {

        switch (typeof obj) {
            case 'number':
                return obj;
            case 'string':
                if (obj.startsWith('var^=')) {
                    return obj.substring(5);
                } else {
                    return '\'' + obj + '\'';
                }
            case 'boolean':
                return obj ? 'True' : 'False';
            case 'object':
                if (obj) {
                    if (Array.isArray(obj)) {
                        let arr = '[';
                        let first = true;
                        for (const val of obj) {
                            if (first) {
                                first = false;
                                arr += this.covertJsonObjectToPythonObject(val);
                            } else {
                                arr += ' ,' + this.covertJsonObjectToPythonObject(val);
                            }
                        }
                        arr += ']';
                        return arr;
                    } else {
                        return this.convertJsonObjToPythonObjString(obj);
                    }
                } else {
                    return 'None';
                }
        }
    }

    closeLogPanel() {
        this.logVisible = false;
        if (this.editFlag === false && this.location['_platformLocation'].location.pathname === '/businesslogic') {
            this.cfgSrv.getAPIExecutorForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account'), this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                if (response !== null && response !== undefined) {
                    this.router.navigateByUrl('/businesslogic/edit?partner=' + this.partner + '&account=' + this.account_id + '&entity=' + this.executor_name + '&version=' + this.selectedVersion);
                }
            });
        }
    }

    debugApi() {
        this.generateExecutorForDebug();
    }

    listenAPICreation(timestamp, apiName, apiVersion, action) {
        if (this.websocketService.isOpen()) {
            this.websocketService.listenAPICreation(localStorage.getItem('partner'), localStorage.getItem('account'), apiName, apiVersion, localStorage.getItem('sessionID'), timestamp, action).subscribe(data => {
                if (data) {
                    this.currentMessage = JSON.parse(data.body);
                }
            });
        }
    }

    listenToApiCreation(topic) {
        this.websocketService.listenToTopic(topic).subscribe(data => {
            if (data) {
                this.currentMessage = JSON.parse(data.body);
            }
        });
    }

    fetchExistingExecutor() {
        if (confirm('This will replace the blocks in current workspace. Are you sure you want to import the API into workspace?')) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.cfgSrv.getApiExecutorByPartnerAccountByNameAndVersion(this.partner, this.account_id, this.entity, this.version).subscribe(data => {
                loaderDialog.close();
                if (data != null) {
                    this.apiExecutor = data;
                    this.backupExecutor = data;
                    if (this.loading) {
                        Blockly.mainWorkspace.clear();
                        this.loadExecutor();
                    }
                }
            }, error => {
                loaderDialog.close();
            });
        }
    }

    setDevexPropertiesIntoModel(model) {
        model['authModel'] = this.devexHeader.authModel1.getAuthModel();
        if (!model['properties']) {
            model['properties'] = {};
        }
        if (this.devexHeader.isCustomPath) {
            model['properties']['pathValues'] = this.devexHeader.getCustomPathVariables();
            model['pathParams'] = this.devexHeader.getCustomPathAsParams();
        } else {
            if (model['properties'].hasOwnProperty('pathValues')) {
                model['properties']['pathValues'] = null;
            }
        }
        model['properties']['showBodyParamDescription'] = this.devexHeader.isBodyParamDescriptionEnabled();
        model['properties']['bodyParamDescription'] = this.devexHeader.getBodyParamDescription();
    }

    saveAPIEmit() {
        var that = this;
        var xml = Blockly.Xml.workspaceToDom(this.workspace);
        var rootNode = xml.getRootNode();

        this.platform.isSaving = true;
        var idsTobeRemoved = [];
        const blocks = rootNode.childNodes;
        blocks.forEach(blk => {
            if (blk.getAttribute('type') === 'json_object' ||
                blk.getAttribute('type') === 'text' ||
                blk.getAttribute('type') === 'basic_authentication' ||
                blk.getAttribute('type') === 'digest_authentication' ||
                blk.getAttribute('type') === 'connector' ||
                blk.getAttribute('type') === 'api_key' ||
                blk.getAttribute('type') === 'bearer_token' ||
                blk.getAttribute('type') === 'aws' ||
                blk.getAttribute('type') === 'oauth_1_0' ||
                blk.getAttribute('type') === 'oauth_2_0') {
                idsTobeRemoved.push(blk.getAttribute('id'));
            }
        });

        const gateways = this.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }

        idsTobeRemoved.forEach(id => {
            var children = rootNode.childNodes;
            children.forEach(child => {
                if (id === child.getAttribute('id')) {
                    rootNode.removeChild(child);
                }
            });
        });

        var xml_text = Blockly.Xml.domToText(rootNode);

        const parser = new DOMParser();
        const xml1 = parser.parseFromString(xml_text, 'text/xml');
        const obj = this.ngxXml2jsonService.xmlToJson(xml1);
        if (obj['xml'].block === undefined) {
            if (this.headers) {
                for (let i = 0; i < this.headers.length; i++) {
                    if (this.headers[i]) {
                        if (this.headers[i]['key'] === '') {
                            this.headers.splice(i, 1);
                        }
                    }
                }
            }
            if (this.queryParams) {
                for (let i = 0; i < this.queryParams.length; i++) {
                    if (this.queryParams[i]) {
                        if (this.queryParams[i]['key'] === '') {
                            this.queryParams.splice(i, 1);
                        }
                    }
                }
            }
            let requestBody = {};
            if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                requestBody = this.requestBody['__zone_symbol__value'];
            } else {
                requestBody = this.requestBody;
            }
            if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
                if (requestBody && requestBody['value']) {
                    for (let i = 0; i < requestBody['value'].length; i++) {
                        if (requestBody['value'][i]) {
                            if (requestBody['value'][i]['key'] === '') {
                                requestBody['value'].splice(i, 1);
                            }
                        }
                    }
                }
            }


            const fabResult = {
                'executor_type': this.selectedExecutorType,
                'executor_name': this.executor_name,
                'executor_version': this.selectedVersion,
                'executor_display_name': this.executor_display_name,
                'executor_description': this.description,
                'executor_category': this.executorCategory,
                'published': true,
                'scopeOfAccess': this.scopeSelected,
                'registeredAsIs': false,
                'executor_method_type': this.selectedExecutor,
                'queryParams': this.queryParams,
                'headers': this.headers,
                'mockResponses': this.mockResponses,
                'requestBody': requestBody,
                'source': xml_text,
                'gatewaySettings': gatewaySettings,
                'executors': [],
                'dataroot': null,
                'responseAttributes': null,
                'attributeMappings': null,
                'response': null,
                'block_attributes': this.attributeList,
                'properties': this.properties ? this.properties : {}
            };
            this.setDevexPropertiesIntoModel(fabResult);
            if (this.prerequisites !== null && this.prerequisites !== undefined) {
                fabResult['prerequisites'] = this.prerequisites;
            }

            this.saveBlocks.emit(fabResult);
            this.platform.isSaving = false;
        } else {
            let JSON_Blocks = {};
            if (obj['xml'].block !== undefined && obj['xml'].block.length > 1) {
                let index = 0;

                obj['xml'].block.forEach((block) => {
                    if (block['@attributes'].type !== 'text' &&
                        block['@attributes'].type !== 'json_object' &&
                        block['@attributes'].type !== 'basic_authentication' &&
                        block['@attributes'].type !== 'digest_authentication' &&
                        block['@attributes'].type !== 'connector' &&
                        block['@attributes'].type !== 'api_key' &&
                        block['@attributes'].type !== 'bearer_token' &&
                        block['@attributes'].type !== 'aws' &&
                        block['@attributes'].type !== 'oauth_1_0' &&
                        block['@attributes'].type !== 'oauth_2_0') {
                        JSON_Blocks['block'] = obj['xml'].block[index];
                    }
                    index++;
                });
            } else {
                JSON_Blocks['block'] = obj['xml'].block;
            }

            this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, JSON_Blocks).subscribe(executors => {
                this.requestBody = this.devexHeader.getRequestBody();

                if (this.headers) {
                    for (let i = 0; i < this.headers.length; i++) {
                        if (this.headers[i]) {
                            if (this.headers[i]['key'] === '') {
                                this.headers.splice(i, 1);
                            }
                        }
                    }
                }
                if (this.queryParams) {
                    for (let i = 0; i < this.queryParams.length; i++) {
                        if (this.queryParams[i]) {
                            if (this.queryParams[i]['key'] === '') {
                                this.queryParams.splice(i, 1);
                            }
                        }
                    }
                }
                let requestBody = {};
                if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                    requestBody = this.requestBody['__zone_symbol__value'];
                } else {
                    requestBody = this.requestBody;
                }
                if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
                    if (requestBody && requestBody['value']) {
                        for (let i = 0; i < requestBody['value'].length; i++) {
                            if (requestBody['value'][i]) {
                                if (requestBody['value'][i]['key'] === '') {
                                    requestBody['value'].splice(i, 1);
                                }
                            }
                        }
                    }
                }


                const fabResult = {
                    'executor_type': this.selectedExecutorType,
                    'executor_name': this.executor_name,
                    'executor_version': this.selectedVersion,
                    'executor_display_name': this.executor_display_name,
                    'executor_description': this.description,
                    'executor_category': this.executorCategory,
                    'published': true,
                    'scopeOfAccess': this.scopeSelected,
                    'registeredAsIs': false,
                    'executor_method_type': this.selectedExecutor,
                    'queryParams': this.queryParams,
                    'headers': this.headers,
                    'mockResponses': this.mockResponses,
                    'requestBody': requestBody,
                    'source': xml_text,
                    'executors': executors,
                    'gatewaySettings': gatewaySettings,
                    'dataroot': null,
                    'responseAttributes': null,
                    'attributeMappings': null,
                    'response': null,
                    'block_attributes': this.attributeList,
                    'properties': this.properties ? this.properties : {}
                };
                this.setDevexPropertiesIntoModel(fabResult);

                this.platform.isSaving = false;
                this.saveBlocks.emit(fabResult);
            }, error => {
                this.platform.isSaving = false;
                this.platform.handleErrorGracefully(error, 'Error while generating Executors. Please try again.');
            });
        }
    }

    saveAPI() {

        Promise.resolve(this.generateJsonForXml(this.workspace, false)).then((result: any) => {
            const JSON_Blocks = result.json;
            const xml_text = result.xml;
            if (!JSON_Blocks.block) {
                this.platform.openSnackBar('The business logic is empty. Please add some blocks to deploy this logic as an API', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.loading1 = false;
            } else {
                this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, JSON_Blocks).subscribe((result: any) => {
                    const blockExecutors = result.statements;
                    const functions = result.functions;
                    this.requestBody = this.devexHeader.getRequestBody();

                    if (this.headers) {
                        for (let i = 0; i < this.headers.length; i++) {
                            if (this.headers[i]) {
                                if (this.headers[i]['key'] === '') {
                                    this.headers.splice(i, 1);
                                }
                            }
                        }
                    }
                    if (this.queryParams) {
                        for (let i = 0; i < this.queryParams.length; i++) {
                            if (this.queryParams[i]) {
                                if (this.queryParams[i]['key'] === '') {
                                    this.queryParams.splice(i, 1);
                                }
                            }
                        }
                    }

                    let requestBody = {};
                    if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                        requestBody = this.requestBody['__zone_symbol__value'];
                    } else {
                        requestBody = this.requestBody;
                    }
                    if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
                        if (requestBody && requestBody['value']) {
                            for (let i = 0; i < requestBody['value'].length; i++) {
                                if (requestBody['value'][i]) {
                                    if (requestBody['value'][i]['key'] === '') {
                                        requestBody['value'].splice(i, 1);
                                    }
                                }
                            }
                        }
                    }

                    const gateways = this.gatewayControl.value as string[];
                    const gatewaySettings = [];
                    if (gateways && gateways.length > 0) {
                        for (const gateway of gateways) {
                            gatewaySettings.push({name: gateway});
                        }
                    }

                    const fabResult = {
                        'executor_type': this.selectedExecutorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'executor_method_type': this.selectedExecutor,
                        'queryParams': this.queryParams,
                        'headers': this.headers,
                        'mockResponses': this.mockResponses,
                        'requestBody': requestBody,
                        'source': xml_text,
                        'executors': blockExecutors,
                        'functions': functions,
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                        'gatewaySettings': gatewaySettings,
                        'block_attributes': this.attributeList,
                        'properties': this.properties ? this.properties : {}
                    };
                    this.setDevexPropertiesIntoModel(fabResult);

                    const savePayload = {
                        partner: '',
                        account: '',
                        executor_name: '',
                        executor_type: '',
                        by: '',
                        executor_version: '',
                        action: ''
                    };

                    savePayload.partner = this.partner;
                    savePayload.account = this.account_id;
                    savePayload['at'] = Date.now();
                    savePayload.by = this.partner;

                    if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '') {
                        savePayload.executor_name = this.executor_name;
                    } else {
                        savePayload.executor_name = Date.now().toString();
                    }

                    if (this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
                        savePayload.executor_version = this.selectedVersion;
                    } else {
                        savePayload.executor_version = 'No Ver.';
                    }
                    if (this.editFlag) {
                        savePayload.action = 'UPDATE';
                    } else {
                        savePayload.action = 'CREATE';
                    }
                    savePayload.executor_type = 'BUSINESSLOGIC';

                    savePayload['executor'] = fabResult;
                    const temp = JSON.parse(JSON.stringify(savePayload['executor']));
                    let isSame = true;
                    if (this.previousSavedData !== undefined && this.previousSavedData !== null) {
                        if (Object.keys(this.previousSavedData).length === Object.keys(temp).length) {
                            const keyArray = Object.keys(this.previousSavedData);
                            for (const key of keyArray) {
                                if (JSON.stringify(this.previousSavedData[key]) === JSON.stringify(temp[key])) {
                                    continue;
                                } else {
                                    isSame = false;
                                    break;
                                }
                            }
                        } else {
                            isSame = false;
                        }
                    } else {
                        isSame = false;
                    }

                    if (isSame === false) {
                        this.previousSavedData = JSON.parse(JSON.stringify(savePayload['executor']));
                        this.cfgSrv.saveExecutorInformation('v1', savePayload).subscribe(data => {
                            this.platform.openSnackBar('API has been saved successfully.', 'Success', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.leftPanelDataListener.saveEntityAndExecutors.emit('success');
                            const log_payload = {
                                logType: 'INFO',
                                logLevel: 2,
                                slugSearch: '',
                                label: 'BUTTON_CLICK',
                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                resource: 'SAVE',
                                action: 'CLICK',
                                result: 'SUCCESS',
                                payload: savePayload,
                                responseStatusCode: data.status,
                                response: data.statusText,
                                errorMessage: '',
                                logMessage: 'Save button clicked'
                            };
                            this.auditLog.log(log_payload);
                        }, error => {
                            this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            this.platform.openSnackBar('Error while saving the API. Please try again after sometime.', 'Error', {
                                duration: 3000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            const log_payload = {
                                logType: 'INFO',
                                logLevel: 2,
                                slugSearch: '',
                                label: 'BUTTON_CLICK',
                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                resource: 'SAVE',
                                action: 'CLICK',
                                result: 'ERROR',
                                payload: savePayload,
                                responseStatusCode: error.status,
                                response: error.statusText,
                                errorMessage: this.platform.returnErrorMessage(error),
                                logMessage: 'Save button clicked'
                            };
                            this.auditLog.log(log_payload);

                        });
                    } else {
                        this.platform.openSnackBar('No changes to save for this Business Logic API.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                });
            }
        }, error => {
            this.platform.openSnackBar(error, 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    displaySnackBarWithWS(type, duration, msg) {
        if (!this.websocketService.isOpen()) {
            this.platform.openSnackBar(msg, type, {
                duration: duration,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    closeNonWSDialogBox() {
        if (this.showDialogOnNonWebsocketConnection) {
            this.showDialogOnNonWebsocketConnection.close();
        }
    }


    validateAPI() {
        if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
            });
            this.cfgSrv.getAPIUsagesWithTestsuites(this.partner, this.account_id, this.partnerKey, this.executor_name, this.selectedVersion).subscribe(response => {
                this.dependencyApis = response;
                loaderDialog.close();
                const dialogRef = this.dialog.open(DependencyCheckComponent, {
                    width: '60%',
                    height: 'auto',
                    maxHeight: '70vh',
                    data: {
                        executors: this.dependencyApis,
                        executor_name: this.executor_name,
                        executor_version: this.selectedVersion
                    }
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result && result.continue) {
                        this.createOrUpdateApi(result.mode);
                    }
                });

            }, error => {
                loaderDialog.close();
                this.platform.openSnackBar('Error while fetching the usages of the API. Please try again later.', 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.createOrUpdateApi();
        }
    }

    async createOrUpdateApiWithCoreApi(editFlag, testMode = 'notests') {
        const gateways = this.gatewayControl.value as string[];
        const gatewaySettings = [];
        if (gateways && gateways.length > 0) {
            for (const gateway of gateways) {
                gatewaySettings.push({name: gateway});
            }
        }
        if (gatewaySettings.length > 0) {
            Promise.resolve(this.devexHeader.isCustomPathValid()).then(async pathValid => {

                Promise.resolve(this.createExecutorsForBlocks()).then(async response => {
                    let resp: any;
                    resp = response;
                    const xml_text = resp.xml_text;
                    const blockExecutors = resp.block_executors;
                    const functions = resp.functions;

                    await this.updateAttributes();

                    if (this.headers) {
                        for (let i = 0; i < this.headers.length; i++) {
                            if (this.headers[i]) {
                                if (this.headers[i]['key'] === '') {
                                    this.headers.splice(i, 1);
                                }
                            }
                        }
                        if (!this.editFlag) {
                            if (this.headers.filter(element => element.key === 'apikey').length === 0) {
                                this.headers.push({
                                    key: 'apikey',
                                    value: localStorage.getItem('apikey'),
                                    description: ''
                                });
                            }
                        }
                    }

                    if (this.queryParams) {
                        for (let i = 0; i < this.queryParams.length; i++) {
                            if (this.queryParams[i]) {
                                if (this.queryParams[i]['key'] === '') {
                                    this.queryParams.splice(i, 1);
                                }
                            }
                        }
                    }
                    let requestBody = {};
                    if (this.requestBody && this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                        requestBody = this.requestBody['__zone_symbol__value'];
                    } else {
                        requestBody = this.requestBody;
                    }
                    if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
                        if (requestBody && requestBody['value']) {
                            for (let i = 0; i < requestBody['value'].length; i++) {
                                if (requestBody['value'][i]) {
                                    if (requestBody['value'][i]['key'] === '') {
                                        requestBody['value'].splice(i, 1);
                                    }
                                }
                            }
                        }
                    }



                    const fabResult = {
                        'executor_type': this.selectedExecutorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'executor_category_group': null,
                        'executor_method_type': this.selectedExecutor,
                        'queryParams': this.queryParams,
                        'headers': this.headers,
                        'mockResponses': this.mockResponses,
                        'requestBody': requestBody,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'registeredAsIs': false,
                        'prerequisites': this.prerequisites,
                        'source': xml_text,
                        'executors': blockExecutors,
                        'functions': functions,
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': this.attributeList,
                        'isDocumentationPublished': true,
                        'disabled': false,
                        'executionLib': null,
                        'gatewaySettings': gatewaySettings,
                        'properties': this.properties ? this.properties : {}
                    };
                    this.setDevexPropertiesIntoModel(fabResult);


                    const timeStamp = Date.now();
                    this.logTimeStamp = timeStamp;

                    this.action = this.editFlag ? 'redeploy' : 'deploy';

                    const topic = this.partner + '.' + this.account_id + '.' + this.executor_name + '.' + this.selectedVersion + '.' + timeStamp.toString() + '.' + 'deploy';
                    this.pubSubTopic = topic;
                    this.listenToApiCreation(topic);

                    const payload = {
                        'topic': topic,
                        'apiModel': fabResult
                    };

                    this.loading1 = true;
                    if (this.websocketService.isOpen()) {
                        this.logVisible = true;
                    }

                    if (!this.websocketService.isOpen()) {
                        this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                            maxWidth: '95vw',
                            maxHeight: '60vh',
                            data: {
                                message: 'API deployment is under progress. Please don\'t close the window'
                            }
                        });
                    }


                    this.cfgSrv.upsertAPIWithCore(this.partner, this.account_id, this.partnerKey, payload, false, editFlag, true, true).toPromise().then(response1 => {

                        this.leftPanelDataListener.changeInLeftPanelData.emit('update');
                        this.loading1 = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                            const log_payload = {
                                logType: 'INFO',
                                logLevel: 2,
                                slugSearch: '',
                                label: 'BUTTON_CLICK',
                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                resource: editFlag ? 'REDEPLOY' : 'DEPLOY',
                                action: 'CLICK',
                                result: 'SUCCESS',
                                payload: {},
                                responseStatusCode: 200,
                                response: response1,
                                errorMessage: '',
                                logMessage: editFlag ? 'Redeploy button clicked' : 'Deploy button clicked'
                            };
                            this.auditLog.log(log_payload);
                    }, error => {

                        this.loading1 = false;
                        if (this.showDialogOnNonWebsocketConnection) {
                            this.showDialogOnNonWebsocketConnection.close();
                        }
                        if (!this.websocketService.isOpen()) {
                            this.logVisible = true;
                            this.refreshLogCount++;
                        }
                        const log_payload = {
                            logType: 'INFO',
                            logLevel: 2,
                            slugSearch: '',
                            label: 'BUTTON_CLICK',
                            featureArea: this.platform.auditFeatureArea.businessLogic,
                            resource:  editFlag ? 'REDEPLOY' : 'DEPLOY',
                            action: 'CLICK',
                            result: 'ERROR',
                            payload: {},
                            responseStatusCode: error.status,
                            response: error,
                            errorMessage: error.message,
                            logMessage:  editFlag ? 'Redeploy button clicked': 'Deploy button clicked'
                        };
                        this.auditLog.log(log_payload);
                    });
                }, error => {
                });
            }, error => {
                this.loading1 = false;
                this.closeNonWSDialogBox();
                this.platform.openSnackBar(error, 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.loading1 = false;
            this.closeNonWSDialogBox();
            this.platform.openSnackBar('Please select at least one valid API Gateway.', 'Error', {
                duration: 7000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    createExecutorsForBlocks() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.generateJsonForXml(this.workspace, false)).then((result: any) => {
                const JSON_Blocks = result.json;
                const xml_text = result.xml;
                Promise.resolve(this.validateBlocks(JSON_Blocks, 0, '')).then((executorResult: any) => {
                    resolve({'xml_text': xml_text, 'block_executors': executorResult.statements, 'functions': executorResult.functions});
                }, error => {
                    reject();
                });
            }, error => {
                this.platform.openSnackBar(error, 'Error', {
                    duration: 7000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });
    }



    async createOrUpdateAPIWithApi() {
        this.loading1 = true;
        if (this.editFlag) {
            if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
                if (this.executorCategory !== undefined && this.executorCategory !== '') {
                    this.createOrUpdateApiWithCoreApi(true);
                } else {
                    this.loading1 = false;
                    this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                const publishdata = {};
                var message = 'Change in entity';
                publishdata['orig_executor_name'] = this.orig_executor_name;
                publishdata['orig_executor_version'] = this.orig_executor_version;
                publishdata['entity'] = this.executor_name;
                publishdata['version'] = this.selectedVersion;
                publishdata['tableName'] = 'logic';
                publishdata['origCollection'] = 'logic';

                if (this.orig_executor_name !== this.executor_name) {
                    if (this.orig_executor_version !== this.selectedVersion) {
                        message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    } else {
                        message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    }
                } else {
                    if (this.orig_executor_version !== this.selectedVersion) {
                        message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    }
                }
                if (this.executor_name !== '' && this.selectedVersion !== '') {

                    if (this.executorCategory !== undefined && this.executorCategory !== '') {
                        publishdata['message'] = message;
                        if (this.isAPIAlreadyPresentCheckCompleted === false) {
                            await this.checkForExistingEntityAndExecutor();
                        }

                        if (this.isAPIAlreadyPresent === false) {
                            const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                width: '60%',
                                data: publishdata
                            });
                            dialogRef.afterClosed().subscribe(result => {
                                if (result) {
                                    this.loading1 = true;
                                    this.createOrUpdateApiWithCoreApi(false);
                                } else {
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                }
                            });
                        } else {
                            this.loading1 = false;
                            this.closeNonWSDialogBox();
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        }
                    } else {
                        this.loading1 = false;
                        this.closeNonWSDialogBox();

                        this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            }
        } else {
            if (this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== undefined && this.selectedVersion !== '' && this.executorCategory !== undefined && this.executorCategory !== '' && this.selectedExecutor !== undefined && this.selectedExecutor !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    await this.checkForExistingEntityAndExecutor();
                }
                if (this.isAPIAlreadyPresent === false) {
                    this.loading1 = true;
                    this.createOrUpdateApiWithCoreApi(false);

                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                if (this.executor_name === undefined || this.executor_name === '' || this.selectedVersion === undefined || this.selectedVersion === '' ||
                    this.executorCategory === undefined || this.executorCategory === '') {
                    this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else if (this.selectedExecutor === undefined || this.selectedExecutor === '') {
                    this.platform.openSnackBar('Please select a valid executor method.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                this.loading1 = false;
                this.closeNonWSDialogBox();

            }
        }

    }

    async validateAPIAndRedeploy() {
        if (this.partner === 'core' && this.account_id === 'core') {
            const dialogRef = this.dialog.open(CoreCheckComponent, {
                width: 'auto',
                height: 'auto'
            });
            dialogRef.afterClosed().subscribe(async result => {
                if (result && result.continue && result.mode === 'old') {
                    this.gatewayUrl = await this.platform.getDefaultGatewayURL();
                    this.gatewayFullUrl = 'https://' + this.gatewayUrl;
                    this.createOrUpdateApi('notests');
                } else if (result && result.continue && result.mode === 'upsert') {
                    this.createOrUpdateAPIWithApi();
                }
            });

        } else {
            this.createOrUpdateAPIWithApi();
        }
    }


    async createOrUpdateApi(testMode = 'notests') {
        let action = '';
        if (this.editFlag) {
            action = 'redeploy';
            this.eventNameForAudit = 'businesslogic_edit_redeploy_clicked';
            this.eventNameForAuditLog = 'REDEPLOY';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_update;
        } else {
            action = 'deploy';
            this.eventNameForAuditLog = 'DEPLOY',
            this.eventNameForAudit = 'businesslogic_create_deploy_clicked';
            this.eventLabelForAuditLog = this.platform.auditLabels.api_create;
        }
        this.logVisible = false;

        this.action = action;
        const timeStamp = Date.now();
        this.logTimeStamp = timeStamp;
        this.listenAPICreation(timeStamp, this.executor_name, this.selectedVersion, action);


        this.loading1 = true;

        if (this.editFlag) {
            if (this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
                if (this.executorCategory !== undefined && this.executorCategory !== '') {
                    this.generateExecutor(action, timeStamp, testMode);
                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                        this.auditListenerService.auditListener.emit({
                            type: 'auditLog',
                            category: 'isAuditForBusinessLogic',
                            payload: response
                        });
                    });
                    this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
            } else {
                const publishdata = {};
                var message = 'Change in entity';
                publishdata['orig_executor_name'] = this.orig_executor_name;
                publishdata['orig_executor_version'] = this.orig_executor_version;
                publishdata['entity'] = this.executor_name;
                publishdata['version'] = this.selectedVersion;
                publishdata['tableName'] = 'logic';
                publishdata['origCollection'] = 'logic';

                if (this.orig_executor_name !== this.executor_name) {
                    if (this.orig_executor_version !== this.selectedVersion) {
                        message = 'Both the name and version of the entity have been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    } else {
                        message = 'Name of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    }
                } else {
                    if (this.orig_executor_version !== this.selectedVersion) {
                        message = 'Version of the entity has been changed. Hence this will create another entity : ' + this.executor_name + ' with the version: ' + this.selectedVersion + '. Do you want to continue creating a new Business Logic API ?';
                    }
                }
                if (this.executor_name !== '' && this.selectedVersion !== '') {

                    if (this.executorCategory !== undefined && this.executorCategory !== '') {
                        publishdata['message'] = message;
                        if (this.isAPIAlreadyPresentCheckCompleted === false) {
                            await this.checkForExistingEntityAndExecutor();
                        }

                        if (this.isAPIAlreadyPresent === false) {
                            const dialogRef = this.dialog.open(EntityVersionChangeConfirmationComponent, {
                                width: '60%',
                                data: publishdata
                            });
                            dialogRef.afterClosed().subscribe(result => {
                                if (result) {
                                    this.loading1 = true;
                                    Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(this.executor_name, this.selectedVersion, timeStamp, action)).then(resp1 => {
                                        if (resp1 === true) {
                                            this.generateExecutor(action, timeStamp);
                                        } else {
                                            this.loading1 = false;
                                            this.closeNonWSDialogBox();
                                            this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                                                duration: 5000,
                                                verticalPosition: 'top',
                                                horizontalPosition: 'center'
                                            });
                                            // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                                            //     this.auditListenerService.auditListener.emit({
                                            //         type: 'auditLog',
                                            //         category: 'isAuditForBusinessLogic',
                                            //         payload: response
                                            //     });
                                            // });
                                            const log_payload = {
                                                logType: 'ERROR',
                                                logLevel: 0,
                                                slugSearch: '',
                                                label: this.eventLabelForAuditLog,
                                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                                resource:  this.eventNameForAuditLog,
                                                action: 'CLICK',
                                                result: 'FAIL',
                                                payload: {},
                                                responseStatusCode: 400,
                                                response: '',
                                                errorMessage: 'Invalid Payload',
                                                logMessage: ''
                                            };
                                            this.auditLog.log(log_payload);
                                        }
                                    });
                                } else {
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                }
                            });
                        } else {
                            this.loading1 = false;
                            this.closeNonWSDialogBox();
                            this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'API already exists')).then(response => {
                            //     this.auditListenerService.auditListener.emit({
                            //         type: 'auditLog',
                            //         category: 'isAuditForBusinessLogic',
                            //         payload: response
                            //     });
                            // });
                            const log_payload = {
                                logType: 'ERROR',
                                logLevel: 0,
                                slugSearch: '',
                                label: this.eventLabelForAuditLog,
                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                resource:  this.eventNameForAuditLog,
                                action: 'CLICK',
                                result: 'FAIL',
                                payload: {},
                                responseStatusCode: 400,
                                response: '',
                                errorMessage: 'API already exists',
                                logMessage: ''
                            };
                            this.auditLog.log(log_payload);
                        }
                    } else {
                        this.loading1 = false;
                        this.closeNonWSDialogBox();

                        // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                        //     this.auditListenerService.auditListener.emit({
                        //         type: 'auditLog',
                        //         category: 'isAuditForBusinessLogic',
                        //         payload: response
                        //     });
                        // });
                        const log_payload = {
                            logType: 'ERROR',
                            logLevel: 0,
                            slugSearch: '',
                            label: this.eventLabelForAuditLog,
                            featureArea: this.platform.auditFeatureArea.businessLogic,
                            resource:  this.eventNameForAuditLog,
                            action: 'CLICK',
                            result: 'FAIL',
                            payload: {},
                            responseStatusCode: 400,
                            response: '',
                            errorMessage: 'Invalid Payload',
                            logMessage: ''
                        };
                        this.auditLog.log(log_payload);

                        this.platform.openSnackBar('Please enter a valid executor category.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, 'DEPLOY', 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                    //     this.auditListenerService.auditListener.emit({
                    //         type: 'auditLog',
                    //         category: 'isAuditForBusinessLogic',
                    //         payload: response
                    //     });
                    // });
                    const log_payload = {
                        logType: 'ERROR',
                        logLevel: 0,
                        slugSearch: '',
                        label: this.eventLabelForAuditLog,
                        featureArea: this.platform.auditFeatureArea.businessLogic,
                        resource:  this.eventNameForAuditLog,
                        action: 'CLICK',
                        result: 'FAIL',
                        payload: {},
                        responseStatusCode: 400,
                        response: '',
                        errorMessage: 'Invalid Payload',
                        logMessage: ''
                    };
                    this.auditLog.log(log_payload);
                }
            }
        } else {
            if (this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== undefined && this.selectedVersion !== '' && this.executorCategory !== undefined && this.executorCategory !== '' && this.selectedExecutor !== undefined && this.selectedExecutor !== '') {

                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    await this.checkForExistingEntityAndExecutor();
                }
                if (this.isAPIAlreadyPresent === false) {
                    this.loading1 = true;
                    Promise.resolve(this.platform.specialCharAndPasteValidationForEntityNameAndVersion(this.executor_name, this.selectedVersion, timeStamp, action)).then(resp1 => {
                        if (resp1 === true) {
                            this.generateExecutor(action, timeStamp, testMode);
                        } else {
                            this.loading1 = false;
                            this.closeNonWSDialogBox();
                            this.platform.openSnackBar('Please enter a valid executor name and version.', 'Error', {
                                duration: 5000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                            // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                            //     this.auditListenerService.auditListener.emit({
                            //         type: 'auditLog',
                            //         category: 'isAuditForBusinessLogic',
                            //         payload: response
                            //     });
                            // });
                            const log_payload = {
                                logType: 'ERROR',
                                logLevel: 0,
                                slugSearch: '',
                                label: this.eventLabelForAuditLog,
                                featureArea: this.platform.auditFeatureArea.businessLogic,
                                resource:  this.eventNameForAuditLog,
                                action: 'CLICK',
                                result: 'FAIL',
                                payload: {},
                                responseStatusCode: 400,
                                response: '',
                                errorMessage: 'Invalid Payload',
                                logMessage: ''
                            };
                            this.auditLog.log(log_payload);
                        }
                    });

                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                    this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'API already exists')).then(response => {
                    //     this.auditListenerService.auditListener.emit({
                    //         type: 'auditLog',
                    //         category: 'isAuditForBusinessLogic',
                    //         payload: response
                    //     });
                    // });
                    const log_payload = {
                        logType: 'ERROR',
                        logLevel: 0,
                        slugSearch: '',
                        label: this.eventLabelForAuditLog,
                        featureArea: this.platform.auditFeatureArea.businessLogic,
                        resource:  this.eventNameForAuditLog,
                        action: 'CLICK',
                        result: 'FAIL',
                        payload: {},
                        responseStatusCode: 400,
                        response: '',
                        errorMessage: 'API already exists',
                        logMessage: ''
                    };
                    this.auditLog.log(log_payload);
                }
            } else {
                // Promise.resolve(this.appComp.generatePayloadForAudit('ERROR', '0', this.router.url, this.eventLabelForAuditLog, this.platform.auditFeatureArea.businessLogic, this.eventLabelForAuditLog, this.eventNameForAuditLog, 'FAIL', '', 400, '', '', 'Invalid payload')).then(response => {
                //     this.auditListenerService.auditListener.emit({
                //         type: 'auditLog',
                //         category: 'isAuditForBusinessLogic',
                //         payload: response
                //     });
                // });
                const log_payload = {
                    logType: 'ERROR',
                    logLevel: 0,
                    slugSearch: '',
                    label: this.eventLabelForAuditLog,
                    featureArea: this.platform.auditFeatureArea.businessLogic,
                    resource:  this.eventNameForAuditLog,
                    action: 'CLICK',
                    result: 'FAIL',
                    payload: {},
                    responseStatusCode: 400,
                    response: '',
                    errorMessage: 'Invalid Payload',
                    logMessage: ''
                };
                this.auditLog.log(log_payload);
                if (this.executor_name === undefined || this.executor_name === '' || this.selectedVersion === undefined || this.selectedVersion === '' ||
                    this.executorCategory === undefined || this.executorCategory === '') {
                    this.platform.openSnackBar('Please enter all the required fields.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                } else if (this.selectedExecutor === undefined || this.selectedExecutor === '') {
                    this.platform.openSnackBar('Please select a valid executor method.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                }
                this.loading1 = false;
                this.closeNonWSDialogBox();

            }
        }
    }

    async generateExecutor(action, timeStamp, testMode = 'notests') {

        if (!this.websocketService.isOpen()) {
            this.showDialogOnNonWebsocketConnection = this.dialog.open(LoaderWithProgressComponent, {
                maxWidth: '95vw',
                maxHeight: '60vh',
                data: {
                    message: 'API deployment is under progress. Please don\'t close the window'
                }
            });
        }

        Promise.resolve(this.generateJsonForXml(this.workspace, false)).then((result: any) => {

            const JSON_Blocks = result.json;
            const xml_text = result.xml;

            Promise.resolve(this.validateBlocks(JSON_Blocks, timeStamp, action)).then(async (response: any) => {
                if (response.statements) {
                    const blockExecutors = response.statements;
                    const functions = response.functions;
                    this.requestBody = this.devexHeader.getRequestBody();

                    if (this.headers) {
                        for (let i = 0; i < this.headers.length; i++) {
                            if (this.headers[i]) {
                                if (this.headers[i]['key'] === '') {
                                    this.headers.splice(i, 1);
                                }
                            }
                        }
                        if (this.headers.filter(element => element.key === 'pkey').length === 0) {
                            this.headers.push({
                                key: 'pkey',
                                value: localStorage.getItem('partnerKey'),
                                description: ''
                            });
                        }
                        if (this.headers.filter(element => element.key === 'apikey').length === 0) {
                            this.headers.push({
                                key: 'apikey',
                                value: localStorage.getItem('apikey'),
                                description: ''
                            });
                        }
                    }

                    if (this.queryParams) {
                        for (let i = 0; i < this.queryParams.length; i++) {
                            if (this.queryParams[i]) {
                                if (this.queryParams[i]['key'] === '') {
                                    this.queryParams.splice(i, 1);
                                }
                            }
                        }
                    }
                    if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
                        for (let i = 0; i < this.requestBody['value'].length; i++) {
                            if (this.requestBody['value'][i]) {
                                if (this.requestBody['value'][i]['key'] === '') {
                                    this.requestBody['value'].splice(i, 1);
                                }
                            }
                        }
                    }

                    let requestBody = {};
                    if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                        requestBody = this.requestBody['__zone_symbol__value'];
                    } else {
                        requestBody = this.requestBody;
                    }

                    const fabResult = {
                        'executor_type': this.selectedExecutorType,
                        'executor_name': this.executor_name,
                        'executor_version': this.selectedVersion,
                        'executor_display_name': this.executor_display_name,
                        'executor_description': this.description,
                        'executor_category': this.executorCategory,
                        'executor_method_type': this.selectedExecutor,
                        'queryParams': this.queryParams,
                        'headers': this.headers,
                        'mockResponses': this.mockResponses,
                        'requestBody': requestBody,
                        'published': true,
                        'scopeOfAccess': this.scopeSelected,
                        'creationTime': Date.now(),
                        'lastModifiedTime': Date.now(),
                        'registeredAsIs': false,
                        'prerequisites': this.prerequisites,
                        'source': xml_text,
                        'executors': blockExecutors,
                        'functions': functions,
                        'partner': this.partner,
                        'account_id': this.account_id,
                        'apiUrl': this.gatewayFullUrl + '/' + this.selectedVersion + '/' + this.executor_name,
                        // 'apiUrl': environment.konghost + '/' + this.selectedVersion + '/' + this.partner + '/' + this.account + '/' + this.executor_name,
                        'dataroot': null,
                        'responseAttributes': null,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': this.attributeList,
                        'action': action,
                        'editFlag': this.editFlag,
                        'isDocumentationPublished': true,
                        'oldExecutor': this.backupExecutor,
                        'properties': this.properties ? this.properties : {}
                    };
                    this.setDevexPropertiesIntoModel(fabResult);

                    if (this.editFlag && this.orig_executor_name === this.executor_name && this.orig_executor_version === this.selectedVersion) {
                        if (fabResult['source'] === this.xml_content &&
                            this.platform.checkEqualStrings(fabResult['executor_display_name'], this.orig_executor['executor_display_name']) &&
                            this.platform.checkEqualStrings(fabResult['executor_description'], this.orig_executor['executor_description']) &&
                            this.platform.checkEqualStrings(fabResult['executor_category'], this.orig_executor['executor_category']) &&
                            this.platform.checkEqualStrings(fabResult['executor_category_group'], this.orig_executor['executor_category_group']) &&
                            this.platform.checkEqualStrings(fabResult['service_provider'], this.orig_executor['service_provider']) &&
                            this.platform.checkEqualStrings(fabResult['scopeOfAccess'], this.orig_executor['scopeOfAccess']) &&
                            this.platform.checkEqualStrings(fabResult['executor_method_type'], this.orig_executor['executor_method_type']) &&
                            this.platform.checkEqualStrings(fabResult['dataroot'], this.orig_executor['dataroot']) &&
                            this.platform.checkEquality(fabResult['prerequisites'], this.orig_executor['prerequisites']) &&
                            this.platform.checkEquality(fabResult['responseAttributes'], this.orig_executor['responseAttributes']) &&
                            this.platform.checkEquality(fabResult['response'], this.orig_executor['response']) &&
                            this.platform.checkEquality(fabResult['attributeMappings'], this.orig_executor['attributeMappings']) &&
                            this.platform.checkEquality(fabResult['block_attributes'], this.orig_executor['block_attributes']) &&
                            this.platform.checkEquality(fabResult['workflow_credentials'], this.orig_executor['workflow_credentials']) &&
                            this.platform.checkEquality(fabResult['pathParams'], this.orig_executor['pathParams']) &&
                            this.platform.checkEquality(fabResult['queryParams'], this.orig_executor['queryParams']) &&
                            this.platform.checkEquality(fabResult['headers'], this.orig_executor['headers']) &&
                            this.platform.checkEquality(fabResult['authModel'], this.orig_executor['authModel']) &&
                            this.platform.checkEquality(fabResult['requestBody'], this.orig_executor['requestBody'])) {
                            this.loading1 = false;
                            this.closeNonWSDialogBox();
                            this.platform.openSnackBar('No changes to save for this Business Logic API.', 'Error', {
                                duration: 10000,
                                verticalPosition: 'top',
                                horizontalPosition: 'center'
                            });
                        } else {
                            if (this.websocketService.isOpen()) {
                                this.logVisible = true;
                            }

                            if (!JSON_Blocks.block) {
                                if (confirm('Are you sure you want to deploy this API without any blocks ?')) {
                                    await this.apiCreator.createBusinessLogicApi(this.partner, this.account_id, [fabResult], timeStamp);
                                } else {
                                    this.platform.openSnackBar('The business logic is empty. Please add some blocks to deploy this logic as an API.', 'Error', {
                                        duration: 10000,
                                        verticalPosition: 'top',
                                        horizontalPosition: 'center'
                                    });
                                    this.loading1 = false;
                                    this.closeNonWSDialogBox();
                                }
                            } else {
                                await this.apiCreator.createBusinessLogicApi(this.partner, this.account_id, [fabResult], timeStamp, testMode);
                            }

                            this.orig_executor = fabResult;
                            this.xml_content = fabResult['source'];
                        }
                    } else {
                        if (this.websocketService.isOpen()) {
                            this.logVisible = true;
                        }
                        if (!JSON_Blocks.block) {
                            if (confirm('Are you sure you want to deploy this API without any blocks ?')) {
                                await this.apiCreator.createBusinessLogicApi(this.partner, this.account_id, [fabResult], timeStamp, testMode);
                            } else {
                                this.platform.openSnackBar('The business logic is empty. Please add some blocks to deploy this logic as an API.', 'Error', {
                                    duration: 10000,
                                    verticalPosition: 'top',
                                    horizontalPosition: 'center'
                                });
                                this.loading1 = false;
                                this.closeNonWSDialogBox();
                            }
                        } else {
                            await this.apiCreator.createBusinessLogicApi(this.partner, this.account_id, [fabResult], timeStamp, testMode);
                        }
                    }

                    this.isAPIAlreadyPresentCheckCompleted = false;
                    this.entityNameVersionAfterDeploy = true;
                } else {
                    this.loading1 = false;
                    this.closeNonWSDialogBox();
                }
            });
        }, error => {
            this.platform.openSnackBar(error, 'Error', {
                duration: 10000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
            this.loading1 = false;
            this.closeNonWSDialogBox();
        });

    }

    validateBlocks(JSON_Blocks, timeStamp, action) {
        return new Promise((resolve, reject) => {
            if (!JSON_Blocks.block) {
                this.blockExecutors = [];
                resolve({funtions: [], statements: []});
            } else {
                this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, JSON_Blocks).subscribe(async executors => {
                    this.blockExecutors = executors;
                    resolve(executors);
                }, error => {
                    this.loading1 = false;
                    // this.displaySnackBarWithWS('Error', 5000, 'No changes made in the API definition.');
                    this.closeNonWSDialogBox();
                    let errorMessage = '';
                    if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                        errorMessage = error.error.message;
                    } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                        errorMessage = error.error;
                    } else {
                        errorMessage = 'Error occurred while debugging your business logic API. Please try again after sometime.';
                    }
                    this.platform.openSnackBar(errorMessage, 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    resolve('failed');
                });
            }
        });
    }

    checkForExistingEntityAndExecutorFromFocusOut() {
        setTimeout(() => {
            this.checkForExistingEntityAndExecutor();
        }, 2000);
    }

    updateNameAndVersion() {
        this.devexHeader.nameVersionChangedInPath({
            name: this.executor_name,
            version: this.selectedVersion
        });
    }

    CheckForExistingEntityOrExecutor() {
        return new Promise((resolve, reject) => {
            Promise.resolve(this.platform.CheckForExistingEntityOrExecutor(this.executor_name, this.selectedVersion)).then(response => {
                this.isAPIAlreadyPresent = false;
                this.isAPIAlreadyPresentCheckCompleted = false;
                this.previouslyCheckedName = this.executor_name;
                this.previouslyCheckedVersion = this.selectedVersion;
                resolve('success');
            }, error => {
                if (error && error.status) {
                    if (error.status === 'already exists') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        this.platform.openSnackBar('An API with the provided name and version already exists.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    } else if (error.status === 'failed') {
                        this.isAPIAlreadyPresent = true;
                        this.isAPIAlreadyPresentCheckCompleted = false;
                        this.previouslyCheckedName = this.executor_name;
                        this.previouslyCheckedVersion = this.selectedVersion;
                        resolve('failed');
                        this.platform.openSnackBar('Error occurred while checking your existing API information. Please try again after sometime.', 'Error', {
                            duration: 10000,
                            verticalPosition: 'top',
                            horizontalPosition: 'center'
                        });
                    }
                }
            });
        });
    }

    checkForExistingEntityAndExecutor() {
        return new Promise(async (resolve, reject) => {
            if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '' && this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
                if (this.isAPIAlreadyPresentCheckCompleted === false) {
                    if (this.previouslyCheckedName !== undefined && this.previouslyCheckedName !== null && this.previouslyCheckedVersion !== undefined && this.previouslyCheckedVersion !== null) {
                        if (this.editFlag === true) {
                            if (this.executor_name !== this.orig_executor_name || this.selectedVersion !== this.orig_executor_version) {
                                if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion || this.entityNameVersionAfterDeploy) {
                                    this.isAPIAlreadyPresentCheckCompleted = true;
                                    this.entityNameVersionAfterDeploy = false;
                                    await this.CheckForExistingEntityOrExecutor();
                                    resolve('success');
                                } else {
                                    resolve('success');
                                }
                            } else {
                                resolve('success');
                            }
                        } else {
                            if (this.previouslyCheckedName !== this.executor_name || this.previouslyCheckedVersion !== this.selectedVersion || this.entityNameVersionAfterDeploy) {
                                this.isAPIAlreadyPresentCheckCompleted = true;
                                this.entityNameVersionAfterDeploy = false;
                                await this.CheckForExistingEntityOrExecutor();
                                resolve('success');
                            } else {
                                resolve('success');
                            }
                        }
                    } else {
                        this.isAPIAlreadyPresentCheckCompleted = true;
                        await this.CheckForExistingEntityOrExecutor();
                        resolve('success');
                    }
                } else {
                    resolve('success');
                }
            }
        });
    }

    toggleDebugger() {
        this.debugFlag = false;
        this.blocklyDivSize = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
    }

    getTitleForVariable(variable) {
        if (variable.executor_name !== null && variable.executor_name !== undefined) {
            if (variable.executor_version !== null && variable.executor_version !== undefined) {
                return variable.executor_name + '(' + variable.executor_version + ')';
            }
            return variable.executor_name;
        } else {
            return variable.name;
        }

    }

    getOriginalBlockDetails(id) {
        return this.blocksBeforeExecution.findIndex(value => value['id'] === id);
    }

    restoreBlocks() {
        if (!this.debugging) {
            this.blocksContainsLogColour = false;
            for (const val of this.blocksBeforeExecution) {
                const block = this.workspace.getBlockById(val.id);
                this.workspace.getBlockById(val.id);
                if (block) {
                    block.setColour(val.colour);
                }
            }
        }
    }

    resetDebuggerResults() {
        if (!this.debugging) {
            this.debugResults = '';
        }
    }

    getChildBlockIds(block, ids = []) {
        if (!ids.includes(block.id)) {
            ids.push(block.id);
        }
        if (block) {
            if (block.childBlocks_ && block.childBlocks_.length > 0) {
                for (const childBlock of block.childBlocks_) {
                    this.getChildBlockIds(childBlock, ids);
                }
            }
        }
        return ids;
    }

    setColourToParentAndChildBlocks(blockId, colour) {
        const ids = [];
        for (const val of this.blocksBeforeExecution) {
            ids.push(val.id);
        }

        const mainBlock = this.workspace.getBlockById(blockId);
        if (mainBlock) {
            for (const id of this.getChildBlockIds(mainBlock)) {
                let sourroundBlock = this.workspace.getBlockById(id).getSurroundParent();
                let stackParent = this.workspace.getBlockById(id);
                while (sourroundBlock) {
                    stackParent = sourroundBlock;
                    sourroundBlock = this.workspace.getBlockById(sourroundBlock.id).getSurroundParent();
                }
                if (stackParent.id === mainBlock.id) {
                    const block = this.workspace.getBlockById(id);
                    this.workspace.getBlockById(id);
                    if (block) {
                        block.setColour(colour);
                    }
                }
            }
        }
    }

    deleteNonRenderedBlocks(workspace) {
        if (workspace) {
            const blockObjects = workspace.getAllBlocks(true);
            for (const block of blockObjects) {
                if (!block.rendered) {
                    block.dispose();
                }
            }
        }
    }


    async executeLocally(executor, executorBlock) {
        return new Promise(async (resolve, reject) => {

            if (this.enableVisualDebugger) {
                this.workspace.highlightBlock(executorBlock.block_id);
            }
            await this._service.debugBusinessLogic(this.partner, this.account_id, executor).subscribe(response => {
                this.debugVariables = [];
                this.debugResults = response;
                var errorKey = '';
                if (this.debugResults) {
                    this.inputSet = this.debugResults.inputSet;
                    this.results = this.debugResults.results;
                    this.isError = this.debugResults.isError;
                    this.logText = this.debugResults.logText;

                    if (this.enableVisualDebugger) {
                        if (!this.isError) {
                            this.setColourToParentAndChildBlocks(executorBlock.block_id, '#02c50a');
                        }
                        if (this.isError) {
                            this.workspace.highlightBlock(null);
                            const mainBlock = this.workspace.getBlockById(executorBlock.block_id);
                            if (mainBlock) {
                                mainBlock.setColour('#e40303');
                            }
                            const errorBlock = this.workspace.getBlockById(this.debugResults.errorBlock);
                            if (errorBlock) {
                                errorBlock.setColour('#e40303');
                            }
                        }
                    }

                    if (this.isError && this.debugResults.errorStackTrace !== undefined && this.debugResults.errorStackTrace !== null) {
                        this.errorStackTrace = this.debugResults.errorStackTrace;
                    }
                    if (this.isError && this.debugResults.errorClass !== undefined && this.debugResults.errorClass !== null) {
                        this.errorClass = this.debugResults.errorClass;
                    }
                    if (this.isError && this.debugResults.errorMessage !== undefined && this.debugResults.errorMessage !== null) {
                        this.errorMessage = this.debugResults.errorMessage;
                    }
                    // const variableInput = {
                    //     'executor_type': executor.executor_type !== null ? executor.executor_type : '',
                    //     'executor_name': executor.executor_name !== null ? executor.executor_name : '',
                    //     'executor_version': executor.executor_version !== null ? executor.executor_version : '',
                    //     'executor_category': executor.executor_category !== null ? executor.executor_category : '',
                    //     'name': executor.executor_type + '-' + executor.executor_name + '(' + executor.executor_version + ')',
                    //     'message': JSON.stringify(this.logText)
                    // };
                    // this.debugVariables.push(variableInput);

                    const keys = Object.keys(this.results);
                    keys.forEach(key => {
                        const result = this.results[key];
                        const statusCode = result['statusCode'];
                        if (statusCode > 300) {
                            this.debugErrorFlag = true;
                            errorKey = key;
                            if (this.debugErrorFlag && result.body) {
                                this.errorMessage = result.body;
                            }
                        }
                        this.debugVariables.push({
                            'name': key,
                            'message': JSON.stringify(this.results[key]),
                            'responses': this.results[key]
                        });
                    });

                    if (!this.isError && !this.debugErrorFlag) {
                        this.debugResult = this.debugResult.concat(this.logText);
                        this.debugResult = this.debugResult.concat('<br/>');
                    } else {
                        this.debugResult = this.debugResult.concat(this.logText);
                        this.debugResult = this.debugResult.concat('<br/>');
                        // this.debugResult = this.debugResult.concat('<p style="color: red"><b>' + 'Error while executing the block: ' + errorKey + '</b></p>');
                        this.debugResult = this.debugResult.concat('<p style="color: red">' + this.errorMessage + '</p>');
                        if (this.errorStackTrace && this.errorStackTrace !== null && this.errorStackTrace !== undefined) {
                            this.debugResult = this.debugResult.concat(JSON.stringify(this.errorStackTrace));
                            this.debugResult = this.debugResult.concat('<br/>');
                        }
                    }
                    resolve(response);
                }


            }, error => {
                this.isError = true;
                this.setColourToParentAndChildBlocks(executorBlock.block_id, '#f97676');
                this.executeFlagLocally = false;
                const result = {
                    'executor_type': executor.executor_type !== null ? executor.executor_type : '',
                    'executor_name': executor.executor_name !== null ? executor.executor_name : '',
                    'executor_version': executor.executor_version !== null ? executor.executor_version : '',
                    'executor_category': executor.executor_category !== null ? executor.executor_category : '',
                    'name': 'response',
                    'timestamp': error.error.timestamp,
                    'status': error.error.status,
                    'error': error.error.error,
                    'message': '<p style="color: red">' + 'Code: ' + error.error.status + ' : Error: ' + error.error.error + ' : Message: ' + error.error.message + '</p>'
                };

                this.debugVariables.push(result);
                this.debugResult = this.debugResult.concat('<br/>');
                this.debugResult = this.debugResult.concat('Error while executing block:');
                this.debugResult = this.debugResult.concat('<br/>');
                // this.debugResult = this.debugResult.concat('<p style="color: red">' + 'Code: ' + error.error.status + ' : Error: ' + error.error.error + ' : Message: ' + error.error.message + '</p>');
                this.debugErrorFlag = true;
                resolve(result);
            });
        });
    }

    shouldIgnoreBlock(block) {
        if (block.type === 'procedures_defnoreturn' || block.type === 'procedures_defreturn') {
            // Block is a procedure block, ignore it and its descendants
            return true;
        }

        const parent = block.getParent();
        if (parent) {
            // Check if any of the parent blocks is a procedure block
            return this.shouldIgnoreBlock(parent);
        }

        return false;
    }

    generateExecutorForDebug() {
        this.restoreBlocks();
        this.debugErrorFlag = false;
        this.debugVariables = [];
        this.debugResult = '';

        this.inputSet = {};
        this.results = {};

        let methodType = 'GET';
        let executorName = 'test';
        let version = 'v1';
        if (this.selectedExecutor !== null && this.selectedExecutor !== undefined && this.selectedExecutor !== '') {
            methodType = this.selectedExecutor;
        }
        if (this.executor_name !== null && this.executor_name !== undefined && this.executor_name !== '') {
            executorName = this.executor_name;
        }
        if (this.selectedVersion !== null && this.selectedVersion !== undefined && this.selectedVersion !== '') {
            version = this.selectedVersion;
        }

        this.inputSet['platformAPIDetails'] = {
            methodType: methodType,
            name: executorName,
            type: 'BUSINESSLOGIC',
            version: version
        };

        let inputHeaders = {};
        let inputParameters = {};
        let inputRequestBody: any;
        inputRequestBody = {};
        this.requestBody = this.devexHeader.getRequestBody();
        if (this.headers && this.headers !== null && this.headers !== undefined) {
            for (let i = 0; i < this.headers.length; i++) {
                if (this.headers[i] && this.headers[i] !== null && this.headers[i] !== undefined) {
                    if (this.headers[i]['key'] === '') {
                        this.headers.splice(i, 1);
                    } else {
                        inputHeaders[this.headers[i].key.toLowerCase()] = this.headers[i]['value'];
                    }
                }
            }
        }
        if (this.queryParams && this.queryParams !== null && this.queryParams !== undefined) {
            for (let i = 0; i < this.queryParams.length; i++) {
                if (this.queryParams[i] && this.queryParams[i] !== null && this.queryParams[i] !== undefined) {
                    if (this.queryParams[i]['key'] === '') {
                        this.queryParams.splice(i, 1);
                    } else {
                        inputParameters[this.queryParams[i].key] = this.queryParams[i]['value'];
                    }
                }
            }
        }
        if (this.devexHeader.isCustomPath) {
            const pathParams = this.devexHeader.getCustomPathAsParams();
            if (pathParams && pathParams !== null && pathParams !== undefined) {
                for (let i = 0; i < pathParams.length; i++) {
                    if (pathParams[i] && pathParams[i] !== null && pathParams[i] !== undefined) {
                        if (pathParams[i]['key'] !== '') {
                            inputParameters[pathParams[i].key] = pathParams[i]['value'];
                        }
                    }
                }
            }
        }
        if (this.devexHeader.requestBodySelected && this.devexHeader.requestBodySelected !== 'raw' && this.devexHeader.requestBodySelected !== 'binary' && this.devexHeader.requestBodySelected !== 'none') {
            if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                this.requestBody = this.requestBody['__zone_symbol__value'];
            }
            const requestBodySelected = this.devexHeader.getRequestBodySelected();
            if (this.requestBody && this.requestBody !== null && this.requestBody !== undefined && this.requestBody['value']) {

                if (requestBodySelected === 'form-data') {
                    inputRequestBody = this.requestBody['value'];
                } else {
                    inputRequestBody = {};
                    for (let i = 0; i < this.requestBody['value'].length; i++) {
                        // let requestBody = {};
                        if (this.requestBody['value'] && this.requestBody['value'][i] && this.requestBody['value'][i] !== null && this.requestBody['value'][i] !== undefined) {
                            if (this.requestBody['value'][i]['key'] === '') {
                                this.requestBody['value'].splice(i, 1);
                            } else {
                                inputRequestBody[this.requestBody['value'][i].key] = this.requestBody['value'][i]['value'];
                            }
                        }
                    }
                }
                this.inputSet['Payload'] = inputRequestBody;
            }
        } else {
            // inputRequestBody[this.requestBody['key']] = this.requestBody['value'];
            if (this.requestBody.hasOwnProperty('__zone_symbol__value')) {
                this.requestBody = this.requestBody['__zone_symbol__value'];
            }
            if (this.requestBody && this.requestBody !== null && this.requestBody !== undefined && this.requestBody['value']) {
                this.inputSet['Payload'] = this.requestBody['value'];
            } else {
                this.inputSet['Payload'] = {};
            }
        }

        this.inputSet['headers'] = inputHeaders;
        this.inputSet['queryParams'] = inputParameters;

        return new Promise(async (resolve, reject) => {

            this.debugResult = 'Reading the blocks...';

            Promise.resolve(this.generateJsonForXml(this.workspace)).then((result: any) => {
                this.debugFlag = true;
                this.debugging = true;
                this.executeFlagLocally = true;
                if (this.debugFlag) {
                    this.blocklyDivSize = 'col-lg-9 col-md-9 col-sm-12 col-xs-12';
                } else {
                    this.blocklyDivSize = 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
                }

                this.debugResult = this.debugResult.concat('Done');
                this.debugResult = this.debugResult.concat('<br/>');
                this.debugResult = this.debugResult.concat('Generating executors for the blocks...');
                this.cfgSrv.getExecutorsForBlocks(this.partner, this.account_id, result.json).subscribe(async (executors) => {
                    let executorsResults: any;
                    executorsResults = executors;
                    if (executors) {
                        const functions = executorsResults.functions;
                        this.executorBlocks = executorsResults.statements;
                        this.debugResult = this.debugResult.concat('Done');
                        this.debugResult = this.debugResult.concat('<br/>');

                        this.isError = false;

                        const allBlocks = this.workspace.getAllBlocks(true);

                        const blockObjects = [];

                        for (let i = 0; i < allBlocks.length; i++) {
                            const block = allBlocks[i];
                            if (!this.shouldIgnoreBlock(block)) {
                                // Block and its ancestors are not procedure blocks, include it in the filtered list
                                blockObjects.push(block);
                            }
                        }

                        this.blocksBeforeExecution = [];
                        for (const block of blockObjects) {
                            this.blocksBeforeExecution.push({
                                id: block.id,
                                colour: block.colour_
                            });
                        }


                        if (this.enableVisualDebugger) {
                            for (const block of blockObjects) {
                                this.workspace.getBlockById(block.id).setColour('#9e9e9e');
                                this.blocksContainsLogColour = true;
                            }
                        }

                        for (const [i, executor] of this.executorBlocks.entries()) {
                            if (this.isError) {
                                this.debugging = false;
                                break;
                            }
                            const executorPayload = {
                                'parentWorkflow': '',
                                'inputSet': this.inputSet,
                                'results': this.results,
                                'statement': {
                                    functions: functions,
                                    statements: [executor]
                                },
                                'isDebug': this.enableDeepDebugLogs,
                            };
                            await this.executeLocally(executorPayload, executor);
                            if (this.executorBlocks.length - 1 === i) {
                                this.debugging = false;
                            }
                        }
                        this.workspace.highlightBlock(null);
                    } else {
                        this.debugging = false;
                        this.debugResult = this.debugResult.concat('<p style="color: red"> There is no block to run....</p>>');
                        this.debugResult = this.debugResult.concat('<br/>');

                    }
                    this.executeFlagLocally = false;


                }, error => {
                    this.debugging = false;
                    this.executeFlagLocally = false;
                    let errorMessage = '';
                    if (error && error.error && error.error.message && error.error.message !== null && error.error.message !== undefined && error.error.message !== '') {
                        errorMessage = error.error.message;
                    } else if (error && error.error && error.error !== undefined && error.error !== null && error.error !== '') {
                        errorMessage = error.error;
                    } else {
                        errorMessage = 'Error occurred while debugging your business logic API. Please try again after sometime.';
                    }
                    this.platform.openSnackBar(errorMessage, 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }, generationError => {
                this.loading1 = false;
                this.platform.openSnackBar(generationError, 'Error', {
                    duration: 10000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        });

    }

    generateJsonForXml(workspace, isTest = true) {
        return new Promise((resolve, reject) => {
            const xml = Blockly.Xml.workspaceToDom(workspace);

            const idsTobeRemoved = [];
            const blocks = xml.childNodes;
            blocks.forEach(blk => {
                if (blk.getAttribute('type') === 'json_object' ||
                    blk.getAttribute('type') === 'text' ||
                    blk.getAttribute('type') === 'basic_authentication' ||
                    blk.getAttribute('type') === 'digest_authentication' ||
                    blk.getAttribute('type') === 'connector' ||
                    blk.getAttribute('type') === 'api_key' ||
                    blk.getAttribute('type') === 'bearer_token' ||
                    blk.getAttribute('type') === 'aws' ||
                    blk.getAttribute('type') === 'oauth_1_0' ||
                    blk.getAttribute('type') === 'oauth_2_0') {
                    idsTobeRemoved.push(blk.getAttribute('id'));
                }
            });

            idsTobeRemoved.forEach(id => {
                const children = xml.childNodes;
                children.forEach(child => {
                    if (id === child.getAttribute('id')) {
                        xml.removeChild(child);
                    }
                });
            });

            const xml_text = Blockly.Xml.domToText(xml);
            const parser = new DOMParser();
            const xml1 = parser.parseFromString(xml_text, 'text/xml');
            const obj = this.ngxXml2jsonService.xmlToJson(xml1);

            if ((obj['xml'].block === undefined) && isTest) {
                reject('The business logic is empty. Please add some blocks to ' + (isTest ? 'test' : 'deploy') + ' this logic as an API');
            }

            const JSON_Blocks: BlockData = {block: {}, functions: []};
            let mainBlockFound = false;
            if (obj['xml'] && obj['xml'].block && obj['xml'].block.length > 1) {
                let index = 0;
                obj['xml'].block.forEach((block) => {
                    if (block['@attributes'].type !== 'text' &&
                        block['@attributes'].type !== 'json_object' &&
                        block['@attributes'].type !== 'basic_authentication' &&
                        block['@attributes'].type !== 'digest_authentication' &&
                        block['@attributes'].type !== 'connector' &&
                        block['@attributes'].type !== 'api_key' &&
                        block['@attributes'].type !== 'bearer_token' &&
                        block['@attributes'].type !== 'aws' &&
                        block['@attributes'].type !== 'oauth_1_0' &&
                        block['@attributes'].type !== 'oauth_2_0') {
                        if (block['@attributes'].type === 'procedures_defnoreturn' ||
                            block['@attributes'].type === 'procedures_defreturn') {
                            JSON_Blocks.functions.push((obj['xml'].block[index]));
                        } else {
                            if (!mainBlockFound) {
                                mainBlockFound = true;
                                JSON_Blocks.block = (obj['xml'].block[index]);
                            } else {
                                reject('Invalid definition: Multiple main definitions found.');
                            }
                        }
                    } else {
                        reject('Invalid block in main function: ' + block['@attributes'].type);
                    }
                    index++;
                });
            } else {
                mainBlockFound = true;
                JSON_Blocks.block = obj['xml'].block;
            }
            if (mainBlockFound) {
                resolve({json: JSON_Blocks, xml: xml_text});
            } else {
                reject('The business logic does not contain a main definition.');
            }

        });
    }

    handleBlocklyRightPanel(drawer, componentValue, forceClose = false) {
        let isComponentOpened = false;
        if (this.selectedRightPanelComponent.value === componentValue.value || forceClose) {
            drawer.toggle();
            this.selectedRightPanelComponent = {
                name: '',
                value: '',
                matIcon: '',
                title: ''
            };
        } else if (this.selectedRightPanelComponent.value === '') {
            drawer.toggle();
            this.selectedRightPanelComponent = componentValue;
            isComponentOpened = true;
        } else {
            this.selectedRightPanelComponent = componentValue;
            isComponentOpened = true;
        }

        if (isComponentOpened) {
            if (componentValue.value === 'docs-component') {
                if (this.blockDescriptions.length === 0) {
                    this.setBlocksDocumentation();
                }
            } else if (componentValue.value === 'accelerators-component') {
                if (this.acceleratorsList === null || this.acceleratorsList === undefined || this.acceleratorsList.length === 0) {
                    this.setAcceleratorsData();
                }
            }
        }
    }

    findExecutorAttibutes(category, executor) {
        let data: any = {};
        const that = this;
        try {
            const catIndex = this.blComponentDataService.myAPIsBlocksData.findIndex(c => c.category === category);
            const fdata = this.blComponentDataService.myAPIsBlocksData[catIndex].executors.findIndex(p => p && p.executor_type + '_' + p.executor_name + '_' + p.executor_version === executor.trim());

            data = this.blComponentDataService.myAPIsBlocksData[catIndex].executors[fdata];
        } catch {}

        if (data && data.responseAttributes) {
            data.responseAttributes.forEach((attr) => {
                if (attr !== 'undefined' || attr != null) {
                    that.getNodeAttributes(executor, attr);
                }
            });
            for (const item of that.firstOfBody) {
                if (item) {
                    that.attributeList.push(item);
                }
            }
            that.firstOfBody = [];
        }
        if (data && (!data.responseAttributes || (data.responseAttributes.length === 0)) ) {

            if (that.attributeList.findIndex(p => p[0] === executor + '>response') === -1) {
                that.attributeList.push([executor + '>response', executor + '>response']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.statusCode') === -1) {
                that.attributeList.push([executor + '>response.statusCode', executor + '>response.statusCode']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body') === -1) {
                that.attributeList.push([executor + '>response.body', executor + '>response.body']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body._isList') === -1) {
                that.attributeList.push([executor + '>response.body._isList', executor + '>response.body._isList']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.headers') === -1) {
                that.attributeList.push([executor + '>response.headers', executor + '>response.headers']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.name') === -1) {
                that.attributeList.push([executor + '>API.name', executor + '>API.name']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.version') === -1) {
                that.attributeList.push([executor + '>API.version', executor + '>API.version']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.methodType') === -1) {
                that.attributeList.push([executor + '>API.methodType', executor + '>API.methodType']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.type') === -1) {
                that.attributeList.push([executor + '>API.type', executor + '>API.type']);
            }
        }
        // console.log(that.attributeList, 'att');
    }
    findExecutorAttibutesforMyServiceProvider(category, executor) {
        let catIndex: any;
        let providerIndex: any;
        if (this.blComponentDataService.myServiceProviderAPIs) {
            this.blComponentDataService.myServiceProviderAPIs.forEach((provider) => {
                catIndex = provider.categories.findIndex(c => c.category === category);
            });
        }

        let data: any;
        let fdata: any;
        const that = this;

        if (this.blComponentDataService.myServiceProviderAPIs && this.blComponentDataService.myServiceProviderAPIs !== undefined && this.blComponentDataService.b2bServiceProviderAPIs !== null) {
            this.blComponentDataService.myServiceProviderAPIs.forEach((b2b) => {
                if (b2b && b2b !== null && b2b !== undefined && b2b.categories && b2b.categories !== null && b2b.categories !== undefined) {
                    b2b.categories.forEach((cat) => {
                        if (cat && cat.category && cat.category !== null && cat.category !== undefined) {
                            if (cat.category === category.category) {
                                fdata = cat['executors'].findIndex(p => p && p.executor_type + '_' + p.executor_name + '_' + p.executor_version === executor.trim());
                                data = cat['executors'][fdata];
                                if (data && data.responseAttributes && data.responseAttributes !== null && data.responseAttributes !== undefined) {
                                    data.responseAttributes.forEach((attr) => {
                                        if (attr !== 'undefined' || attr != null) {
                                            that.getNodeAttributes(executor, attr);
                                        }
                                    });
                                    for (const item of that.firstOfBody) {
                                        if (item) {
                                            that.attributeList.push(item);
                                        }
                                    }
                                    that.firstOfBody = [];
                                }
                            }
                        }
                    });
                }
            });
        }

        if (data && data.responseAttributes) {
            data.responseAttributes.forEach((attr) => {
                if (attr !== 'undefined' || attr != null) {
                    that.getNodeAttributes(executor, attr);
                }
            });
            for (const item of that.firstOfBody) {
                if (item) {
                    that.attributeList.push(item);
                }
            }
            that.firstOfBody = [];
        }
        if (data && (data.responseAttributes === null || data.responseAttributes === undefined || data.responseAttributes.length === 0)) {
            if (that.attributeList.findIndex(p => p[0] === executor + '>response') === -1) {
                that.attributeList.push([executor + '>response', executor + '>response']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.statusCode') === -1) {
                that.attributeList.push([executor + '>response.statusCode', executor + '>response.statusCode']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body') === -1) {
                that.attributeList.push([executor + '>response.body', executor + '>response.body']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body._isList') === -1) {
                that.attributeList.push([executor + '>response.body._isList', executor + '>response.body._isList']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.headers') === -1) {
                that.attributeList.push([executor + '>response.headers', executor + '>response.headers']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.name') === -1) {
                that.attributeList.push([executor + '>API.name', executor + '>API.name']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.version') === -1) {
                that.attributeList.push([executor + '>API.version', executor + '>API.version']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.methodType') === -1) {
                that.attributeList.push([executor + '>API.methodType', executor + '>API.methodType']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.type') === -1) {
                that.attributeList.push([executor + '>API.type', executor + '>API.type']);
            }
        }
    }

    findExecutorAttibutesforB2B(category, executor) {
        let catIndex: any;
        let providerIndex: any;
        if (this.blComponentDataService.b2bServiceProviderAPIs) {
            this.blComponentDataService.b2bServiceProviderAPIs.forEach((provider) => {
                catIndex = provider.categories.findIndex(c => c.category === category);
            });
        }

        let data: any;
        let fdata: any;
        const that = this;

        if (this.blComponentDataService.b2bServiceProviderAPIs && this.blComponentDataService.b2bServiceProviderAPIs !== undefined && this.blComponentDataService.b2bServiceProviderAPIs !== null) {
            this.blComponentDataService.b2bServiceProviderAPIs.forEach((b2b) => {
                if (b2b && b2b !== null && b2b !== undefined && b2b.categories && b2b.categories !== null && b2b.categories !== undefined) {
                    b2b.categories.forEach((cat) => {
                        if (cat && cat.category && cat.category !== null && cat.category !== undefined) {
                            if (cat.category === category.category) {
                                fdata = cat['executors'].findIndex(p => p && p.executor_type + '_' + p.executor_name + '_' + p.executor_version === executor.trim());
                                data = cat['executors'][fdata];
                                if (data && data.responseAttributes && data.responseAttributes !== null && data.responseAttributes !== undefined) {
                                    data.responseAttributes.forEach((attr) => {
                                        if (attr !== 'undefined' || attr != null) {
                                            that.getNodeAttributes(executor, attr);
                                        }
                                    });
                                    for (const item of that.firstOfBody) {
                                        if (item) {
                                            that.attributeList.push(item);
                                        }
                                    }
                                    that.firstOfBody = [];
                                }
                            }
                        }
                    });
                }
            });
        }

        if (data && data.responseAttributes) {
            data.responseAttributes.forEach((attr) => {
                if (attr !== 'undefined' || attr != null) {
                    that.getNodeAttributes(executor, attr);
                }
            });
            for (const item of that.firstOfBody) {
                if (item) {
                    that.attributeList.push(item);
                }
            }
            that.firstOfBody = [];
        }
        if (data && (data.responseAttributes === null || data.responseAttributes === undefined || data.responseAttributes.length === 0)) {
            if (that.attributeList.findIndex(p => p[0] === executor + '>response') === -1) {
                that.attributeList.push([executor + '>response', executor + '>response']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.statusCode') === -1) {
                that.attributeList.push([executor + '>response.statusCode', executor + '>response.statusCode']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body') === -1) {
                that.attributeList.push([executor + '>response.body', executor + '>response.body']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.body._isList') === -1) {
                that.attributeList.push([executor + '>response.body._isList', executor + '>response.body._isList']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>response.headers') === -1) {
                that.attributeList.push([executor + '>response.headers', executor + '>response.headers']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.name') === -1) {
                that.attributeList.push([executor + '>API.name', executor + '>API.name']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.version') === -1) {
                that.attributeList.push([executor + '>API.version', executor + '>API.version']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.methodType') === -1) {
                that.attributeList.push([executor + '>API.methodType', executor + '>API.methodType']);
            }
            if (that.attributeList.findIndex(p => p[0] === executor + '>API.type') === -1) {
                that.attributeList.push([executor + '>API.type', executor + '>API.type']);
            }
        }
    }

    getNodeAttributes(exName, data) {
        const that = this;
        if (that.attributeList.findIndex(p => p[0] === exName + '>response') === -1) {
            that.attributeList.push([exName + '>response', exName + '>response']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>response.statusCode') === -1) {
            that.attributeList.push([exName + '>response.statusCode', exName + '>response.statusCode']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>response.body') === -1) {
            that.attributeList.push([exName + '>response.body', exName + '>response.body']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>response.body._isList') === -1) {
            that.attributeList.push([exName + '>response.body._isList', exName + '>response.body._isList']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>response.headers') === -1) {
            that.attributeList.push([exName + '>response.headers', exName + '>response.headers']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>API.name') === -1) {
            that.attributeList.push([exName + '>API.name', exName + '>API.name']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>API.version') === -1) {
            that.attributeList.push([exName + '>API.version', exName + '>API.version']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>API.methodType') === -1) {
            that.attributeList.push([exName + '>API.methodType', exName + '>API.methodType']);
        }
        if (that.attributeList.findIndex(p => p[0] === exName + '>API.type') === -1) {
            that.attributeList.push([exName + '>API.type', exName + '>API.type']);
        }
        if (data.attributeName !== null) {
            if (data.subType == null || data.subType.length === 0) {
                const ind = that.attributeList.findIndex(p => p[0] === exName + '>' + data.attributeName);
                if (ind === -1) {
                    that.attributeList.push([exName + '>' + data.attributeName, exName + '>' + data.attributeName]);
                }
                const ind1 = that.attributeList.findIndex(p => p[0] === exName + '>response.body._first>' + data.attributeName);
                if (ind1 === -1) {
                    that.firstOfBody.push([exName + '>response.body._first>' + data.attributeName, exName + '>response.body._first>' + data.attributeName]);
                }
            } else {
                data.subType.forEach((sub) => {
                    if (data.subType == null || data.subType.length === 0) {
                        const ind = that.attributeList.findIndex(p => p[0] === exName + '>' + data.attributeName + '.' + sub.attributeName);
                        if (ind === -1) {
                            that.attributeList.push([exName + '>' + data.attributeName + '.' + sub.attributeName, exName + '>' + data.attributeName + '.' + sub.attributeName]);
                        }
                        const ind1 = that.attributeList.findIndex(p => p[0] === exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName);
                        if (ind1 === -1) {
                            that.firstOfBody.push([exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName, exName + '>response.body._first>' + data.attributeName + '.' + sub.attributeName]);
                        }
                    } else {
                        that.getLeafAttributes(exName + '>' + data.attributeName, sub);
                    }
                });
            }

        }
    }

    getLeafAttributes(parent, data) {
        const that = this;
        if (data.subType == null || data.subType.length === 0) {
            const ind = that.attributeList.findIndex(p => p[0] === parent + '.' + data.attributeName);
            if (ind === -1 && data.attributeName !== null) {
                that.attributeList.push([parent + '.' + data.attributeName, parent + '.' + data.attributeName]);
            }
        } else {
            data.subType.forEach((sub) => {
                if (data.subType == null || data.subType.length === 0) {
                    const ind = that.attributeList.findIndex(p => p[0] === parent + '.' + data.attributeName + '.' + sub.attributeName);
                    if (ind === -1 && sub.attributeName !== null) {
                        that.attributeList.push([parent + '.' + data.attributeName + '.' + sub.attributeName,
                            parent + '.' + data.attributeName + '.' + sub.attributeName]);
                    }
                } else {
                    that.getLeafAttributes(parent + '.' + data.attributeName, sub);
                }
            });
        }
    }

    displayFn(user?: ICategory): string | undefined {
        return user ? user.name : undefined;
    }

    toggleExecutor1(ev) {
        if (ev === 'DELETE') {
            if (this.isToggleExpanded === true) {
                this.isToggleExpanded = false;
                $('.executor-definition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        } else {
            if (this.isToggleExpanded === false) {
                this.isToggleExpanded = true;
                $('.executor-definition').slideToggle();
                $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
            }
        }
    }

    toggleExecutor(ev) {
        this.isToggleExpanded = !this.isToggleExpanded;
        $('.executor-definition').slideToggle();
        $(ev.target).toggleClass('fa-chevron-down fa-chevron-up');
    }


    setInterval(blockEnd, nextPanel) {
        this.destroy = setInterval(() => this.manageProgress(blockEnd, nextPanel), 1000);
    }

    ngOnDestroy() {
        clearInterval(this.destroy);
    }

    // async delay(ms: number) {
    //     return new Promise(resolve => setTimeout(resolve, ms));
    // }


    generateExecutorAgain() {
        window.location.reload();
    }

    addNewAPIBlock() {
        const isAPIRegistered = false;
        const dialogRef = this.dialog.open(AddAPIBlockComponent, {
            data: {isAPIRegistered: isAPIRegistered},
            height: '80%',
            width: '90%'
        });
        dialogRef.afterClosed().subscribe(resp => {
            if (resp) {
                if (resp.isAPIRegistered) {
                    this.renderBlockly('update', {myExecutors: true,
                        b2bExecutors: false,
                        alerts: false,
                        connectors: false,
                        triggers: false});
                }
            }
        });
    }

    requestAPIBlock() {
        const dialogRef = this.dialog.open(RequestBlockComponent, {
            data: {blocklyXMLToolbox: this.blocklyXMLToolbox},
            height: '70%',
            width: '52%'
        });
    }
    downloadCode(name, code) {
        const filename = name + '.py';
            saveAs(new Blob([code]), filename);
    }

    openGitHubDialog(partner, account, entityname, version, code) {
        const dialogRef = this.dialog.open(GithubConnectionBusinessComponent, {
            width: '70vh',
            data: {
                partner: partner,
                account: account,
                entityname: entityname,
                version: version,
                code: code,
                xml: this.xml_content
            }
        });
    }

    createMarginRight() {
        document.getElementById('view:businesslogic').style.marginRight = '400px';
    }

    removeMarginRight() {
        document.getElementById('view:businesslogic').style.marginRight = '0';
    }

    generateBlockWithSAIL(sail_code) {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this.cfgSrv.generateBlockForSAIL(this.partner, this.partnerKey, sail_code).subscribe(response => {
            let resp: any;
            resp = response;
            if (resp && resp.xml) {
                const xml = resp.xml;

                try {
                    this.updateAttributesFoundInSail(xml);
                    this.appendToDom('xml', xml, []);
                    loaderDialog.close();
                } catch (e) {
                    this.platform.openSnackBar('Unable to import the SAIL code as blocks: Invalid block generated.', 'Error', {
                        duration: 5000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    loaderDialog.close();
                }

            } else {
                this.platform.openSnackBar('Unable to import the SAIL code as blocks: Invalid block generated.', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                loaderDialog.close();
            }

        }, error => {
            this.platform.handleErrorGracefully(error, 'Unable to import the SAIL code as blocks: Invalid block generated.');
            loaderDialog.close();
        });
    }

    updateAttributesFoundInSail(blockText) {
        const xmlDom = Blockly.utils.xml.textToDom(blockText);
        const blockNodes = xmlDom.getElementsByTagName('block');
        for (const node of blockNodes) {
            if (node.getAttribute('type') === 'attributes') {
                const fieldValue = node.childNodes[0].childNodes[0].nodeValue;
                if (fieldValue.startsWith('Parameter.')) {
                    if (this.queryParams.filter(element => element.key === fieldValue.substring(10)).length === 0) {
                        this.queryParams.push({
                            key: fieldValue.substring(10),
                            value: null,
                            description: null
                        });
                    }
                } else if (fieldValue.startsWith('Header.')) {
                    if (this.headers.filter(element => element.key === fieldValue.substring(7)).length === 0) {
                        this.headers.push({
                            key: fieldValue.substring(7),
                            value: null,
                            description: null
                        });
                    }
                } else {
                    if (this.attributeList.findIndex(p => p[0] === fieldValue) === -1) {
                        this.attributeList.push([fieldValue, fieldValue]);
                    }
                }
                this.updateAttributes();
            }
        }
    }

}

@Component({
    selector: 'github-connection-business-dialog',
    templateUrl: 'github-connection-business.html',
    styleUrls: ['github-connection-business.css'],
})

export class GithubConnectionBusinessComponent implements OnInit {
    accessToken = '';
    github_handle = '';
    github_repo = [];
    github_branches = [];
    isConnected = false;
    selectedRepo = '';
    selectedBranch = '';
    isEdit = false;
    id: any;
    selectedCode = '';
    codes = ['Python', 'XML'];
    path = '';
    repoPath = '';
    filePath = '';
    fileName = '';
    isCommitted: boolean;
    committedFilePath = '';
    committedRepoPath = '';
    committedBranch = '';
    committedPath = '';
    committedSha = '';
    committedFileName = '';
    incorrectToken = false;
    defaultPath = '';
    author = '';
    committedDate = '';
    commitPath = '';
    isRedeployed = false;
    executorData: any;
    newRepo = '';
    commitMessage = '';


    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<GithubConnectionBusinessComponent>, public confPost: ConfService) {
        const queryParam = 'account=' + this.data['account'] + '&partner=' + this.data['partner'] + '&entity_name=' + this.data['entityname'] + '&version=' + this.data['version'];
        this.confPost.getData('services', 'services', 'v1', 'githubCommits', queryParam).subscribe(res => {
            if (res && res !== undefined && res !== null) {
                const temp: any = res;
                if (temp.length > 0) {
                    this.isCommitted = true;
                    const latestCommitDate = new Date(Math.max.apply(null, temp.map(function (e) {
                        return new Date(e.commit_date);
                    })));
                    for (const item of temp) {
                        if (String(new Date(item['commit_date'])) === String(latestCommitDate)) {
                            this.committedFilePath = item['file_path'];
                            this.author = item['author'];
                            this.committedDate = item['commit_date'];
                            this.commitPath = item['commit_path'];
                            this.defaultPath = item['repository_path'] + '/';
                            this.committedRepoPath = item['repository_path'];
                            this.committedPath = item['path'];
                            this.selectedBranch = item['branch'];
                            this.selectedCode = item['code'];
                            this.path = item['path'];
                            this.selectedRepo = item['repository_path'].split('/')[1];
                            this.committedSha = item['sha'];
                            this.committedFileName = item['file_name'];
                            const committedAttributes = item['attributes'];
                            this.commitMessage = item['commit_message'];
                            if (this.selectedCode === 'Python') {
                                if (committedAttributes !== JSON.stringify(this.data['code'])) {
                                    this.isRedeployed = true;
                                }
                            }
                            if (this.selectedCode === 'XML') {
                                if (committedAttributes !== JSON.stringify(this.data['xml'])) {
                                    this.isRedeployed = true;
                                }
                            }
                        }
                    }
                } else {
                    this.isCommitted = false;
                }
            } else {
                this.isCommitted = false;
            }
        }, error => {
            this.isCommitted = false;
        });
    }

    ngOnInit() {
    }

    createRepository() {
        const payload = {
            'name': this.newRepo
        };
        this.confPost.createGitRepo(this.accessToken, payload).subscribe(res => {
            if (res) {

                this.platform.openSnackBar('GitHub repository created.', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    this.github_repo = [];
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.selectedRepo = this.newRepo;
                    this.newRepo = '';
                    // this.onChangeRepo(this.newRepo);
                    this.github_branches = ['main'];
                    this.repoPath = this.github_handle + '/' + this.selectedRepo;
                    this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';
                });
            }
        }, err1 => {
            this.platform.openSnackBar('Failed to create new repository, Please try again.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });
    }

    generateAccessToken() {
        window.open('https://github.com/settings/tokens', '_blank').focus();
    }

    submitAccessToken() {
        this.confPost.getGitUser(this.accessToken).subscribe(res => {
            if (res && res['login'].length > 0) {
                this.github_handle = res['login'];
                if (!this.isRedeployed) {
                    this.defaultPath = this.github_handle + '/';
                }
                this.confPost.getGitUserRepo(this.accessToken).subscribe(res1 => {
                    let temp: any = res1;
                    if (res1) {
                        for (let i = 0; i < temp.length; i++) {
                            if (temp[i]['owner']['login'] === this.github_handle) {
                                this.github_repo.push(temp[i]['name']);
                            }
                        }
                    }
                    this.isConnected = true;
                    this.incorrectToken = false;
                });
            }
        }, error => {
            this.isConnected = false;
            this.incorrectToken = true;
        });

    }

    onChangeRepo(repo) {
        this.github_branches = [];
        this.confPost.getGitUserBranch(this.accessToken, this.github_handle, repo).subscribe(res1 => {
            let temp: any = res1;
            if (res1) {
                for (let i = 0; i < temp.length; i++) {
                    this.github_branches.push(temp[i]['name']);
                }
            }
            if (this.github_branches.length === 0) {
                this, this.github_branches.push('main');
            }
        });
        this.repoPath = this.github_handle + '/' + this.selectedRepo;
        this.defaultPath = this.github_handle + '/' + this.selectedRepo + '/';
    }

    commitToGitHub() {
        let content = '';
        if (this.selectedCode === 'Python') {
            this.fileName = this.data['entityname'] + '.py';
            content = this.data['code'];
        }
        if (this.selectedCode === 'XML') {
            this.fileName = this.data['entityname'] + '.xml';
            content = this.data['xml'];
        }
        this.filePath = this.path;
        if (this.filePath === '') {
            this.filePath = this.fileName;
        } else if (this.filePath !== '' && this.filePath.slice(-1) === '/') {
            this.filePath = this.filePath + this.fileName;
        } else {
            this.filePath = this.filePath + '/' + this.fileName;
        }

        if (!this.isRedeployed) {
            this.confPost.commitToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.repoPath, this.filePath, this.fileName, btoa(content), this.commitMessage).subscribe(res => {
                this.isCommitted = true;
                this.committedFilePath = res['content']['html_url'];
                const payload = {
                    'account': this.data['account'],
                    'partner': this.data['partner'],
                    'entity_name': this.data['entityname'],
                    'version': this.data['version'],
                    'file_path': this.committedFilePath,
                    'commit_path': res['commit']['html_url'],
                    'author': res['commit']['author']['email'],
                    'commit_date': res['commit']['author']['date'],
                    'sha': res['content']['sha'],
                    'attributes': JSON.stringify(content),
                    'repository_path': this.repoPath,
                    'branch': this.selectedBranch,
                    'path': this.filePath,
                    'file_name': this.fileName,
                    'code': this.selectedCode,
                    'commit_message': this.commitMessage
                };
                this.author = res['commit']['author']['email'];
                this.committedDate = res['commit']['author']['date'];
                this.commitPath = res['commit']['html_url'];

                this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                });
            }, err => {
                this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        } else {
            this.confPost.mergeToGitHub(this.data['account'], this.accessToken, this.selectedBranch, this.committedRepoPath, this.committedPath, this.committedFileName, btoa(content), this.committedSha, this.commitMessage).subscribe(res => {
                this.isCommitted = true;
                this.isRedeployed = false;
                this.committedFilePath = res['content']['html_url'];
                const payload = {
                    'account': this.data['account'],
                    'partner': this.data['partner'],
                    'entity_name': this.data['entityname'],
                    'version': this.data['version'],
                    'file_path': res['content']['html_url'],
                    'commit_path': res['commit']['html_url'],
                    'author': res['commit']['author']['email'],
                    'commit_date': res['commit']['author']['date'],
                    'sha': res['content']['sha'],
                    'attributes': JSON.stringify(content),
                    'repository_path': this.committedRepoPath,
                    'branch': this.selectedBranch,
                    'path': this.committedPath,
                    'file_name': this.fileName,
                    'code': this.selectedCode,
                    'commit_message': this.commitMessage
                };
                this.author = res['commit']['author']['email'];
                this.committedDate = res['commit']['author']['date'];
                this.commitPath = res['commit']['html_url'];

                this.confPost.addItemServices('v1', 'githubCommits', payload).subscribe(res => {
                });
            }, err => {
                this.platform.openSnackBar('Commit Failed. Please try again with different file path ', 'Error', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            });
        }


    }

    commitAgain() {
        this.isCommitted = false;
    }

    copyMessage(val) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        // selBox.value = $(val).text();
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.platform.openSnackBar('Copied to clipboard.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }


    close() {
        this.dialogRef.close();
    }
}

@Component({
    selector: 'app-add-api-block',
    templateUrl: './add-api-block.html',
    styleUrls: ['./new-blockly.component.css']
})
export class AddAPIBlockComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<AddAPIBlockComponent>, private kong: KongService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {

    }

    onRegisteringAPI() {
        this.data.isAPIRegistered = true;
        this.close();
    }

    close() {
        this.dialogRef.close(this.data);
    }
}

@Component({
    selector: 'app-request-block',
    templateUrl: './request-block.html',
    styleUrls: ['./new-blockly.component.css']
})
export class RequestBlockComponent implements OnInit {


    categoryType = 'add';
    blockCategories: any;
    parentCategories = [];
    title: any;
    summary: any;
    description: any;
    selectedParentCategory: any;
    selectedSubCategory: any;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    signInEmail = localStorage.getItem('signInEmail');
    loading = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<RequestBlockComponent>, public confPost: ConfService, public emailTemplateInstance: EmailtemplateService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() {
        this.getBlockCategories();
    }

    getBlockCategories() {
        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString(this.data.blocklyXMLToolbox, 'text/xml');
        // const xmlBlocks = xmlDoc.getElementsByTagName('block');
        const xmlCategories = xmlDoc.getElementsByTagName('category');
        this.blockCategories = {};
        for (let i = 0; i < xmlCategories.length; i++) {
            const parentCategory = xmlCategories[i].getAttribute('name');
            if (xmlCategories[i].children && xmlCategories[i].children.length && xmlCategories[i].children[0].tagName === 'category') {
                this.blockCategories[parentCategory] = [];
                for (let j = 0; j < xmlCategories[i].children.length; j++) {
                    this.blockCategories[parentCategory].push(xmlCategories[i].children[j].getAttribute('name'));
                }
            }
        }
        this.parentCategories = Object.keys(this.blockCategories);
    }

    categoryTypeChanged() {
        this.selectedParentCategory = '';
        this.selectedSubCategory = '';
    }

    submit() {
        if (this.title && this.title !== '' && this.summary && this.summary !== '' && this.description && this.description !== '' && this.selectedParentCategory && this.selectedParentCategory !== '' && this.selectedSubCategory && this.selectedSubCategory !== '') {
            this.loading = true;
            let categoryType = '';
            switch (this.categoryType) {
                case 'add':
                    categoryType = 'Add to existing category';
                    break;
                case 'createSub':
                    categoryType = 'Create a sub category';
                    break;
                case 'create':
                    categoryType = 'Create a new category';
                    break;
            }

            this.emailTemplateInstance.newBlockRequest.to.value[0].title = this.title;
            this.emailTemplateInstance.newBlockRequest.to.value[0].summary = this.summary;
            this.emailTemplateInstance.newBlockRequest.to.value[0].description = this.description;
            this.emailTemplateInstance.newBlockRequest.to.value[0].addTo = categoryType;
            this.emailTemplateInstance.newBlockRequest.to.value[0].category = this.selectedParentCategory;
            this.emailTemplateInstance.newBlockRequest.to.value[0].subCategory = this.selectedSubCategory;
            this.emailTemplateInstance.newBlockRequest.to.value[0].partner = this.partner;
            this.emailTemplateInstance.newBlockRequest.to.value[0].account = this.account;
            this.emailTemplateInstance.newBlockRequest.to.value[0].partnerEmail = this.signInEmail;

            this.confPost.executeEmail(this.emailTemplateInstance.newBlockRequest).subscribe(response => {
                this.loading = false;
                this.close();
                this.platform.openSnackBar('Your request has been sent  ', 'Success', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }, error => {
                this.loading = false;
                this.platform.handleErrorGracefully(error, 'Error while sending your request. Please try again after sometime.');
            });
            // const email = "<!DOCTYPE html> <head> <meta charset="utf-8"> <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"> <meta name="description" content=""> <meta name="author" content=""> <link rel="icon" href="../../../../favicon.ico"> <title>apiplatform.io</title> <!-- Bootstrap core CSS --> <link href="https://services.apiplatform.io.s3.amazonaws.com/services-services-userVerification-v1-editor.css" rel="stylesheet"><!-- Custom styles for this template --><link href="https://services.apiplatform.io.s3.amazonaws.com/services-services-userVerification-v1-narrow-jumbotron.css" rel="stylesheet"><style></style></head><body><div class="container"><div class="header clearfix"><nav></nav><h3 class="text-muted" contenteditable="true" spellcheckker="false" style="font-weight: 700;"></h3></div><div class="jumbotron"><h3 style="font-size: 25px;text-align: left">Hello,</h3><span>Title: {{title}}</span><br><span>Summary: {{summary}}</span><br><span>Description: {{description}}</span><br><span>Add To: {{addTo}}</span><br><span>Category: {{category}}</span><br><span>Sub Category: {{subCategory}}</span><br><span>Partner: {{partner}}</span><br><span>Account: {{account}}</span><br><span>Email: {{email}}</span><br><p style="text-align: left">Cheers<br>Team apiplatform.io</p></div><footer class="footer"></footer></div></body></html>"
        } else {
            this.platform.openSnackBar('Please fill all required fields', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }
    }

    close() {
        this.dialogRef.close(this.data);
    }
}

@Component({
    selector: 'api-dependency-check',
    templateUrl: 'api-dependency-check.component.html',
    styleUrls: ['api-dependency-check.component.css']
})
export class DependencyCheckComponent implements OnInit {

    @Input() executors: any;
    mode = 'alltests';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<DependencyCheckComponent>) {
        if (data && data.executors) {
            this.executors = data.executors;
        }
    }

    ngOnInit() {
    }

    changeMode(e) {
        this.mode = e;
    }

    proceed() {
        this.dialogRef.close({continue: true, mode: this.mode});
    }

    close() {
        this.dialogRef.close({continue: false});
    }

}


@Component({
    selector: 'core-check',
    templateUrl: 'core-check.html',
    styleUrls: ['api-dependency-check.component.css']
})
export class CoreCheckComponent implements OnInit {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<CoreCheckComponent>) {
    }

    ngOnInit() {
    }

    proceedWithUpsert() {
        this.dialogRef.close({continue: true, mode: 'upsert'});
    }

    proceedWithOld() {
        this.dialogRef.close({continue: true, mode: 'old'});
    }

    close() {
        this.dialogRef.close({continue: false});
    }

}

@Component({
    selector: 'blockly-first-row-buttons',
    templateUrl: 'blockly-first-row-buttons.component.html',
    styleUrls: ['blockly-first-row-buttons.component.css']
})
export class BlocklyAddButtonsComponent implements OnInit {
    autoSuggest: boolean;
    constructor(public blocklsRefreshService: BlocklyHeaderButtonsService) {

    }

    ngOnInit() {
        this.blocklsRefreshService.initAutoSuggest();
        this.autoSuggest = this.blocklsRefreshService.predicativeAutoSuggest;
    }

    updateAutoSuggest() {
        this.blocklsRefreshService.updateAutoSuggest(this.autoSuggest);
    }

    clickedButton(button) {
        this.blocklsRefreshService.refreshListener.emit({clickedButton: button})
    }
}
